import React, { useEffect, useMemo, useRef, useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import ErrorIcon from "@mui/icons-material/Error";
import {
  Box,
  Dialog,
  DialogActions,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Popover,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import Sidebar from "../comman/Sidebar";
import Navbar from "../comman/Navbar";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AttachmentRed from "../../images/attachment-red.svg";
import AttachmentGreen from "../../images/attachment-green.svg";
import Download from "../../images/Download.svg";
import Print from "../../images/Print.svg";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import {
  CircleGreenFillIcon,
  CircleGreenIcon,
  CircleIcon,
  DownloadIcon,
} from "../../images/SvgIcons";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import {
  ATTACH_DETACH_INVOICE_URL,
  DELETE_INVOICE_ATTATCHMENTS,
  DELETE_INVOICE_LINE_ITEM_URL,
  GET_ATTACH_URL,
  GET_CUSTOMER_BY_ID_URL,
  GET_DAY_AND_MILEAGE_RATE_URL,
  GET_INVOICE_ATTATCHMENT_LIST_URL,
  GET_INVOICE_DETAILS_BY_ID,
  GET_INVOICE_SELECTED_PERIOD_URL,
  GET_PROJECTS_ID,
  UPDATE_DAY_AND_MILEAGE_RATE_INVOICE_URL,
  UPDATE_INVOICE_BILLING_ADDRESS,
  UPDATE_INVOICE_STATUS_URL,
  UPSERT_INVOICE_DETAILS_URL,
  UPSERT_INVOICE_STATEMENT_URL,
  GET_PROJECT_DETAILS_BY_ID_URL,
  SYSTEM_LOG_INSERT_URL,
  GET_ALL_BROKERS,
  GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
  GET_ATTACH_NEW_STATEMENT_INVOICE_URL,
} from "../../constants/ApiRoute";
import {
  authHeader,
  getLogUserId,
  getLogUserName,
} from "../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import API from "../comman/API";
import { useToast } from "../comman/CustomMessages";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllStatesList,
  getAlluserList,
  getPerDiemList,
} from "../../redux/action";
import DetachConfirmation from "./DetachConfirmation";
import CircleGreenIconSvg from "../../images/Nodes-green-circle.svg";
import AttachConfirmation from "./AttachConfirmation";
import InvoiceAttachment from "../model/InvoiceAttachment";
import { INVOICE_LIST, PAGE_NOT_FOUND_PATH } from "../../constants/RoutePath";
import axios from "axios";
import sampleimg from "../../images/myw3schoolsimage.jpg";
import { select } from "underscore";
import { useLocation, useNavigate, useParams } from "react-router";
import CustomPageLoading from "../comman/CustomPageLoading";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import JSZip from "jszip";
import { useTheme } from "@emotion/react";
import { yellow } from "@mui/material/colors";
dayjs.extend(isSameOrAfter);
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import PrintInvoiceModel from "../model/PrintInvoiceModel";
import {
  getLineDayRateOptions,
  getLineRatePayload,
  getInvoiceSelectionRate,
  getPersistedSelectedDayRate,
  getSelectedRateFields,
  formatRateValue,
  isEnabledRateFlag,
  resolveNewLineItemDayRate,
  resolveExistingLineItemDayRate,
  buildNewLineItemRatePayload,
  buildExistingLineItemRatePayload,
} from "./dayRateUtils";

dayjs.extend(utc);
dayjs.extend(timezone);
const today = dayjs();
const yesterday = dayjs().subtract(1, "day");
const todayStartOfTheDay = today.startOf("day");
const steps = [
  "Statement Open",
  "Statement Closed",
  "Invoice Started",
  "Invoice Closed",
];
const billTypeList = [
  { id: 1, name: "Abstract" },
  { id: 2, name: "Mineral" },
  { id: 3, name: "Tract" },
  { id: 4, name: "Cursory Title" },
  { id: 5, name: "Due Dilligence" },
  { id: 6, name: "Area Checks" },
  { id: 7, name: "Curative" },
  { id: 8, name: "Other" },
];
const DAY_RATE_OPTIONS = [
  "Billable Rate",
  "Principal Rate",
  "Project Manager Rate",
  "Field Agent Rate",
];
const getDayRateForSelection = (
  selection,
  rates,
  fallback = 0,
  preferSelectedRate = false
) => {
  const sourceBySelection = {
    "Billable Rate": [
      "InvDayRate",
      "InvoiceDayRate",
      "default",
      "billingDayRate",
      "billableDayRate",
    ],
    "Principal Rate": [
      ...(preferSelectedRate ? ["SelectedPrincipalRate", "selectedPrincipalRate"] : []),
      "principalRate",
      "PrincipalRate",
    ],
    "Project Manager Rate": [
      ...(preferSelectedRate ? ["SelectedProjectManagerRate", "selectedProjectManagerRate"] : []),
      "projectManagerRate",
      "ProjectManagerRate",
    ],
    "Field Agent Rate": [
      ...(preferSelectedRate ? ["SelectedFieldAgentRate", "selectedFieldAgentRate"] : []),
      "fieldAgentRate",
      "FieldAgentRate",
    ],
  };
  const source =
    sourceBySelection[selection] || sourceBySelection["Billable Rate"];
  const value = source.map((key) => rates?.[key]).find((item) =>
    item !== null &&
    item !== undefined &&
    item !== "" &&
    Number.isFinite(Number(item))
  );
  return value === undefined ? fallback : value;
};
const formatPopulatedDayRate = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isFinite(Number(value))
    ? Number(value).toFixed(2)
    : value;
const getAllSelectedRateFields = (source = {}, selection, selectedRate) => ({
  selectedPrincipalRate: formatRateValue(
    source.selectedPrincipalRate ?? source.SelectedPrincipalRate ?? 0
  ),
  selectedProjectManagerRate: formatRateValue(
    source.selectedProjectManagerRate ?? source.SelectedProjectManagerRate ?? 0
  ),
  selectedFieldAgentRate: formatRateValue(
    source.selectedFieldAgentRate ?? source.SelectedFieldAgentRate ?? 0
  ),
  ...getSelectedRateFields(selection, selectedRate),
});
const getInvoiceLineChargeTotal = (
  lineItems = [],
  invoiceRates = {},
  overrideSelection,
  overrideRate
) =>
  (Array.isArray(lineItems) ? lineItems : []).reduce((total, item) => {
    const selection = normalizeSelectedDayRate(
      item?.selectedDayRate ??
        item?.SelectedDayRate ??
        item?.InvSelectedDayRate
    );
    const rate =
      normalizeSelectedDayRate(overrideSelection) === selection &&
      overrideRate !== undefined
        ? overrideRate
        : getInvoiceSelectionRate(selection, invoiceRates, {}, 0);
    const hours = Number(item?.Hours ?? item?.hours ?? 0);
    const numericRate = Number(rate);

    return total +
      (Number.isFinite(hours) && Number.isFinite(numericRate)
        ? (hours / 8) * numericRate
        : 0);
  }, 0);
const normalizeSelectedDayRate = (selection) => {
  if (selection === "Default") return "Billable Rate";
  return DAY_RATE_OPTIONS.includes(selection) ? selection : "Billable Rate";
};
const getInvoiceLineChargeBreakdown = (lineItems = [], invoiceRates = {}) => {
  const grouped = new Map();

  (Array.isArray(lineItems) ? lineItems : []).forEach((item) => {
    const selection = normalizeSelectedDayRate(
      item?.selectedDayRate ??
        item?.SelectedDayRate ??
        item?.InvSelectedDayRate
    );
    const hours = Number(item?.Hours ?? item?.hours ?? 0);
    if (!Number.isFinite(hours)) return;

    grouped.set(selection, (grouped.get(selection) || 0) + hours);
  });

  return DAY_RATE_OPTIONS.filter((selection) => grouped.has(selection)).map(
    (selection) => {
      const hours = grouped.get(selection);
      const rate = Number(getInvoiceSelectionRate(selection, invoiceRates, {}, 0));
      const billableDays = hours / 8;

      return {
        selection,
        label: selection.replace(" Rate", " day rate"),
        hours,
        billableDays,
        rate: Number.isFinite(rate) ? rate : 0,
        charge: Number.isFinite(rate) ? billableDays * rate : 0,
      };
    }
  );
};
const initialValues = {
  street1: "",
  street2: "",
  city: "",
  state: "",
  zipcode: "",
  invoiceDate: dayjs.utc(),
  createDate: dayjs.utc(),
  invoiceNo: "",
  invoiceTotal: "",
  projectName: "",
  startDate: "",
  endDate: "",
  brokerName: "",
  totalPerDiem: "0",
  totalExpenses: "",
  totalMileage: "",
  totalCharges: "",
  totalLodging: "",
  totalCopies: "",
  totalMisc: "",
  totalHours: "0",
  dayRate: "0",
  mileageRate: "",
  totalMiles: "0",
  perMile: "1",
  ProjectID: "",
  CustomerID: "",
  date: "",
  brokerId: "",
  billingType: "",
  selectedDayRate: "Billable Rate",
};
const initialLineItem = {
  invoiceDetailsId: "",
  invoiceHeaderId: "",
  billingHeaderId: "",
  billingDetailId: "",
  brokerId: "",
  billingType: "",
  dayRate: "",
  selectedDayRate: "Billable Rate",
  hours: "0.00",
  miles: "0",
  lodging: "0.00",
  description: "",
  perDiem: "0.00",
  copies: "0.00",
  misc: "0.00",
  perDiemRate: "0.00",
  // date: moment(new Date()).format("MM/DD/YYYY"),
  date: null, // Initially empty
  CustomerName: "",
};
const initialArrayOfLines = {
  brokerId: "",
  brokerName: "",
  hours: "",
  lastModify: "",
  status: "",
  total: "",
  billingType: "",
};
export default function IvoiceForm() {
  const theme = useTheme();
  const pathname = window.location.pathname;
  const location = useLocation();

  // Get the full pathname (e.g., '/invoice-form/10449')
  const fullPath = location.pathname;

  // Split the pathname to get 'invoice-form'
  const pathSegments = fullPath.split("/");

  // Get the second segment of the path (invoice-form)
  const currentPathSegment = pathSegments[1];

  console.log(currentPathSegment, "currentPathSegmentcurrentPathSegment");
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { id } = useParams();
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const gridRefDay = useRef(null);
  const parts = pathname.split("/");
  const lastPart = parts[parts.length - 1];
  let invoiceid = isNaN(lastPart) ? null : lastPart;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const [activeStep, setActiveStep] = React.useState(2);
  console.log(activeStep, "activeStepeeeee", invoiceid);
  const [completed, setCompleted] = React.useState({});
  const [LineItemArr, setLineItemArr] = React.useState({});
  const [LineItemArrIni, setLineItemArrIni] = React.useState({});
  const [invoiceStatus, setInvoiceStatus] = useState(false);
  const [detachOpen, setDetachOpen] = useState(false);
  const [AtachOpen, setAttachOpen] = useState(false);
  const [attachDettachLoading, setAttachDettachLoading] = useState(false);
  const [isAttach, setIsAttach] = useState(false);
  const [bname, setBname] = useState();
  const [projname, setPrpjName] = useState();
  const [overAllInvoiceTotal, setOverAllInvoiceTotal] = useState(0);
  const userListSel = deCryptFun(useSelector((s) => s.AllUserReducer));
  const stateList = deCryptFun(useSelector((s) => s.AllStateListReducer));
  const perList = deCryptFun(useSelector((s) => s.AllPerDiemListReducer));
  const [saveDayRate, setSavedDayRate] = useState();
  const [savedMilRate, setSavedMilRate] = useState();
  const [invoiceProjectIdVal, setInvoiceProjectIdVal] = useState("");
  const [invoiceStatusIDVal, setInvoiceStatusIDVal] = useState("");
  const [updateAddressValues, setUpdateAddressValues] = useState({
    street1: "",
    street2: "",
    city: "",
    state: "",
    zipcode: "",
  });
  const [addressvaluesChanged, setAddressvaluesChanged] = useState(false);
  const [addlineItemValue, setAddlineItemValue] = useState(false);
  const [showWarning, setShowWarningpopup] = useState(false);
  const [warningHighlightColor, setWarningHighlightColor] = useState(false);
  const [changedFields, setChangedFields] = useState({});
  const [backNavigateArrow, setBackNavigateArrow] = useState(false);
  const [openPrintInvoiceModel, setOpenPrintInvoiceModel] = useState(false);
  console.log(
    addressvaluesChanged,
    "dhjahsdhsdhakshdsakjhd",
    addlineItemValue,
    changedFields
  );
  const [closeBillingAlert, setCloseBillingAlert] = React.useState(false);
  const [closingInvoice, setCloseingInvoice] = React.useState(false);
  const [ManuallyAddLine, setManuallyLineAdd] = React.useState(false);
  console.log(changedFields, "dhjahsdhsdhakshdsakjhd");
  const [projectIdval, setProjectIdval] = useState();
  const [customerIdValue, setCustomerIdval] = useState();
  const {
    BillableOfficePerDiem,
    BillableTravelPerDiem,
    // BillingDayRate,
    // MileageRate,
    // PayableDayRate,
  } =
    (perList && JSON.parse(perList).data && JSON.parse(perList).data[0]) || [];
  const [attachmentId, setAttachmentId] = useState();
  const [lineList, setLineList] = useState([]);
  const [lineListPerDiemCheck, setLineListPerDiemCheck] = useState([]);
  const [billingStatementHeading, setBillingStatementHeading] = useState("");
  const [initialLineList, setInitialLineList] = useState([]);
  console.log(initialLineList, "c ");
  console.log(lineList, "lineListlineListlineList ");
  console.log(
    lineListPerDiemCheck,
    "lineListPerDiemChecklineListPerDiemCheck "
  );
  const [selectedPeriodList, setSelectedPeriodList] = useState([]);
  const [selectedNewPeriodList, setSelectedNewPeriodList] = useState([]);
  console.log(
    selectedNewPeriodList,
    "setSelectedNewPeriodListsetSelectedNewPeriodList"
  );
  console.log(selectedPeriodList, "selectedPeriodListselectedPeriodList");
  const [openAttachmentFilter, setOpenAttachmentFilter] = useState(false);
  const [deletedInvoicePopup, setDeletedInvoicePopup] = useState(false);
  const [deletedInvoiceLineItemPopup, setDeletedInvoiceLineItemPopup] =
    useState(false);
  const [invoiceDetailsVallues, setInvoiceDetailsValues] = useState("");
  const [invoiceDeleteKey, setInvoiceDeleteKey] = useState("");
  const [invoiceDeleteIndex, setInvoiceDeleteIndex] = useState("");
  console.log(
    invoiceDetailsVallues,
    "userListSel11111111 ",
    invoiceDeleteKey,
    invoiceDeleteIndex
  );
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);
  const [brokerView, setBrokerView] = useState(false);
  const [brokerDetails, setBrokerDetails] = useState();
  console.log("invoiceid id", invoiceDetailsVallues);
  const [headidStatement, setHeadIdStatement] = useState();
  const [attachList, setAttachList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [attachDetachLoading, setAttachDetachLoading] = useState(false);
  const [brokerNamePerProject, setBrokerNamePerProject] = useState([]);
  const [projectBrokerDetails, setProjectBrokerDetails] = useState([]);
  const [billingDayRate, setBillingDayRate] = useState(0);
  const [selectedDayRate, setSelectedDayRate] = useState("Billable Rate");
  const [savedSelectedDayRate, setSavedSelectedDayRate] =
    useState("Billable Rate");
  const restoringSavedDayRateRef = useRef(false);
  const [projectRateOptions, setProjectRateOptions] = useState({});
  const [invoiceExistingRateSource, setInvoiceExistingRateSource] = useState({});
  const [billingMileageRate, setBillingMileageRate] = useState(0);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [saveDayRateValue, setSaveDayRateValue] = useState(false);
  const [saveMileageRateValue, setSaveMileageRateValue] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  console.log(brokerNamePerProject, "brokerNamePerProjectbrokerNamePerProject");
  console.log(
    saveDayRateValue,
    "billingDayRatebillingDayRate",
    saveMileageRateValue
  );
  const [reOpenLoading, setReopenLoading] = useState(false);

  const [periousInvoiceDate, setInvoiceDate] = useState(null);
  const [dateFormatError, setDateFormatError] = useState("");
  console.log(dateFormatError, "dateeeeeeeeeeeeee");
  const [invoicDatePopup, setInvoiceDatePopup] = useState(false);

  console.log(billingMileageRate, "billingMileageRatebillingMileageRate");
  // console.log(
  //   selectedPeriodList,
  //   "selectedPeriodListselectedPeriodList",
  //   dayjs(selectedPeriodList[0]?.BillingStart, "MM/DD/YYYY")
  // );
  // let selectPeriodList = [];
  const filteredBrokerList = userListSel
    ? JSON.parse(userListSel).data.filter(
        (userlist) =>
          userlist.UserRole &&
          userlist.UserRole.split(",").includes(
            "6d8f5f3c-8ed1-40d5-b870-d54283c7da28"
          )
      )
    : [];
  const showToast = useToast();

  const handleAttachmentOpen = (val) => {
    // if (invoiceStatus) {
    //   showToast(
    //     "This invoice has been closed and can no longer be edited.",
    //     "reopenInvoice"View
    //   );
    // } else {
    setOpenAttachmentFilter(val);
    // getInvoiceDetails("View-Edit", val);
    // }
  };

  const handleAttachmentClose = () => {
    setOpenAttachmentFilter(false);
  };

  const generateInitialValues = (numberOfLineItems, startDate) => {
    const initialValuesLines = {};
    const startMoment = moment(startDate, "MM/DD/YYYY").local().startOf("day");
    for (let i = 1; i <= numberOfLineItems; i++) {
      const currentMoment = startMoment
        .clone()
        .add(i - 1, "days")
        .startOf("day");
      initialValuesLines[`lineItem${currentMoment.format("MM/DD/YYYY")}`] = [
        {
          invoiceDetailsId: "",
          invoiceHeaderId: "",
          billingHeaderId: "",
          billingDetailId: "",
          brokerId: "",
          billingType: "",
          dayRate: "",
          hours: "0.00",
          miles: "0",
          lodging: "0.00",
          description: "",
          perdiemRate: "$0.00",
          perDiem: "0.00",
          copies: "0.00",
          misc: "0.00",
          date: currentMoment.format("MM/DD/YYYY"),
          billingStatementDetailsId: 0,
        },
      ];
    }

    return initialValuesLines;
  };
  React.useEffect(() => {
    let stDate = moment(new Date()).utc().format("MM/DD/YYYY");
    let val = generateInitialValues(1, stDate);
    // setLineItemArr(val)
    setLineItemArrIni(val);
    // formik1.setValues(val)
  }, []);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };
  const handleStep = (step) => () => {
    console.log("step", step);
    // setActiveStep(step);
  };
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const handlePopoverOpen1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handlePopoverClose1 = () => {
    setAnchorEl1(null);
  };
  const handlePopoverOpen2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handlePopoverClose2 = () => {
    setAnchorEl2(null);
  };

  const handlePopoverOpen3 = (event) => {
    setAnchorEl3(event.currentTarget);
  };

  const handlePopoverClose3 = () => {
    setAnchorEl3(null);
  };

  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorEl1);
  const open2 = Boolean(anchorEl2);
  const open3 = Boolean(anchorEl3);
  const validationSchema = Yup.object({
    street1: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    zipcode: Yup.string().required("Zipcode is required"),
  });
  const validationSchemaForm1 = Yup.object().shape({
    billingType: Yup.string().required("Billing type is required"),
    brokerId: Yup.string().required("Broker is required"),
    date: Yup.string()
      .nullable() // Allows null values
      .required("Date is required") // Add required validation
      .test(
        "isValidDate",
        "Invalid date format",
        (value) => !value || dayjs.utc(value, "MM/DD/YYYY", true).isValid()
      ),
    // .test(
    //   "isFutureOrToday",
    //   "Date cannot be in the past",
    //   (value) =>
    //     !value || dayjs(value, "MM/DD/YYYY").isSameOrAfter(dayjs(), "day")
    // )
  });

  const lineItemValidationSchema = Yup.object().shape({
    billingType: Yup.string().required("Billing type is required"),
    brokerId: Yup.string().required("Broker is required"),
  });

  const validationSchemaForm2 = Yup.object().shape(
    Object.keys(initialValues)
      .filter((key) => key.startsWith("lineItem"))
      .reduce((schema, key) => {
        schema[key] = Yup.array().of(lineItemValidationSchema);
        return schema;
      }, {})
  );
  const {
    handleSubmit,
    handleChange,
    setValues,
    setFieldTouched,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    setFieldValue,
    setTouched,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values, "value of item");
      upsertAddressFun(values);
    },
  });

  const [previousMileageRate, setPreviousMileageRate] = useState();
  const [previousDayRate, setPreviousDayRate] = useState();
  const isProjectCardDayRateSynced = (selection = selectedDayRate) => {
    const normalizedSelection = normalizeSelectedDayRate(selection);
    const invoiceRate = getInvoiceSelectionRate(
      normalizedSelection,
      invoiceExistingRateSource,
      {},
      undefined
    );
    const projectRate = getInvoiceSelectionRate(
      normalizedSelection,
      {},
      projectRateOptions,
      undefined
    );

    // A saved optional rate belongs to the invoice and can differ from the
    // current project rate. Compare against that invoice value first.
    const savedRate =
      invoiceRate !== undefined &&
      invoiceRate !== null &&
      invoiceRate !== ""
        ? invoiceRate
        : projectRate;

    return (
      Number.isFinite(Number(values.dayRate)) &&
      Number.isFinite(Number(savedRate)) &&
      Math.abs(Number(values.dayRate) - Number(savedRate)) < 0.005
    );
  };
  const hasUnsavedDayRate = !isProjectCardDayRateSynced(
    selectedDayRate || values.selectedDayRate
  );

  console.log(values, "initiallllllllll");
  const upsertAddressFun = async () => {
    let postData = {
      invoiceId: invoiceid,
      billToStreet1: values.street1,
      billToStreet2: values.street2,
      billToCity: values.city,
      billToState: values.state,
      billToZip: values.zipcode,
    };
    const config = {
      method: "PUT",
      headers: authHeader(),
      url: UPDATE_INVOICE_BILLING_ADDRESS,
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      console.log("response", response);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        const message = parsedResponse.message;

        const invoiceUpdateMessage = message.split("\\n")[0]; // The first line contains the static part
        const updatedData = message
          .split("\\n") // Split the message into lines by the newline character
          .slice(1) // Ignore the first line as it contains the static part
          .filter((line) => line.includes("updated from")) // Keep only lines that mention updates
          .map((line) => line.trim()); // Clean up extra spaces

        const formattedUpdates = updatedData.map((update, index) => (
          <span key={index}>{update}</span>
        ));

        let toastMessage = null;

        if (formattedUpdates.length == 0) {
          toastMessage = (
            <>
              <span>{invoiceUpdateMessage}</span>
              <br />
            </>
          );
          getInvoiceDetails();
          // Show the toast with the formatted message
          showToast(toastMessage, "success");
        } else if (formattedUpdates.length > 0) {
          toastMessage = (
            <>
              <span>{invoiceUpdateMessage}</span>
              <br />
              {formattedUpdates.map((update, index) => (
                <span key={index}>
                  {update}
                  <br />
                </span>
              ))}
            </>
          );
          getInvoiceDetails();
          // Show the toast with the formatted message
          showToast(toastMessage, "success");
        }

        // showToast(parsedResponse.message, "success");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
          getInvoiceDetails();
        }
      }
    }
  };
  const upsertInvoiceDetailsFun = async (values) => {
    setSaveButtonLoading(true);
    // const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const {
      lodging,
      billingType,
      hours,
      perDiem,
      dayRate,
      miles,
      misc,
      copies,
      mileageRate,
      total,
      date,
      perDiemRate,
      description,
      brokerId,
      ProjectID,
      selectedDayRate: selectedDayRateValue,
    } = formik1.values;

    const calculatedPerDiem = calculatePerDiem(hours, perDiemRate);

    console.log("data get formik1.values", formik1.values);
    const resolvedRate = resolveNewLineItemDayRate(
      selectedDayRateValue,
      findLineBroker(brokerId),
      projectRateOptions,
      invoiceExistingRateSource.InvoiceDayRate
    );
    const billableRate = invoiceExistingRateSource.InvoiceDayRate ?? 0;
    let postData = {
      invoiceDetailsId: 0,
      invoiceHeaderId: parseInt(invoiceid),
      billingHeaderId: 0,
      billingDetailId: 0,
      brokerId: brokerId,
      billingType: billingType,
      date: date ? date : dayjs.utc(selectedPeriodList[0]?.BillingStart),
      hours: parseFloat(hours) || 0,
      perDiem: perDiem ? parseFloat(perDiem).toFixed(2) : "0.00",
      lodging: parseFloat(lodging) || 0,
      miles: parseFloat(miles) || 0,
      misc: parseFloat(misc) || 0,
      copies: parseFloat(copies) || 0,
      description: description ? description : "",
      perDiemRate: !isNaN(parseFloat(perDiemRate))
        ? parseFloat(perDiemRate)
        : 0,
      ...buildNewLineItemRatePayload(
        resolvedRate.selectedDayRate,
        billableRate,
        resolvedRate.dayRate
      ),
      ...getAllSelectedRateFields(
        invoiceExistingRateSource,
        resolvedRate.selectedDayRate,
        resolvedRate.dayRate
      ),
      projectId: invoiceProjectIdVal && invoiceProjectIdVal,
    };

    const configone = {
      method: "POST",
      url: UPSERT_INVOICE_DETAILS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };

    try {
      const response = await API(configone);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        showToast(parsedResponse.message, "success");
        formik1.resetForm();
        getInvoiceDetails("attach-dettach");
        setSaveButtonLoading(false);
        // // Add a delay of 2 seconds
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
        } else {
          showToast(v.message, "error");
        }
        getInvoiceDetails();
        setSaveButtonLoading(false);
      }
    }
  };

  // const calculatePerDiem = (hours, rate) => {
  //   console.log(hours, "hoyerKJJKkhasj", rate);
  //   // const parsedRate = rate ? parseFloat(rate) : "0.00" || 0;
  //   // return (hours ? hours : "0.00" / 8) * parsedRate;
  //   const parsedRate = parseFloat(rate) || 0;
  //   const hoursVal = parseFloat(hours) <= 8 ? hours : 8.0;

  //   console.log(
  //     (hoursVal / 8) * parsedRate,
  //     "parsedRateparsedRateparsedRate",
  //     parsedRate,
  //     hoursVal
  //   );
  //   return (hoursVal / 8) * parsedRate;
  // };

  const calculatePerDiem = (hours, rate) => {
    const parsedRate = parseFloat(rate) || 0; // Ensure rate is a valid number
    const roundHours = hours ? parseFloat(hours) : 0; // Ensure rate is a valid number
    const hoursVal = parseFloat(roundHours) <= 8 ? parseFloat(roundHours) : 8; // Ensure hours are a valid number and capped at 8
    console.log(hours, "roundHoursroundHours", roundHours, parseFloat(hours));
    // Perform the calculation without formatting
    const resultCalc = (hoursVal / 8) * parsedRate;

    // Truncate or round to 2 decimal places as needed
    const truncatedResult = Math.trunc(resultCalc * 100) / 100; // Truncate to 2 decimal places
    const roundedResult = Math.round(resultCalc * 100) / 100;
    // Round the result if needed
    const roundedResult3 = Math.ceil(resultCalc * 100) / 100; // Round up to 2 decimal places
    console.log(
      roundedResult,
      "roundedResultroundedResult",
      parsedRate,
      hoursVal
    );
    // Return as a string formatted to 2 decimal places
    return roundedResult.toFixed(2); // Ensures the result is always a string with 2 decimals
  };

  // const updateLineItems = {...initialLineItem, brokerId: selectedPeriodList[0]?.BrokerID }
  const formik1 = useFormik({
    initialValues: {
      ...initialLineItem,
      date:
        selectedPeriodList?.length > 0 && selectedPeriodList[0]?.BillingStart
          ? dayjs.utc(selectedPeriodList[0]?.BillingStart).format("MM/DD/YYYY")
          : dayjs
              .utc(billingStatementHeading?.InvoiceBillingStart)
              .format("MM/DD/YYYY"),
    },
    enableReinitialize: true,
    validationSchema: validationSchemaForm1,
    onSubmit: (values) => {
      const billingStart =
        selectedPeriodList?.length > 0 && selectedPeriodList[0]?.BillingStart
          ? dayjs.utc(selectedPeriodList[0]?.BillingStart)
          : dayjs.utc(billingStatementHeading?.InvoiceBillingStart);

      const billingEnd =
        selectedPeriodList?.length > 0 && selectedPeriodList[0]?.BillingEnd
          ? dayjs.utc(selectedPeriodList[0]?.BillingEnd)
          : dayjs.utc(billingStatementHeading?.InvoiceBillingEnd);

      const selectedDate = dayjs.utc(values.date, "MM/DD/YYYY");

      // Log to verify the day parts only
      console.log(
        billingStart.format("MM/DD/YYYY"),
        billingEnd.format("MM/DD/YYYY"),
        selectedDate.format("MM/DD/YYYY"),
        "kaaaaaaaaaaaaa"
      );

      // Compare only the day part, ignoring the time
      if (
        !selectedDate.isSame(billingStart, "day") &&
        (selectedDate.isBefore(billingStart, "day") ||
          selectedDate.isAfter(billingEnd, "day"))
      ) {
        showToast(
          "Selected date is outside of this invoice's billing period.",
          "error"
        );
        return;
      } else {
        console.log(values, "values from form 1");
        // setManuallyLineAdd(true);
        upsertInvoiceDetailsFun(values);
      }
    },
  });

  useEffect(() => {
    if (formik1.values.date == null || formik1.values.date == "") {
      formik1.setValues((prev) => ({
        ...prev,
        date:
          selectedPeriodList?.length > 0 && selectedPeriodList[0]?.BillingStart
            ? dayjs
                .utc(selectedPeriodList[0]?.BillingStart)
                .format("MM/DD/YYYY")
            : dayjs
                .utc(billingStatementHeading?.InvoiceBillingStart)
                .format("MM/DD/YYYY"),
        hours: "0.00",
        miles: "0",
        lodging: "0.00",
        description: "",
        perdiemRate: "$0.00",
        perDiem: "0.00",
        copies: "0.00",
        misc: "0.00",
      }));
    }
    console.log(
      dayjs.utc(selectedPeriodList[0]?.BillingStart).format("MM/DD/YYYY"),
      'dayjs.utc(selectedPeriodList[0]?.BillingStart).format("MM/DD/YYYY")',
      dayjs.utc(formik1.values.date, "MM/DD/YYYY")
    );
  }, [formik1.values]);

  console.log(
    formik1.errors,
    "console.log(formik1.errors);  console.log(formik1.errors);nnn",
    formik1.touched
  );
  console.log(
    dayjs.utc(formik1.values.date),
    "initiajjjjjjllllllllll",
    dayjs.utc(selectedPeriodList[0]?.BillingStart).format("MM/DD/YYYY"),
    formik1.values.date
  );

  console.log(formik1.values, "initialLineItdfghheminitialLineItem");
  console.log(
    values.mileageRate,
    "initialLineIteminitialLineItem",
    savedMilRate
  );
  console.log(formik1.values, "formik1.values.hours");
  const formik2 = useFormik({
    initialValues: initialArrayOfLines,
    enableReinitialize: true,
    // validationSchema: validationSchemaForm1,
    onSubmit: (values) => {
      console.log(values, "values from form 2");
    },
  });
  // const validateLineItem = async (key, index) => {
  //   const lineItemPath = `${key}[${index}]`;
  //   const lineItemValues = formik1.values[key][index];

  //   try {
  //     await lineItemValidationSchema.validate(lineItemValues, {
  //       abortEarly: false,
  //     });
  //     const newErrors = { ...errors };
  //     if (newErrors[key]) {
  //       newErrors[key].splice(index, 1);
  //       if (newErrors[key].length === 0) {
  //         delete newErrors[key];
  //       }
  //     }
  //     formik1.setErrors(newErrors);
  //     return true;
  //   } catch (validationErrors) {
  //     if (validationErrors.inner) {
  //       const newErrors = { ...errors };
  //       if (!newErrors[key]) {
  //         newErrors[key] = [];
  //       }
  //       newErrors[key][index] = validationErrors.inner.reduce((acc, error) => {
  //         acc[error.path.split(".").pop()] = error.message;
  //         return acc;
  //       }, {});
  //       formik1.setErrors(newErrors);

  //       // Mark fields as touched
  //       const newTouched = { ...touched };
  //       if (!newTouched[key]) {
  //         newTouched[key] = [];
  //       }
  //       newTouched[key][index] = validationErrors.inner.reduce((acc, error) => {
  //         acc[error.path.split(".").pop()] = true;
  //         return acc;
  //       }, {});
  //       formik1.setTouched(newTouched);
  //     }
  //     return false;
  //   }
  // };
  useEffect(() => {
    dispatch(getAlluserList());
  }, []);
  console.log("formik values", formik1.values, formik1.errors);
  const deleteLineItemFromAPI = async (id, lineItemKey, index) => {
    let data = {
      invoiceDetailId: id,
      isConsolidate: 0,
      projectId: invoiceProjectIdVal,
    };
    console.log("delete id", id);
    const config = {
      method: "DELETE",
      url: DELETE_INVOICE_LINE_ITEM_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      console.log("config", data);
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setLineItemArr((prevValues) => ({
          ...prevValues,
          [lineItemKey]: prevValues[lineItemKey]?.filter((_, i) => i !== index),
        }));
        // getBillStatementDetails();
        // upsertLog("remove");

        showToast(parsedResponse?.message, "success");
        getInvoiceDetails("attach-dettach");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
        } else {
          showToast(v.message, "error");
        }
        getInvoiceDetails();
      }
    }
  };
  const handleSaveItem = async (key, index, itemid) => {
    console.log("item id", itemid);
    // const isValid = await validateLineItem(key, index);
    if (isValid) {
      // If valid, you can proceed with submission logic for the specific item or the whole form
      console.log("Line item is valid, proceeding with submission");
      handleAddItem(key);
      // upsertBillingDetailsFun(formik1.values); // Uncomment this if you want to submit the form
    } else {
      console.log("Line item validation failed");
    }
  };
  const handleAddItem = (lineItemKey) => {
    const currentItems = LineItemArr[lineItemKey];
    if (currentItems) {
      const lastDate = currentItems[currentItems.length - 1].date;
      setLineItemArr((prevValues) => ({
        ...prevValues,
        [lineItemKey]: [
          ...prevValues[lineItemKey],
      {
          billingType: 0,
            dayRate: "",
            selectedDayRate: "Billable Rate",
            hours: "0.00",
            miles: "0",
            lodging: "0.00",
            description: "",
            perdiemRate: "$0.00",
            perDiem: "0.00",
            copies: "0.00",
            misc: "0.00",
            date: lastDate,
          },
        ],
      }));
    } else {
      setLineItemArr((prevValues) => ({
        ...prevValues,
        [lineItemKey]: [
          {
            billingType: 0,
            dayRate: "",
            selectedDayRate: "Billable Rate",
            hours: "0.00",
            miles: "0",
            lodging: "0.00",
            description: "",
            perdiemRate: "$0.00",
            perDiem: "0.00",
            copies: "0.00",
            misc: "0.00",
            date: moment(new Date()).utc().format("MM/DD/YYYY"),
          },
        ],
      }));
    }
  };

  const updateInvoiceStatus = async (id, status, type) => {
    let data = {
      invoiceId: id,
      statusId: status,
      isDelete: type == "true" ? 1 : 0,
    };
    const config = {
      method: "PUT",
      url: UPDATE_INVOICE_STATUS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        if (type == "true") {
          showToast(parsedResponse.message, "success");
          navigate(INVOICE_LIST);
        } else {
          showToast(
            `Invoice ${values.invoiceNo} in project '${values.projectName}' for customer '${values?.CustomerName}' was closed.`,
            "success"
          );
          showToast(
            "This invoice has been closed and can no longer be edited.",
            "reopenInvoice"
          );
        }
        setCloseingInvoice(false);
        getInvoiceDetails();
        if (type != "true") {
          updateHeaderDetails("false");
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
          getInvoiceDetails();
        }
      }
    }
  };
  const handleInvoiceStatus = () => {
    const allAttachedFalse = selectedPeriodList.every(
      (item) => item.IsAttached === false
    );
    if (overAllInvoiceTotal == 0 && lineList?.length == 0 && allAttachedFalse) {
      setDeletedInvoicePopup(true);
    } else if (
      addressvaluesChanged ||
      Object.keys(changedFields).length > 0 ||
      addlineItemValue ||
      hasUnsavedDayRate
    ) {
      setShowWarningpopup(true);
      setCloseBillingAlert(true);
    } else {
      setCloseingInvoice(true);
      // const newCompleted = completed;
      // newCompleted[activeStep] = true;
      // setCompleted(newCompleted);
      // setActiveStep(3);
      // setInvoiceStatus(true);
      // updateInvoiceStatus(invoiceid, 4);
    }
  };

  const handleClosingInvoiceYesClick = () => {
    updateInvoiceStatus(invoiceid, 4);
    setCloseingInvoice(false);
    getInvoiceAttachmentsList(4);
  };

  const handleClosingInvoiceNoClick = () => {
    setCloseingInvoice(false);
  };

  const handleManulyAddYesClick = () => {
    // upsertInvoiceDetailsFun(formik1.values);
    // setManuallyLineAdd(false);
    deleteLineItemFromAPI(
      invoiceDetailsVallues,
      invoiceDeleteKey,
      invoiceDeleteIndex
    );
    setDeletedInvoiceLineItemPopup(false);
  };

  const handleManuallyAddNoClick = () => {
    setManuallyLineAdd(false);
    setDeletedInvoiceLineItemPopup(false);
    setInvoiceDeleteIndex("");
    setInvoiceDeleteKey("");
    setInvoiceDetailsValues("");
  };
  console.log("line item add", LineItemArr);
  // const handleDownload = async (Path) => {
  //   const anchor = document.createElement("a");

  //   // Set the href attribute to the path of the Excel file
  //   anchor.href = sampleimg;

  //   // Set the download attribute to the desired file name
  //   anchor.download = "sampleimg.png";

  //   // Trigger a click event on the anchor element
  //   anchor.click();
  // };

  // const handleDownload = async (attachmentFileObject) => {
  //   const zip = new JSZip();
  //   const folder = zip.folder();

  //   try {
  //     // Fetch images and add them to the zip
  //     const fetchPromises = attachmentFileObject.map(async (photo) => {
  //       try {
  //         const response = await fetch(photo.Path);
  //         console.log(response, "responseeeeeeeeee");
  //         if (!response.ok) {
  //           throw new Error(
  //             `Failed to fetch ${photo.Path}. Status: ${response.status}, Status Text: ${response.statusText}`
  //           );
  //         }
  //         const blob = await response.blob();
  //         console.log(`Adding ${photo.FileName} to zip.`);
  //         folder.file(photo.FileName, blob);
  //       } catch (error) {
  //         console.error(`Error fetching ${photo.Path}:`, error);
  //       }
  //     });

  //     // Wait for all fetch promises to resolve
  //     await Promise.all(fetchPromises);

  //     // Generate the zip file and save it
  //     const zipBlob = await zip.generateAsync({ type: "blob" });
  //     console.log("Generated zip blob:", zipBlob);
  //     saveAs(zipBlob, "ZipFiles.zip");
  //   } catch (error) {
  //     console.error("Error generating or saving zip file:", error);
  //   }
  // };

  const handleDownload = async (attachmentFileObject, brokerDetails) => {
    console.log(attachmentFileObject, "gggggggggggggggg", brokerDetails);
    setDownloadLoading(true);
    const zip = new JSZip();
    const folder = zip.folder();

    try {
      // Fetch images and add them to the zip
      const fetchPromises = attachmentFileObject.map(async (photo, index) => {
        setDownloadLoading(true);
        try {
          const response = await fetch(photo.Path);
          if (!response.ok) {
            throw new Error(
              `Failed to fetch ${photo.Path}. Status: ${response.status}, Status Text: ${response.statusText}`
            );
          }

          const blob = await response.blob();
          let fileName = photo.FileName;

          // Check for duplicate filenames
          let duplicateCount = 0;
          const originalFileName = fileName;

          // Ensure uniqueness by appending an index if a duplicate exists
          while (folder.files[`${fileName}`]) {
            duplicateCount += 1;
            const lastDotIndex = originalFileName.lastIndexOf(".");
            const nameWithoutExt = originalFileName.substring(0, lastDotIndex);
            const ext = originalFileName.substring(lastDotIndex); // Includes the dot
            fileName = `${nameWithoutExt} (${duplicateCount})${ext}`;
          }

          // Add file to the zip with the unique file name
          folder.file(fileName, blob);
        } catch (error) {
          console.error(`Error fetching ${photo.Path}:`, error);
        }
      });

      // Wait for all fetch promises to resolve
      await Promise.all(fetchPromises);

      // Generate the zip file and save it
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(
        zipBlob,
        `${brokerDetails.ProjectName}_${"attachments"}_${
          brokerDetails.PeriodKey
        }.zip`
      );
    } catch (error) {
      console.error("Error generating or saving zip file:", error);
    } finally {
      setDownloadLoading(false);
    }
  };

  const getDayAndMileageRate = async () => {
    console.log("getDayAndMileageRate -->", getDayAndMileageRate);
    let data = {
      invoiceId: invoiceid,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_DAY_AND_MILEAGE_RATE_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        // console.log(
        //   "parse",
        //   parsedResponse.invoiceData,
        //   parsedResponse.invoiceData[0].dayRate
        // );
        setDetails(parsedResponse.invoiceData);

        const rateData = parsedResponse.invoiceData[0] || {};
        const loadedSelection = normalizeSelectedDayRate(
          rateData.selectedDayRate || rateData.SelectedDayRate || selectedDayRate
        );
        const { dayRate, mileageRate } = rateData;
        const savedRate = getDayRateForSelection(
          loadedSelection,
          rateData,
          dayRate || 0,
          true
        );
        setSavedDayRate(formatPopulatedDayRate(savedRate));
        setSavedSelectedDayRate(loadedSelection);
        // setSavedDayRate(dayRate);
        // setSavedMilRate(mileageRate);
        setValues((prev) => ({
          ...prev,
          mileageRate: mileageRate?.toFixed(3),
          dayRate: formatPopulatedDayRate(
            getDayRateForSelection(loadedSelection, rateData, dayRate || 0, true)
          ),
        }));
        // formik1.setValues((prev) => ({
        //   ...prev,
        //   mileageRate: mileageRate,
        //   dayRate: dayRate,
        // }));
        // setValues({...values,dayRate:dayRate,mileagRate:mileageRate})
        // setDetails(
        //   parsedResponse.invoiceData && parsedResponse.invoiceData.length > 0
        //     ? parsedResponse.invoiceData
        //     : []
        // );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAttachNewStatementInvoice = async (adminBillingStatementDetail) => {
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_ATTACH_NEW_STATEMENT_INVOICE_URL,
      params: {
        webString: enCryptFun(JSON.stringify(adminBillingStatementDetail)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("parse test parsedResponse", parsedResponse);

      // if (parsedResponse.status === "Success") {
      //   return parsedResponse.data;
      // }
      if (
        parsedResponse.status === "Success" &&
        parsedResponse.data.length > 0
      ) {
        const filteredData = parsedResponse.data.filter(
          (item) => item.StatusID != 3
        );
        return filteredData;
      }
    } catch (error) {}
  };

  const getInvoiceAttachmentsList = async (InvoiceStatusID, periodsDetail) => {
    let data = {
      invoiceId: invoiceid,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_ATTACH_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status === "Success") {
        setAttachDetachLoading(true);

        const billingStatementDetailArray = parsedResponse.data;

        console.log("Parsed Response Data:", billingStatementDetailArray);

        const adminBillingStatementDetail = {
          projectId: billingStatementDetailArray[0]?.ProjID,
          periodKey: billingStatementDetailArray[0]?.PeriodKey,
        };

        if (billingStatementDetailArray[0]?.ProjID) {
          const adminBillingStatementDetailRes =
            await getAttachNewStatementInvoice(adminBillingStatementDetail);
          console.log(
            adminBillingStatementDetailRes,
            "adminBillingStatementDetailResadminBillingStatementDetailRes"
          );
          if (
            adminBillingStatementDetailRes &&
            adminBillingStatementDetailRes.length > 0
          ) {
            const billingIds = billingStatementDetailArray.map(
              (item) => item.BillingHeaderID != 0 && item.BillingHeaderID
            );

            const filteredAdminBillingStatementDetail =
              adminBillingStatementDetailRes.filter(
                (item) => !billingIds.includes(item.statementId)
              );

            if (
              InvoiceStatusID === 3 ||
              (!InvoiceStatusID && invoiceStatusIDVal === 3)
            ) {
              setSelectedNewPeriodList(filteredAdminBillingStatementDetail);
            }
          } else {
            setSelectedNewPeriodList([]);
          }
        }

        // Set the selected period list based on conditions
        if (
          InvoiceStatusID === 3 ||
          (!InvoiceStatusID && invoiceStatusIDVal === 3)
        ) {
          const filteredData1 = billingStatementDetailArray.filter(
            (item) => item.BillingHeaderID != 0
          );
          setSelectedPeriodList(filteredData1);
        } else {
          const filteredData = billingStatementDetailArray.filter(
            (item) =>
              item.BillingHeaderID != 0 &&
              item.StatusID !== 1 &&
              item.StatusID !== 2
          );
          setSelectedPeriodList(filteredData);
        }

        setTimeout(() => {
          setAttachDetachLoading(false);
        }, 5000);
      } else {
        setSelectedPeriodList([]);
      }
    } catch (error) {
      console.log("API Error: ", error);
      if (error.response) {
        const decryptedError = deCryptFun(error.response.data);
        const parsedError = JSON.parse(decryptedError);
        if (parsedError.message !== "No record found.") {
          showToast(parsedError.message, "error");
        }
        setSelectedPeriodList([]);
      }
      console.log(periodsDetail, "periodsDetailperiodsDetail");
      if (periodsDetail) {
        try {
          const adminBillingStatementDetailRes =
            await getAttachNewStatementInvoice(periodsDetail);
          console.log(
            adminBillingStatementDetailRes,
            "adminBillingStatementDetailRes"
          );

          if (
            adminBillingStatementDetailRes &&
            adminBillingStatementDetailRes.length > 0
          ) {
            if (
              InvoiceStatusID === 3 ||
              (!InvoiceStatusID && invoiceStatusIDVal === 3)
            ) {
              setSelectedNewPeriodList(adminBillingStatementDetailRes);
            } else {
              setSelectedNewPeriodList([]);
            }
          } else {
            console.log(callinggggggggggg);
            setSelectedNewPeriodList([]);
          }
        } catch (error) {
          console.error("Error fetching admin billing statement:", error);
          setSelectedNewPeriodList([]);
          setSelectedPeriodList([]);
        }
      } else {
        setSelectedNewPeriodList([]);
        setSelectedPeriodList([]);
      }
    }
  };

  const getProjectsById = async (ProjID) => {
    let data = {
      projectId: ProjID,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_PROJECT_DETAILS_BY_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        const project = parsedResponse.ProjectDetails?.[0] || {};
        const {
          MileageRate,
          BillableTravelPerDiem,
          BillableOfficePerDiem,
          BillingDayRate,
          ProjectID,
          CustomerID,
        } = parsedResponse.ProjectDetails[0];
        setProjectRateOptions((previous) => ({
          ...previous,
          // Keep the invoice's billable rate separate from the project-card
          // selected rate. The invoice load seeds these values from the line
          // detail's BillableDayRate before this request completes.
          default: previous.default ?? BillingDayRate,
          billingDayRate: previous.billingDayRate ?? BillingDayRate,
          billableDayRate: previous.billableDayRate ?? BillingDayRate,
          principalRate: project.PrincipalRate ?? project.principalRate,
          PrincipalRate: project.PrincipalRate ?? project.principalRate,
          projectManagerRate:
            project.ProjectManagerRate ?? project.projectManagerRate,
          ProjectManagerRate:
            project.ProjectManagerRate ?? project.projectManagerRate,
          fieldAgentRate: project.FieldAgentRate ?? project.fieldAgentRate,
          FieldAgentRate: project.FieldAgentRate ?? project.fieldAgentRate,
          IsPrincipalRate: project.IsPrincipalRate ?? project.isPrincipalRate,
          IsProjectManagerRate:
            project.IsProjectManagerRate ?? project.isProjectManagerRate,
          IsFieldAgentRate: project.IsFieldAgentRate ?? project.isFieldAgentRate,
        }));
        setValues((prev) => ({
          ...prev,
          // mileageRate: MileageRate,
          // BillableOfficePerDiem: BillableOfficePerDiem,
          // BillableTravelPerDiem: BillableTravelPerDiem,
          // dayRate: BillingDayRate,
          CustomerID: CustomerID,
          ProjectID: ProjectID,
        }));
        // setSavedDayRate(BillingDayRate);
        // setSavedMilRate(MileageRate);
        console.log(MileageRate, "MileageRateMileageRate");
        console.log(BillingDayRate, "BillingDayRateBillingDayRate");

        // setBrokerNamePerProject(parsedResponse.BrokerDetails);

        //Project Broker
        if (parsedResponse.BrokerDetails) {
          let BrokerDetails = parsedResponse.BrokerDetails;
          setProjectBrokerDetails(
            BrokerDetails.filter((broker) => isEnabledRateFlag(broker.Active))
          );
          var activeBrokers = BrokerDetails.find(function (broker) {
            return broker.Active === true;
          });
          if (activeBrokers && activeBrokers.UserID) {
            dispatch(getPerDiemList(ProjID, activeBrokers.UserID));
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAllBrokers = async () => {
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_ALL_BROKERS,
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        console.log("sjsssss");
        const filteredValues = parsedResponse.data.filter(
          (item) => item.AccountActive == 1
        );
        setBrokerNamePerProject(filteredValues);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCustomersById = async (InvoiceCustomerID) => {
    let data = {
      userId: InvoiceCustomerID,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_CUSTOMER_BY_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log("customer", parsedResponse);
      if (parsedResponse.status === "Success") {
        const { Name } = parsedResponse.data;
        formik1.setValues({
          ...values,
          CustomerName: Name,
          // dayRate:
          //   DefaultDayRate != null
          //     ? parsedResponse?.data[0]?.DefaultDayRate
          //     : BillableDayRate,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(()=>{
  //   getInvoiceAttachmentsList()
  // },[])
  // useEffect(() => {
  //   if (Array.isArray(selectedPeriodList) && Array.isArray(attachList)) {
  //     const updatedPeriodList = selectedPeriodList.map((item) => {
  //       const selectedPeriod = attachList.find(
  //         (period) => period.BillingHeaderID === item.BillingStatementID
  //       );

  //       if (selectedPeriod) {
  //         return {
  //           ...item,
  //           IsAttached: selectedPeriod.IsAttached, // Make sure IsAttached is boolean
  //           id: selectedPeriod.ID,
  //         };
  //       }

  //       // Default when no matching period is found
  //       return {
  //         ...item,
  //         IsAttached: false, // Updated to boolean false
  //         id: 0,
  //       };
  //     });

  //     console.log('fetched', updatedPeriodList);
  //     setSelectedPeriodList(updatedPeriodList); // Update state with the new list
  //   }
  // }, [selectedPeriodList, attachList]); // Added dependencies

  const getInvoiceAttachments = async (
    projid,
    userid,
    periodk,
    type,
    brokerDetails
  ) => {
    console.log(brokerDetails, "typeeeeeeee");
    setLoading(true);
    let data = {
      // projectId: projid,
      type: 1,
      userId: userid,
      billingStatementId: brokerDetails.BillingHeaderID,
      parentTypeId: 1,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        const { Path, attachmentId } = parsedResponse.data[0];
        setAttachmentId(attachmentId);
        // if (type == "download") {
        handleDownload(parsedResponse.data, brokerDetails);
        // } else if (type == "detach") {
        //   // handleDetach();
        // }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
      setLoading(false);
    } finally {
      if (type == "detach") {
        // handleDetach()
      }
      setLoading(false);
    }
  };
  const getInvoiceSelectedPeriod = async (projectId, periodKeySel) => {
    let data = {
      projectId: projectId,
      periodKey: periodKeySel,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_INVOICE_SELECTED_PERIOD_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        console.log("parse", parsedResponse);
        // setSelectedPeriodList(parsedResponse.billingStatementDetails);
        return parsedResponse.billingStatementDetails;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const parsePeriodKey = (periodKey) => {
    // Extract the start and end dates from the period key
    const startDateStr = periodKey.substring(0, 8);
    const endDateStr = periodKey.substring(8, 16);

    // Parse the dates in the local time zone dynamically using Moment.js
    // const startDate = moment
    //   .utc(startDateStr, "DDMMYYYY", true)
    //   .format("MM/DD/YYYY");
    // const endDate = moment
    //   .utc(endDateStr, "DDMMYYYY", true)
    //   .format("MM/DD/YYYY");

    const startDate = moment
      .utc(startDateStr, "MMDDYYYY", true)
      .format("MM/DD/YYYY");
    const endDate = moment
      .utc(endDateStr, "MMDDYYYY", true)
      .format("MM/DD/YYYY");
    console.log(periodKey, "periodKey");
    console.log(startDateStr, "startDateStr", startDate);
    console.log(endDateStr, "endDateStr", endDate);

    return { startDate, endDate };
  };

  const getInvoiceDetails = async (type) => {
    console.log(type, "gaaaaaaaaa");
    setLoading(true);
    let data = {
      invoiceId: invoiceid,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_INVOICE_DETAILS_BY_ID,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        console.log("parse for project -->", parsedResponse.invoiceData);

      const invoiceData = parsedResponse.invoiceData[0];
      console.log(invoiceData,"=====invoiceData====");

        setInvoiceExistingRateSource(
          Object.fromEntries(
            Object.entries({
              InvDayRate: invoiceData?.InvDayRate ?? invoiceData?.InvoiceDayRate,
              InvoiceDayRate: invoiceData?.InvDayRate ?? invoiceData?.InvoiceDayRate,
              InvoiceMileageRate: invoiceData?.InvoiceMileageRate,
              selectedPrincipalRate: invoiceData?.selectedPrincipalRate,
              SelectedPrincipalRate: invoiceData?.SelectedPrincipalRate,
              selectedProjectManagerRate: invoiceData?.selectedProjectManagerRate,
              SelectedProjectManagerRate: invoiceData?.SelectedProjectManagerRate,
              selectedFieldAgentRate: invoiceData?.selectedFieldAgentRate,
              SelectedFieldAgentRate: invoiceData?.SelectedFieldAgentRate,
            }).filter(([, value]) => value !== null && value !== undefined && value !== "")
          )
        );
        const fetchedSelectedDayRate =
          invoiceData?.selectedDayRate ||
          invoiceData?.SelectedDayRate ||
          "Billable Rate";
        restoringSavedDayRateRef.current = true;
        setSelectedDayRate(normalizeSelectedDayRate(fetchedSelectedDayRate));
        setSavedSelectedDayRate(normalizeSelectedDayRate(fetchedSelectedDayRate));
        setProjectRateOptions((previous) => ({
          ...previous,
          default: invoiceData?.ProjectBillableDayRate ?? 0,
          billingDayRate: invoiceData?.ProjectBillableDayRate ?? 0,
          billableDayRate: invoiceData?.ProjectBillableDayRate ?? 0,
          principalRate:
            invoiceData?.PrincipalRate ?? invoiceData?.principalRate,
          PrincipalRate:
            invoiceData?.PrincipalRate ?? invoiceData?.principalRate,
          projectManagerRate:
            invoiceData?.ProjectManagerRate ?? invoiceData?.projectManagerRate,
          ProjectManagerRate:
            invoiceData?.ProjectManagerRate ?? invoiceData?.projectManagerRate,
          fieldAgentRate:
            invoiceData?.FieldAgentRate ?? invoiceData?.fieldAgentRate,
          FieldAgentRate:
            invoiceData?.FieldAgentRate ?? invoiceData?.fieldAgentRate,
        }));
        const {
          InvoiceProjectName,
          BillingDetailID,
          BillingType,
          BrokerID,
          Copies,
          Date,
          Description,
          Hours,
          InvoiceProjectID,
          InvoiceBillToCity,
          InvoiceBillToState,
          InvoiceBillToStreet2,
          InvoiceBillToStreet1,
          InvoiceBillToZip,
          InvoiceBillingEnd,
          InvoiceBillingStart,
          InvoiceBrokerCount,
          InvoiceBrokerHours,
          InvoiceCopies,
          InvoiceCreateDate,
          InvoiceCustomerID,
          InvoiceDate,
          InvoiceDayRate,
          InvoiceDetailsID,
          InvoiceHeaderID,
          InvoiceLodging,
          InvoiceMileageRate,
          InvoiceMiles,
          InvoiceMisc,
          InvoicePerDiem,
          InvoicePeriodKey,
          InvoiceStatusID,
          InvoiceTotal,
          IsConsolidate,
          LastModified,
          Lodging,
          Miles,
          Misc,
          CustomerName,
          CustomerFirstName,
          CustomerLastName,
          CustomerMobilePhone,
          CustomerOfficePhone,
          ProjectName,
          ProjectBillableDayRate,
          ProjectMileageRate,
          ProjectBillableTravelPerDiem,
          ProjectBillableOfficePerDiem,
          invoiceId,
          invoiceDetails,
          ConsolidatedInvoiceDetails,
        } = invoiceData;
        console.log(invoiceDetails, "fileeeeeeeeeeeeeeee");
        // console.log(ConsolidatedInvoiceDetails !== null && currentPathSegment === 'invoice-form', 'ConsolidatedInvoiceDetailsiiiiii')
        if (
          ConsolidatedInvoiceDetails !== null &&
          currentPathSegment === "invoice-form"
        ) {
          // window.location.reload()
          navigate(`/consolidated-invoice-form/${invoiceId}`, {
            replace: true,
          });
          // getInvoiceDetails()
        } else {
          const dayRateValue = invoiceData?.InvoiceDayRate?.toFixed(2) || "";
          const mileageRateValue =
            invoiceData?.InvoiceMileageRate?.toFixed(3) || "";
          console.log("Invoice Broker Count", InvoiceProjectID);
          // const BrokeruserId = JSON.parse(invoiceDetails)[0].BrokerID;

          const { startDate, endDate } = parsePeriodKey(InvoicePeriodKey);
          console.log(startDate, "InvoicePeriodKeyInvoicePeriodKey", endDate, InvoicePeriodKey);
          setBillingStatementHeading({
            ProjectName: ProjectName,
            InvoiceBillingStart: startDate,
            InvoiceBillingEnd: endDate,
          });
          const prasedValue = invoiceDetails ? JSON.parse(invoiceDetails) : [];
          // New line items use the invoice header rate exclusively.
          const billableDayRateForNewLine = InvoiceDayRate ?? 0;
          setProjectRateOptions((previous) => ({
            ...previous,
            default: ProjectBillableDayRate ?? 0,
            billingDayRate: ProjectBillableDayRate ?? 0,
            billableDayRate: ProjectBillableDayRate ?? 0,
          }));
          const formattedValues = prasedValue.map((item) => ({
            ...item,
            Hours: item?.Hours?.toFixed(2),
            Lodging: item.Lodging.toFixed(2),
            Copies: item.Copies.toFixed(2),
            PerDiem: !isNaN(parseFloat(item.PerDiem))
              ? parseFloat(item.PerDiem).toFixed(2)
              : "0.00",
            Misc: item.Misc?.toFixed(2),
          }));
          const filteredvalues = prasedValue?.filter(
            (item) => item?.BillingType != 0
          );
          console.log(prasedValue, "invoiceDetailsStrnginvoiceDetailsStrng");
          console.log(filteredvalues, "fileeeeeeeeeeeeeeee");
          console.log(formattedValues, "fileeeeeeeeeeprasedValueeeeeee");
          setLineList(formattedValues);
          setLineListPerDiemCheck(formattedValues);
          setInitialLineList(invoiceDetails ? JSON.parse(invoiceDetails) : []);
          setSavedDayRate(
            formatPopulatedDayRate(
              getDayRateForSelection(
                fetchedSelectedDayRate,
                invoiceData,
                InvoiceDayRate || 0,
                true
              )
            )
          );
          setSavedMilRate(InvoiceMileageRate?.toFixed(3));
          setInvoiceProjectIdVal(InvoiceProjectID);
          setInvoiceStatusIDVal(InvoiceStatusID);
          console.log(invoiceData, "invoicekskalallaaaaaaaaaa");
          // Fetch related lists (invoice periods, attachments)
          // if (InvoiceProjectID) {
          await Promise.all([
            getInvoiceSelectedPeriod(InvoiceProjectID, InvoicePeriodKey),
            getInvoiceAttachmentsList(InvoiceStatusID, {
              projectId: invoiceData.InvoiceProjectID,
              periodKey: invoiceData.InvoicePeriodKey,
            }),
            getCustomersById(InvoiceCustomerID),
            getAllBrokers(),
            getProjectsById(InvoiceProjectID),
          ]);

          // const { startDate, endDate } = parsePeriodKey(InvoicePeriodKey);
          // console.log(startDate, "startssssssssssssss", endDate);
          // Parse invoice details if available
          const parsedInvoiceDetails = invoiceDetails
            ? JSON.parse(invoiceDetails)
            : [];
          console.log(parsedInvoiceDetails, "parsedInvoiceDetailsj");
          const totalValues = {
            perDiemSum: parsedInvoiceDetails.reduce((acc, item) => {
              // Ensure that each item is treated as a valid number for accumulation
              const perDiem = calculatePerDiem(item.Hours, item.PerDiemRate);
              // return acc + parseFloat(perDiem); // Convert the result back to a number before summing
              return acc + item.PerDiem; // Convert the result back to a number before summing
            }, 0),
            perLodgingSum: parsedInvoiceDetails.reduce(
              (acc, item) => acc + item.Lodging,
              0
            ),
            perCopiesSum: parsedInvoiceDetails.reduce(
              (acc, item) => acc + item.Copies,
              0
            ),
            perMiscSum: parsedInvoiceDetails.reduce(
              (acc, item) => acc + item.Misc,
              0
            ),
            perMilesSum: parsedInvoiceDetails.reduce(
              (acc, item) => acc + item.Miles,
              0
            ),
            perTotalHoursSum: parsedInvoiceDetails.reduce(
              (acc, item) => acc + item.Hours,
              0
            ),
          };

          const invoiceLineChargeTotal = getInvoiceLineChargeTotal(
            parsedInvoiceDetails,
            invoiceData
          );
          const grandTotal =
            (totalValues.perDiemSum ? parseFloat(totalValues.perDiemSum) : 0) +
            (totalValues.perLodgingSum
              ? parseFloat(totalValues.perLodgingSum)
              : 0) +
            (totalValues.perCopiesSum
              ? parseFloat(totalValues.perCopiesSum)
              : 0) +
            (totalValues.perMiscSum ? parseFloat(totalValues.perMiscSum) : 0) +
            (totalValues.perMilesSum
              ? parseFloat(totalValues.perMilesSum)
              : 0) *
              (values.mileageRate ? parseFloat(values.mileageRate) : 0) +
            invoiceLineChargeTotal;

          const AddressValues = {
            street1: InvoiceBillToStreet1,
            street2: InvoiceBillToStreet2,
            city: InvoiceBillToCity,
            state: InvoiceBillToState,
            zipcode: InvoiceBillToZip,
          };

          console.log(totalValues, "totalValuestotalValues");

          setUpdateAddressValues(AddressValues);
          const invoiceDate = dayjs.utc(InvoiceDate);
          const currentDate = dayjs.utc(); // Gets the current date in UTC

          const finalInvoiceDate = invoiceDate.isBefore(currentDate)
            ? invoiceDate.format("MM/DD/YYYY")
            : invoiceDate.format("MM/DD/YYYY");

          setInvoiceDate(finalInvoiceDate);
          console.log(finalInvoiceDate, 'finalInvo222iceDatefinalInvoiceDate')
          // console.log(dayjs.utc(InvoiceCreateDate), 'dayjs(InvoiceCreateDate)',finalInvoiceDate)
          // Update form values with parsed invoice details
          setValues((prevValues) => ({
            ...prevValues,
            street1: InvoiceBillToStreet1,
            street2: InvoiceBillToStreet2,
            city: InvoiceBillToCity,
            state: InvoiceBillToState,
            zipcode: InvoiceBillToZip,
            invoiceDate: finalInvoiceDate,
            createDate: InvoiceCreateDate
              ? dayjs.utc(InvoiceCreateDate)
              : dayjs.utc(),
            invoiceNo: invoiceId,
            invoiceTotal: InvoiceTotal,
            projectName: ProjectName ? ProjectName : InvoiceProjectName,
            startDate: startDate,
            endDate: endDate,
            // brokerName: BrokerName,
            totalPerDiem: totalValues.perDiemSum,
            totalMileage: InvoiceMileageRate,
            totalLodging: totalValues.perLodgingSum,
            totalCopies: totalValues.perCopiesSum,
            totalMisc: totalValues.perMiscSum,
            totalHours: totalValues.perTotalHoursSum,
            totalMiles: totalValues.perMilesSum,
            CustomerName: CustomerName,
            dayRate: formatPopulatedDayRate(
              getDayRateForSelection(
                fetchedSelectedDayRate,
                invoiceData,
                dayRateValue || 0,
                true
              )
            ),
            selectedDayRate: normalizeSelectedDayRate(fetchedSelectedDayRate),
            mileageRate: mileageRateValue ? mileageRateValue : "",
            date: null,
            brokerId: null,
            billingType: "",
            CustomerID: InvoiceCustomerID,
            ProjectID: InvoiceProjectID,
            InvoiceStatusID: InvoiceStatusID,
            InvoicePeriodKey: InvoicePeriodKey,
            InvoiceBrokerCount: InvoiceBrokerCount,
            InvoiceBrokerHours: InvoiceBrokerHours,
            BillableOfficePerDiem: parseFloat(
              ProjectBillableOfficePerDiem
            )?.toFixed(2),
            BillableTravelPerDiem: parseFloat(
              ProjectBillableTravelPerDiem
            )?.toFixed(2),
          }));
          formik1.setValues((prev) => ({
            ...prev,
            mileageRate: InvoiceMileageRate,
            BillableOfficePerDiem: parseFloat(
              ProjectBillableOfficePerDiem
            )?.toFixed(2),
            BillableTravelPerDiem: parseFloat(
              ProjectBillableTravelPerDiem
            )?.toFixed(2),
            // New line items are independent from the project-card selection.
            dayRate: formatRateValue(InvoiceDayRate),
      selectedDayRate: "Billable Rate",
      InvoiceDayRate,
          }));
          if (
            type !== "day_rate" &&
            type !== "mileage_rate" &&
            type !== "InvoiceDate"
          ) {
            console.log(type, "ieeeeeeeehhhhhhhhhhhhhhhhhhhhh");
            updateHeaderDetails(
              " ",
              grandTotal,
              parsedInvoiceDetails,
              invoiceData,
              dayRateValue,
              mileageRateValue
            );
            console.log(InvoiceTotal, "ksjjhfkjkakfkhgshf", grandTotal);
          }

          if (InvoiceStatusID == 4) {
            setActiveStep(3);
            setInvoiceStatus(true);
          }

          let formattedInvoiceDate = moment(InvoiceDate);
          console.log("Invoice Date formatted:", formattedInvoiceDate);

          getDayAndMileageRate();
        }
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getInvoiceDetails("reload");
  }, [invoiceid]);
  useEffect(() => {
    if (restoringSavedDayRateRef.current) {
      restoringSavedDayRateRef.current = false;
      return;
    }
    if (!Object.keys(projectRateOptions).length) return;
    const invoiceRate = getDayRateForSelection(
      selectedDayRate,
      invoiceExistingRateSource,
      undefined,
      true
    );
    const selectedRate =
      invoiceRate !== undefined && invoiceRate !== null
        ? invoiceRate
        : getDayRateForSelection(selectedDayRate, projectRateOptions, 0, false);
    if (selectedRate !== undefined && selectedRate !== null) {
      setValues((previous) => ({
        ...previous,
         dayRate: formatPopulatedDayRate(selectedRate),
      }));
    }
  }, [selectedDayRate, projectRateOptions, invoiceExistingRateSource]);

  const handleDayRateSelection = (selection) => {
    const nextSelection = normalizeSelectedDayRate(selection);
    const invoiceRate = getDayRateForSelection(
      nextSelection,
      invoiceExistingRateSource,
      undefined,
      true
    );
    const nextRate =
      invoiceRate !== undefined && invoiceRate !== null
        ? invoiceRate
        : getDayRateForSelection(
            nextSelection,
            projectRateOptions,
            0,
            false
          );
    setSelectedDayRate(nextSelection);
    setValues((previous) => ({
      ...previous,
      dayRate: formatPopulatedDayRate(nextRate ?? 0),
      selectedDayRate: nextSelection,
    }));
  };
  const getLineRateOptions = () =>
    getLineDayRateOptions(
      findLineBroker(formik1.values.brokerId),
      projectRateOptions
    );
  const findLineBroker = (brokerId) => {
  if (brokerId === null || brokerId === undefined || brokerId === "") {
    return undefined;
  }
  const broker = [...projectBrokerDetails, ...brokerNamePerProject].find(
    (broker) =>
      String(broker.UserID) === String(brokerId) ||
      String(broker.BrokerID) === String(brokerId)
  );

  return broker;
};
  const handleNewLineBrokerChange = (event) => {
    const brokerId = event.target.value;
    const broker = findLineBroker(brokerId);
    const resolved = resolveNewLineItemDayRate(
      "Billable Rate",
      broker,
      projectRateOptions,
      invoiceExistingRateSource.InvoiceDayRate
    );
    formik1.setValues((previous) => ({
      ...previous,
      brokerId,
      selectedDayRate: resolved.selectedDayRate,
      ...(resolved.selectedDayRate === "Billable Rate"
        ? { dayRate: formatPopulatedDayRate(resolved.dayRate) }
        : {}),
    }));
  };
  const handleNewLineRateChange = (event) => {
    const resolved = resolveNewLineItemDayRate(
      event.target.value,
      findLineBroker(formik1.values.brokerId),
      projectRateOptions,
      invoiceExistingRateSource.InvoiceDayRate
    );
    formik1.setValues((previous) => ({
      ...previous,
      selectedDayRate: resolved.selectedDayRate,
      ...(resolved.selectedDayRate === "Billable Rate"
        ? { dayRate: formatPopulatedDayRate(resolved.dayRate) }
        : {}),
    }));
  };
  const handleExistingLineRateChange = (invoiceDetailsId, selection, brokerId) => {
    const item = lineList.find(
      (row) => String(row.InvoiceDetailsID) === String(invoiceDetailsId)
    );
    const resolved = resolveExistingLineItemDayRate(
      selection,
      {
        ...item,
        ...invoiceExistingRateSource,
        InvoiceDayRate:
          invoiceExistingRateSource.InvDayRate ??
          invoiceExistingRateSource.InvoiceDayRate,
      },
      projectRateOptions,
      item?.DayRate ?? item?.InvoiceDayRate ?? 0
    );
    setLineList((previous) =>
      previous.map((row) =>
        String(row.InvoiceDetailsID) === String(invoiceDetailsId)
          ? {
              ...row,
              selectedDayRate: resolved.selectedDayRate,
              ...getSelectedRateFields(resolved.selectedDayRate, resolved.dayRate),
              ...(resolved.selectedDayRate === "Billable Rate"
                ? { dayRate: resolved.dayRate, DayRate: resolved.dayRate }
                : {}),
            }
          : row
      )
    );
    const initialSelection = getPersistedSelectedDayRate(
      initialLineList.find(
        (row) => String(row.InvoiceDetailsID) === String(invoiceDetailsId)
      )
    );
    setChangedFields((previous) => {
      const next = { ...previous };
      const isChanged =
        normalizeSelectedDayRate(resolved.selectedDayRate) !==
        normalizeSelectedDayRate(initialSelection);

      if (isChanged) {
        next[invoiceDetailsId] = {
          ...next[invoiceDetailsId],
          SelectedDayRate: true,
        };
      } else if (next[invoiceDetailsId]) {
        const fields = { ...next[invoiceDetailsId] };
        delete fields.SelectedDayRate;
        if (Object.keys(fields).length > 0) {
          next[invoiceDetailsId] = fields;
        } else {
          delete next[invoiceDetailsId];
        }
      }

      return next;
    });
  };
  useEffect(() => {
    dispatch(getAllStatesList());
  }, []);
  // useEffect(() => {
  //   console.log("Details useEffect =>", details && details.length);
  //   if (details && details.length > 0) {
  //     const { dayRate, mileageRate } = details[0];
  //     setValues({ ...values, dayRate: dayRate, mileageRate: mileageRate });
  //     setBillingMileageRate(mileageRate);
  //   }
  // }, [details]);

  useEffect(() => {
    if (lineList.length > 0) {
      const updatedChangedFields = lineList.reduce((acc, newItem) => {
        const initialItem = initialLineList.find(
          (item) => item.InvoiceDetailsID === newItem.InvoiceDetailsID
        );

        console.log(initialItem, "Found item"); // Check the value of initialItem

        if (initialItem) {
          const changedFields = {};

          [
            "Description",
            "BillingType",
            "PerDiem",
            "Lodging",
            "Copies",
            "Misc",
            "Miles",
            "Hours",
          ].forEach((field) => {
            if (newItem[field] !== initialItem[field]) {
              changedFields[field] = true;
            }
          });

          if (Object.keys(changedFields).length > 0) {
            acc[newItem.InvoiceDetailsID] = changedFields;
          }
        }
        return acc;
      }, {});

      // setChangedFields(updatedChangedFields);
    }
  }, [lineList, initialLineList]);

  useEffect(() => {
    let totalPerDiem = 0;
    let expenses = 0;
    let mileage = 0;
    let charges = 0;

    // Ensure values are defined and numeric, or default to 0
    totalPerDiem = parseFloat(values?.totalPerDiem || 0);

    // Lodging, Copies, Misc expenses
    expenses =
      parseFloat(values?.totalLodging || 0) +
      parseFloat(values?.totalCopies || 0) +
      parseFloat(values?.totalMisc || 0);

    // Mileage calculation
    if (values?.totalMiles && savedMilRate) {
      mileage = parseFloat(values.totalMiles) * parseFloat(savedMilRate);
    }

    // Calculate charges per line using the invoice's selected rate fields.
    charges = getInvoiceLineChargeTotal(lineList, invoiceExistingRateSource);

    // Calculate total value
    const totalValue = totalPerDiem + expenses + mileage + charges;

    console.log(totalPerDiem, expenses, mileage, charges, "Total calculation");

    // Set the total value, including when total is 0
    if (!isNaN(totalValue)) {
      setOverAllInvoiceTotal(totalValue);
    }
  }, [
    values,
    lineList,
    invoiceExistingRateSource,
    saveDayRate,
    savedMilRate,
  ]);

  console.log("lines", lineList, values);
  const invoiceLineChargeTotal = getInvoiceLineChargeTotal(
    lineList,
    invoiceExistingRateSource
  );
  const invoiceLineChargeBreakdown = getInvoiceLineChargeBreakdown(
    lineList,
    invoiceExistingRateSource
  );
  const detachFunCall = async () => {
    setAttachDettachLoading(true);
    let attordet = "detached from";
    if (isAttach == false) {
      attordet = "attached to";
    }
    let data = {
      id: attachmentId ? attachmentId : 0,
      invoiceId: invoiceid,
      billingHeaderId: headidStatement ? headidStatement : 0,
      isAttached: isAttach == true ? false : true,
    };
    console.log("data pose", data, headidStatement);
    const config = {
      method: "POST",
      headers: authHeader(),
      url: ATTACH_DETACH_INVOICE_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        console.log("parse", parsedResponse);
        const { rowCount } = parsedResponse;
        if (isAttach == false) {
          upsertLog("attached to", rowCount);
        } else {
          upsertLog("detached from", rowCount);
        }
        setDetachOpen(false);
        setAttachOpen(false);
        getInvoiceAttachmentsList();
        getInvoiceDetails("attach-dettach");
        console.log("ids", headidStatement);
        showToast(
          `Billing for ${bname} (Customer: ${
            values.CustomerName
          }, Project: ${projname}, Statement ID: ${headidStatement}) was ${attordet} this invoice. A total of ${rowCount} invoice lines were ${
            attordet == "attached to" ? "added" : "removed"
          }.`,
          "success"
        );
        setShowWarningpopup(false);
        setAddressvaluesChanged(false);
        setChangedFields({});
        setWarningHighlightColor(false);
        setAddlineItemValue(false);
        setAttachDettachLoading(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
          getInvoiceAttachmentsList();
          setDetachOpen(false);
          setAttachOpen(false);
        } else {
          showToast(v.message, "error");
          getInvoiceDetails();
          getInvoiceAttachmentsList();
          setDetachOpen(false);
          setAttachOpen(false);
        }
        setAttachDettachLoading(false);
      }
    }
  };
  const handleCloseAttach = () => {
    setAttachOpen(false);
  };
  const handleDetach = (
    headerid,
    id,
    attached,
    bname,
    projname,
    projId,
    customerId
  ) => {
    console.log("headerid", headerid, id);
    setDetachOpen(true);
    setIsAttach(attached);
    setAttachmentId(id);
    setHeadIdStatement(headerid);
    setBname(bname);
    setPrpjName(projname);
    setProjectIdval(projId);
    setCustomerIdval(customerId);
  };
  const handleAttach = (
    headerid,
    id,
    attached,
    bname,
    projname,
    projId,
    customerId
  ) => {
    setAttachOpen(true);
    setAttachmentId(id);
    setIsAttach(attached);
    setHeadIdStatement(headerid);
    setBname(bname);
    setPrpjName(projname);
    setProjectIdval(projId);
    setCustomerIdval(customerId);
    // setSelectedNewPeriodList([])
  };
  const upsertLog = async (type, rowCount) => {
    let logData = {
      logTypeID: type == "attached to" ? 51 : 52,
      logUser: getLogUserId(),
      target: projectIdval,
      target2: customerIdValue,
      description:
        type == "attached to"
          ? `Billing for ${bname} (Customer: ${values.CustomerName}, Project: ${projname}, Statement ID: ${headidStatement}) was ${type} this invoice. A Total of ${rowCount} invoice lines were added}`
          : `Billing for ${bname} (Customer: ${values.CustomerName}, Project: ${projname}, Statement ID: ${headidStatement}) was ${type} this invoice. A Total of ${rowCount} invoice lines were removed}`,
    };
    const config = {
      method: "POST",
      headers: authHeader(),
      url: SYSTEM_LOG_INSERT_URL,
      data: {
        webString: enCryptFun(JSON.stringify(logData)),
      },
    };
    try {
      const resp = await API(config);
    } catch (error) {
      console.error(error);
    }
  };
  const upsertPerDiemLog = async (item) => {
    const oldperDiemValue = initialLineList?.filter(
      (val) => val.InvoiceDetailsID == item?.InvoiceDetailsID
    );

    console.log(oldperDiemValue, "olddddddddddddddddd");
    let logData = {
      logTypeID: 74,
      logUser: getLogUserId(),
      target: invoiceid,
      target2: item?.InvProjectID
        ? item?.InvProjectID
        : item?.ProjID || item?.ProjectID,
      description: `Invoice line was updated for ${getLogUserName()} on ${moment
        .utc(item?.Date || item?.date)
        .format("MM/DD/YYYY")} in project '${
        values?.projectName || item?.projectName || item?.ProjectName
      }' for customer '${
        values?.CustomerName
      }'. Data updated was: PerDiem manually updated from ${
        oldperDiemValue?.length > 0 ? oldperDiemValue[0]?.PerDiem : "0.00"
      } to ${parseFloat(item.PerDiem || item?.perDiem).toFixed(2)}.`,
    };

    console.log(logData, "logggggggggg");
    const config = {
      method: "POST",
      headers: authHeader(),
      url: SYSTEM_LOG_INSERT_URL,
      data: {
        webString: enCryptFun(JSON.stringify(logData)),
      },
    };
    try {
      const resp = await API(config);
    } catch (error) {
      console.error(error);
    }
  };
  const handleClose = () => {
    setDetachOpen(false);
    setAttachOpen(false);
  };
  const lineDateChange = (date, formik) => {
    let valueDate;

    // Check if date is null and set fallback date if needed
    if (date === null) {
      valueDate =
        selectedPeriodList?.length > 0 && selectedPeriodList[0]?.BillingStart
          ? dayjs.utc(selectedPeriodList[0]?.BillingStart).format("MM/DD/YYYY")
          : dayjs
              .utc(billingStatementHeading?.InvoiceBillingStart)
              .format("MM/DD/YYYY");
    } else {
      valueDate = dayjs.utc(date).format("MM/DD/YYYY");
    }

    console.log("Formatted Date:", valueDate, "Original Date:", date);

    // Set the value in Formik
    formik.setValues((prevValues) => ({
      ...prevValues,
      date: valueDate,
    }));

    formik.setFieldValue("date", valueDate);
    formik.setFieldTouched("date", true, false); // Mark the field as touched
    console.log("Date change:", date, valueDate);
  };

  console.log("values for 1st", values);
  const handleChangeDate = (e, field) => {
    // setValues({ ...values, field: dayjs.utc(e) });
    const selectedDate = dayjs(e);
    const today = dayjs().startOf("day");

    if (!selectedDate.isValid()) {
      setDateFormatError("Invalid date format.", "error");
      // Reset or keep the old date (Optional: depends on your UX)
      setValues({ ...values, invoiceDate: selectedDate });
      return;
    }
    // else if (selectedDate.isBefore(today)) {
    //   setDateFormatError("Invoice date cannot be in the past.", "error");
    //   // Reset or keep the old date (Optional: depends on your UX)
    //   setValues({ ...values, invoiceDate: selectedDate });
    // }
    else {
      // Set the valid date
      setDateFormatError("", "error");
      setValues({ ...values, invoiceDate: selectedDate });
    }
  };
  const listOnChange = (e, id) => {
    const { name, value } = e?.target;
    console.log("namesssssssssssssss", value, name, id);
    const regex = /^\d*\.?\d{0,2}$/;
    const floatRegex = /^(\d{0,2}(\.\d{0,2})?)$/;
    const numericValue = parseFloat(value);

    if (name === "Description" || name === "BillingType") {
      const updatedLineList = lineList.map((item) =>
        item.InvoiceDetailsID === id ? { ...item, [name]: value } : item
      );

      setLineList(updatedLineList);

      // Check if the value has reverted back to the original state
      const initialValue = initialLineList.find(
        (item) => item.InvoiceDetailsID === id
      )?.[name];

      setChangedFields((prevState) => {
        const newState = { ...prevState };
        const isChanged = value !== initialValue; // Check if the current value differs from the initial value

        if (isChanged) {
          newState[id] = {
            ...prevState[id],
            [name]: true, // Mark as changed
          };
        } else {
          if (newState[id]) {
            delete newState[id][name]; // Remove the changed state if reverted
            if (Object.keys(newState[id]).length === 0) {
              delete newState[id]; // Clean up if no changes remain for this ID
            }
          }
        }

        return newState;
      });
    } else if (name === "Hours") {
      if (
        (value === "" || floatRegex.test(value)) &&
        (numericValue <= 24 || value === "")
      ) {
        const updatedLineList = lineList.map((item) =>
          item?.InvoiceDetailsID === id
            ? {
                ...item,
                [name]: typeof value === "number" ? value.toFixed(2) : value,
              }
            : item
        );

        const updatedLineList1 = lineList.map((item) => {
          if (item?.InvoiceDetailsID === id) {
            const updatedItem = {
              ...item,
              [name]: typeof value === "number" ? value.toFixed(2) : value,
            };
            return {
              ...updatedItem,
              PerDiem: calculatePerDiem(
                updatedItem?.Hours,
                updatedItem?.PerDiemRate
              ),
            };
          }
          return item;
        });

        if (name === "PerDiemRate" || name === "Hours") {
          setLineList(updatedLineList1);
        } else {
          setLineList(updatedLineList);
        }

        const initialValue = initialLineList.find(
          (item) => item.InvoiceDetailsID === id
        )?.[name];

        setChangedFields((prevState) => {
          const newState = { ...prevState };
          const isChanged = value != initialValue; // Check if the current value differs from the initial value
          console.log(isChanged, "ischangeeeeeeeeeeeeee");
          console.log(initialValue, "ischangeeeeeeeeeeeeee", value);
          if (isChanged) {
            newState[id] = {
              ...prevState[id],
              [name]: true, // Mark as changed
            };
          } else {
            if (newState[id]) {
              delete newState[id][name]; // Remove the changed state if reverted
              if (Object.keys(newState[id]).length === 0) {
                delete newState[id]; // Clean up if no changes remain for this ID
              }
            }
          }

          return newState;
        });
      }
    } else {
      // Numeric input handling
      if (regex.test(value) || value === "") {
        const updatedLineList = lineList.map((item) =>
          item?.InvoiceDetailsID === id ? { ...item, [name]: value } : item
        );
        const updatedLineList1 = lineList.map((item) => {
          if (item?.InvoiceDetailsID === id) {
            const updatedItem = { ...item, [name]: value };
            return {
              ...updatedItem,
              PerDiem: calculatePerDiem(
                updatedItem?.Hours,
                updatedItem?.PerDiemRate
              ),
            };
          }
          return item;
        });

        if (name === "PerDiemRate" || name === "Hours") {
          setLineList(updatedLineList1);
        } else {
          setLineList(updatedLineList);
        }

        const initialValue = initialLineList.find(
          (item) => item.InvoiceDetailsID === id
        )?.[name];

        setChangedFields((prevState) => {
          const newState = { ...prevState };
          const isChanged = value != initialValue; // Check if the current value differs from the initial value
          console.log(isChanged, "ischangeeeeeeeeeeeeee");
          console.log(initialValue, "ischangeeeeeeeeeeeeee", value);
          if (isChanged) {
            newState[id] = {
              ...prevState[id],
              [name]: true, // Mark as changed
            };
          } else {
            if (newState[id]) {
              delete newState[id][name]; // Remove the changed state if reverted
              if (Object.keys(newState[id]).length === 0) {
                delete newState[id]; // Clean up if no changes remain for this ID
              }
            }
          }

          return newState;
        });
      }
    }
  };
  const handleUpdateLineItem = async (id) => {
    setSaveLoading(true);
    setSaveButtonLoading(true);
    console.log(id, "idddd");
    let filterresult = lineList.filter((rec) => rec.InvoiceDetailsID == id);

    console.log(filterresult, "filterresult");
    const {
      BillingDetailID,
      BillingHeaderID,
      InvoiceDetailsID,
      InvoiceHeaderID,
      BillingType,
      BrokerID,
      Copies,
      Date,
      Description,
      Hours,
      Miles,
      Lodging,
      Misc,
      PerDiem,
      PerDiemRate,
      ProjID,
    } = filterresult[0];
    let postData = {
      invoiceDetailsId: InvoiceDetailsID,
      invoiceHeaderId: InvoiceHeaderID,
      billingHeaderId: BillingHeaderID,
      billingDetailId: BillingDetailID,
      brokerId: BrokerID,
      billingType: BillingType,
      date: moment(Date).utc().format("MM/DD/YYYY"),
      hours: Hours || "0.00",
      perDiem: PerDiem || "0.00",
      // perDiem: calculatePerDiem(Hours, PerDiemRate),
      lodging: Lodging || "0.00",
      miles: Miles || "0",
      misc: Misc || "0.00",
      copies: Copies || "0.00",
      description: Description,
      perDiemRate: PerDiemRate,
      projectId: invoiceProjectIdVal && invoiceProjectIdVal,
      dayRate: parseFloat(filterresult[0]?.DayRate ?? filterresult[0]?.InvoiceDayRate ?? filterresult[0]?.BillableDayRate ?? 0),
      selectedDayRate: normalizeSelectedDayRate(getPersistedSelectedDayRate(filterresult[0])),
    };
    const lineSelection = postData.selectedDayRate;
    const lineRate = resolveExistingLineItemDayRate(
      lineSelection,
      { ...filterresult[0], ...invoiceExistingRateSource },
      projectRateOptions,
      postData.dayRate
    ).dayRate;
    const lineSource = { ...projectRateOptions, ...filterresult[0] };
    Object.assign(
      postData,
      buildExistingLineItemRatePayload(
        lineSelection,
        resolveExistingLineItemDayRate(
          "Billable Rate",
          { ...filterresult[0], ...invoiceExistingRateSource },
          projectRateOptions,
          postData.dayRate
        ).dayRate,
        lineRate,
        filterresult[0]
      )
    );
    const configone = {
      method: "POST",
      url: UPSERT_INVOICE_DETAILS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };

    try {
      const response = await API(configone);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status === "Success") {
        // Extract the full message from the response
        const message = parsedResponse.message;

        // Dynamically extract the project, customer, and date information from the message
        const invoiceUpdateMessage = message.split("\\n")[0]; // The first line contains the static part

        // Extract the rest of the data updates from the message
        const updatedData = message
          .split("\\n") // Split the message into lines by the newline character
          .slice(1) // Ignore the first line as it contains the static part
          .filter((line) => line.includes("updated from")) // Keep only lines that mention updates
          .map((line) => line.trim()); // Clean up extra spaces

        // Format the updates into JSX spans
        const formattedUpdates = updatedData.map((update, index) => (
          <span key={index}>{update}</span>
        ));

        // Create the final toast message dynamically
        // Declare the toastMessage outside the JSX
        let toastMessage = null;

        if (formattedUpdates.length > 0) {
          toastMessage = (
            <>
              <span>{invoiceUpdateMessage}</span>
              <br />
              <span>Data updated was:</span>
              <br />
              {formattedUpdates.map((update, index) => (
                <span key={index}>
                  {update}
                  <br />
                </span>
              ))}
            </>
          );

          // Show the toast with the formatted message
          showToast(toastMessage, "success");
        } else {
          toastMessage = (
            <>
              <span>{invoiceUpdateMessage}</span>
            </>
          );
          showToast(toastMessage, "success");
        }

        // updateHeaderDetails("false");
      }
      setSaveButtonLoading(false);
      // showToast(parsedResponse.message, "success");
      getInvoiceDetails();
      // setChangedFields({})
      setSaveLoading(false);
      setChangedFields({});
      setWarningHighlightColor(false);
      setAddlineItemValue(false);
      setAddressvaluesChanged(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
          getInvoiceDetails();
        }
        setSaveLoading(false);
        setSaveButtonLoading(false);
      }
    }
  };
  console.log(
    typeof previousMileageRate,
    "previousMileageRate",
    parseInt(previousMileageRate)
  );
  const updateDayAndMileageRate = async () => {
    const data = {
      consolidatedProjects: JSON.stringify(values),
      oldMileageRate: parseFloat(savedMilRate) || 0,
      mileageRate: parseFloat(values.mileageRate) || 0,
      oldDayRate: parseFloat(saveDayRate) || 0,
      ...getLineRatePayload(
        values.selectedDayRate,
        projectRateOptions.billableDayRate ?? values.dayRate,
        values.dayRate,
        values
      ),
      ...getAllSelectedRateFields(
        { ...invoiceExistingRateSource, ...values },
        values.selectedDayRate,
        values.dayRate
      ),
      customerId: values.CustomerID,
      projectId: values.ProjectID,
    };
    const config = {
      method: "POST",
      headers: authHeader(),
      url: UPDATE_DAY_AND_MILEAGE_RATE_INVOICE_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        showToast(parsedResponse.message, "success");
        getDayAndMileageRate();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          showToast(v.message, "error");
          getInvoiceDetails();
        } else {
          showToast(v.message, "error");
          getInvoiceDetails();
        }
      }
    }
  };
  console.log(values, "valuessssssssssss");
  const updateHeaderDetails = async (
    Type,
    InvoiceTotal,
    parsedInvoiceDetails,
    invoiceData1,
    dayRateInitial,
    mileageRateInitial,
    selectedDayRateToSave
  ) => {
    console.log(invoiceData1, values, "TypeTypeType", parsedInvoiceDetails);
    const totalValues = {
      perDiemSum: parsedInvoiceDetails?.reduce((acc, item) => {
        return acc + Number(item.PerDiem);
        // return acc + calculatePerDiem(item.Hours, item.PerDiemRate);
      }, 0),

      newPerDiem: parsedInvoiceDetails?.reduce(
        (acc, item) => acc + Number(item.PerDiem),
        0
      ),
      perLodgingSum: parsedInvoiceDetails?.reduce(
        (acc, item) => acc + Number(item.Lodging),
        0
      ),
      perCopiesSum: parsedInvoiceDetails?.reduce(
        (acc, item) => acc + Number(item.Copies),
        0
      ),
      perMiscSum: parsedInvoiceDetails?.reduce(
        (acc, item) => acc + Number(item.Misc),
        0
      ),
      perMilesSum: parsedInvoiceDetails?.reduce(
        (acc, item) => acc + Number(item.Miles),
        0
      ),
      perTotalHoursSum: parsedInvoiceDetails?.reduce(
        (acc, item) => acc + Number(item.Hours),
        0
      ),
    };

    console.log(
      totalValues,
      "totalValuestotalValuestotalValues",
      parsedInvoiceDetails[0]?.BillableDayRate,
      values?.dayRate
    );

    const invoiceRateSource = {
      ...(parsedInvoiceDetails?.[0] || {}),
      ...(invoiceData1 || {}),
      ...invoiceExistingRateSource,
    };
    const invoiceLineChargeTotal = getInvoiceLineChargeTotal(
      parsedInvoiceDetails,
      invoiceRateSource,
      selectedDayRateToSave,
      Type === "day_rate" || Type === "false" ? values.dayRate : undefined
    );

    // Calculate grand total based on different components
    const grandTotal =
      (totalValues.newPerDiem ? parseFloat(totalValues.newPerDiem) : 0) +
      (totalValues.perLodgingSum ? parseFloat(totalValues.perLodgingSum) : 0) +
      (totalValues.perCopiesSum ? parseFloat(totalValues.perCopiesSum) : 0) +
      (totalValues.perMiscSum ? parseFloat(totalValues.perMiscSum) : 0) +
      (totalValues.perMilesSum ? parseFloat(totalValues.perMilesSum) : 0) *
        (values.mileageRate
          ? parseFloat(values.mileageRate)
          : mileageRateInitial
          ? mileageRateInitial
          : 0) + // Wrapped correctly
      invoiceLineChargeTotal;

    // Log the grand total
    console.log("Grand Total:", grandTotal);

    // Log the grand total
    console.log(
      "Grand Thhhhhotal:",
      parsedInvoiceDetails[0]?.BillableDayRate,
      saveDayRate
    );

    const invoiceDate = dayjs.utc(invoiceData1?.InvoiceDate ? invoiceData1?.InvoiceDate : values.invoiceDate); // For ISO dates, no format string is needed
    const createDate = dayjs.utc(invoiceData1?.InvoiceCreateDate ? invoiceData1?.InvoiceCreateDate : values.createDate);

    const invoiceDayRate =
      invoiceExistingRateSource.InvoiceDayRate ??
      invoiceData1?.InvoiceDayRate ??
      parsedInvoiceDetails?.[0]?.InvoiceDayRate ??
      0;

    console.log(invoiceDate, 'jhajhjhjahjhsajhaj')

    const headerRateSource = {
      ...(invoiceData1 || {}),
      ...(parsedInvoiceDetails?.[0] || {}),
      ...projectRateOptions,
      ...invoiceExistingRateSource,
    };
    const headerSelection = normalizeSelectedDayRate(
      selectedDayRateToSave ?? values.selectedDayRate
    );
    const headerBillableRate =
      headerSelection === "Billable Rate" && Type === "day_rate"
        ? formatRateValue(values.dayRate)
        : formatRateValue(invoiceDayRate);
    const headerRatePayload = {
      ...getLineRatePayload(
        headerSelection,
        headerBillableRate,
        values.dayRate,
        headerRateSource
      ),
      ...getAllSelectedRateFields(
        headerRateSource,
        headerSelection,
        values.dayRate
      ),
    };

    const data = {
      invoiceId:
        values?.invoiceNo ||
        parsedInvoiceDetails[0]?.InvoiceHeaderID ||
        invoiceData1?.invoiceId,
      customerId:
        values.CustomerID ||
        parsedInvoiceDetails[0]?.customerId ||
        invoiceData1?.InvoiceCustomerID,
      periodKey:
        values.InvoicePeriodKey ||
        parsedInvoiceDetails[0]?.PeriodKey ||
        invoiceData1?.InvoicePeriodKey,
      projectId:
        values.ProjectID ||
        parsedInvoiceDetails[0]?.ProjID ||
        invoiceData1?.InvoiceProjectID,
      userId: getLogUserId(),
      statusId: values.InvoiceStatusID || invoiceData1?.InvoiceStatusID, //pending
      billingStart:
        values.startDate ||
        moment.utc(invoiceData1?.InvoiceBillingStart).format("MM/DD/YYYY"),
      billingEnd:
        values.endDate ||
        moment.utc(invoiceData1?.InvoiceBillingEnd).format("MM/DD/YYYY"),
      invoiceDate: invoiceDate.format("MM/DD/YYYY"),
      createDate: createDate.format("MM/DD/YYYY"),
      billToStreet1: values.street1 || invoiceData1?.InvoiceBillToStreet1,
      billToStreet2: values.street2 || invoiceData1?.InvoiceBillToStreet2,
      billToCity: values.city || invoiceData1?.InvoiceBillToCity,
      billToState: values.state || invoiceData1?.InvoiceBillToState,
      billToZip: values.zipcode || invoiceData1?.InvoiceBillToZip,
      brokerCount: values.InvoiceBrokerCount
        ? values.InvoiceBrokerCount
        : invoiceData1?.InvoiceBrokerCount || 0,
      brokerHours: totalValues?.perTotalHoursSum
        ? totalValues?.perTotalHoursSum
        : 0,
      ...headerRatePayload,
      perDiem: parseFloat(totalValues.newPerDiem)?.toFixed(2),
      lodging: totalValues.perLodgingSum?.toFixed(2),
      miles: totalValues.perMilesSum,
      misc: totalValues.perMiscSum?.toFixed(2),
      copies: totalValues.perCopiesSum?.toFixed(2),
      mileageRate:
      Type == "mileage_rate"
          ? values.mileageRate
          : Number(
                mileageRateInitial ??
                  invoiceData1?.InvoiceMileageRate ??
                  invoiceExistingRateSource.InvoiceMileageRate ??
                  0
              ).toFixed(3),
      invoiceTotal:
        !isNaN(Number(InvoiceTotal)) &&
        Number(InvoiceTotal) === Number(grandTotal)
          ? Number(InvoiceTotal).toFixed(2)
          : Number(grandTotal).toFixed(2),
      headerIds: null,
      isConsolidated: false,
    };
    const config = {
      method: "POST",
      headers: authHeader(),
      url: UPSERT_INVOICE_STATEMENT_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log(Type, "typeeeeeeeeeee");
      if (parsedResponse.status == "Success") {
        // getInvoiceDetails();
        if (Type == "true") {
          showToast(parsedResponse.message, "success");
        } else if (Type == "day_rate") {
          showToast(
            `The day rate was updated from $${saveDayRate} to $${values?.dayRate} for the billing period from ${values.startDate} to ${values.endDate} in the "${values.projectName}" project.`,
            "success"
          );
          getInvoiceDetails("day_rate");
        } else if (Type == "mileage_rate") {
          showToast(
            `The mileage rate was updated from $${savedMilRate} to $${values?.mileageRate} for the billing period from ${values.startDate} to ${values.endDate} in the "${values.projectName}" project.`,
            "success"
          );
          getInvoiceDetails("mileage_rate");
        } else if (Type == "InvoiceDate") {
          showToast("Invoice date updated successfully", "success");
          getInvoiceDetails("InvoiceDate");
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v.message == "This invoice is closed and cannot be edited.") {
          // showToast(v.message, "error");
          // getInvoiceDetails();
        } else {
          // showToast(v.message, "error");
          // getInvoiceDetails();
        }
      }
    }
  };
  const mileageRateSave = () => {
    if (values.mileageRate !== "") {
      setSaveMileageRateValue(true);
      // updateDayAndMileageRate(); // Ensure this function correctly handles updates
    } else {
      showToast("Mileage Rate is required", "error");
    }
  };

  const handleSaveMileageRateNo = () => {
    setSaveMileageRateValue(false);
    setDetails((prevDetails) => {
      if (prevDetails && prevDetails.length > 0) {
        const updatedDetails = [...prevDetails];
        updatedDetails[0] = {
          ...updatedDetails[0],
          mileageRate: savedMilRate,
        };
        return updatedDetails;
      }
      return prevDetails; // Return the original details if no updates
    });
    setValues((prevDetails) => ({
      ...prevDetails,
      mileageRate: savedMilRate,
    }));
  };

  const handleSaveMileageRateYes = () => {
    if (values.mileageRate !== "") {
      setDetails((prevDetails) => {
        if (prevDetails && prevDetails.length > 0) {
          const updatedDetails = [...prevDetails];
          updatedDetails[0] = {
            ...updatedDetails[0],
            mileageRate: values.mileageRate,
          };
          return updatedDetails;
        }
        return prevDetails; // Return the original details if no updates
      });
      setValues((prevDetails) => ({
        ...prevDetails,
        mileageRate: values.mileageRate,
      }));
      updateHeaderDetails(
        "mileage_rate",
        overAllInvoiceTotal.toFixed(2),
        lineList
      );
      setSaveMileageRateValue(false);
      // updateDayAndMileageRate(); // Ensure this function correctly handles updates
    } else {
      showToast("Mileage Rate is required", "error");
    }
  };

  console.log("DetailsofRecord", details);
  const dayRateSave = () => {
    if (values.dayRate != "") {
      setSaveDayRateValue(true);
    } else {
      showToast("Day Rate is required", "error");
    }
  };

  const handleSaveDayRateNo = () => {
    // Restore the value belonging to the last saved selection. Using only
    // InvoiceDayRate here incorrectly restores the billable/day rate when the
    // saved selection was Principal, Project Manager, or Field Agent.
    const previousDayRate = getDayRateForSelection(
      savedSelectedDayRate,
      invoiceExistingRateSource,
      saveDayRate ?? 0,
      true
    );
    const restoredDayRate = formatPopulatedDayRate(previousDayRate ?? 0);

    restoringSavedDayRateRef.current = true;
    setDetails((prevDetails) =>
      prevDetails?.map((detail) => ({
        ...detail,
        dayRate: restoredDayRate,
        // ID: 0,
      }))
    );
    setValues((prevDetails) => ({
      ...prevDetails,
      dayRate: restoredDayRate,
      selectedDayRate: normalizeSelectedDayRate(savedSelectedDayRate),
    }));
    setSelectedDayRate(normalizeSelectedDayRate(savedSelectedDayRate));
    setSaveDayRateValue(false);
  };

  const handleSaveDayRateYes = () => {
    if (values.dayRate != "") {
    setSavedDayRate(formatRateValue(values.dayRate));
      setSavedSelectedDayRate(normalizeSelectedDayRate(selectedDayRate));
      // setDetails((prevDetails) =>
      //   prevDetails.map((detail) =>
      //     detail.ID === 8 ? { ...detail, dayRate: values.dayRate } : detail
      //   )
      // );
      setDetails((prevDetails) =>
        prevDetails?.map((detail) => ({
          ...detail,
          dayRate: values.dayRate,
          // ID: 0,
        }))
      );
      setValues((prevDetails) => ({
        ...prevDetails,
        dayRate: values.dayRate,
        selectedDayRate,
      }));
      const normalizedSelection = normalizeSelectedDayRate(selectedDayRate);
      const selectedRateFields = getSelectedRateFields(
        normalizedSelection,
        values.dayRate
      );
      setInvoiceExistingRateSource((previous) => ({
        ...previous,
        ...(normalizedSelection === "Billable Rate"
          ? { InvoiceDayRate: values.dayRate }
          : {}),
        ...(normalizedSelection === "Principal Rate"
          ? { selectedPrincipalRate: values.dayRate }
          : {}),
        ...(normalizedSelection === "Project Manager Rate"
          ? { selectedProjectManagerRate: values.dayRate }
          : {}),
        ...(normalizedSelection === "Field Agent Rate"
          ? { selectedFieldAgentRate: values.dayRate }
          : {}),
      }));
      setLineList((previous) =>
        previous.map((line) =>
          normalizeSelectedDayRate(getPersistedSelectedDayRate(line)) ===
          normalizedSelection
            ? {
                ...line,
                dayRate: values.dayRate,
                DayRate: values.dayRate,
                ...selectedRateFields,
              }
            : line
        )
      );
      // setDetails((prevDetails) => {
      //   const updatedDetails = [...prevDetails];
      //   updatedDetails[0] = { ...updatedDetails[0], dayRate: values.dayRate };
      //   return updatedDetails;
      // });
      console.log(overAllInvoiceTotal, "overAllInvoiceTotalshsh");
      updateHeaderDetails(
        "day_rate",
        overAllInvoiceTotal.toFixed(2),
        lineList,
        undefined,
        undefined,
        undefined,
        selectedDayRate
      );
      setSaveDayRateValue(false);
      // updateDayAndMileageRate();
    } else {
      showToast("Day Rate is required", "error");
    }
  };

  const handleChangeDayRate = (e, type) => {
    const value = e.target.value || "";
    // Keep intermediate values valid while the user edits (for example,
    // deleting the leading digit from `1.00` produces `.00`). Rejecting that
    // value makes React restore the old value and moves the caret.
    const regex = /^\d*(\.\d{0,2})?$/;
    console.log(type, "typeeeeeeeeeeeeeee", values.mileageRate);
    if (type === "dayRate") {
      if (regex.test(value) || value === "") {
        setValues((previous) => ({ ...previous, dayRate: value }));

        if (details && details.length > 0) {
          setDetails((prevDetails) => {
            const updatedDetails = [...prevDetails];
            updatedDetails[0] = {
              ...updatedDetails[0],
              dayRate: value,
            };
            return updatedDetails;
          });
        }
      }
    }
  };
  const handleChangeMileageRate = (e, type) => {
    const value = e.target.value || "";
    console.log(type, "typeeeeeeeeeeeeeee", values.mileageRate);
    const regex = /^\d*(\.\d{0,3})?$/;
    if (type === "mileageRate") {
      if (regex.test(value) || value === "") {
        setValues((previous) => ({ ...previous, mileageRate: value }));
        if (details && details.length > 0) {
          setDetails((prevDetails) => {
            const updatedDetails = [...prevDetails];
            updatedDetails[0] = {
              ...updatedDetails[0],
              mileageRate: value,
            };
            return updatedDetails;
          });
        }
      }
    }
  };

  const handleDayRateBlur = () => {
    console.log(savedMilRate, "previousMileageRate98765", values.mileageRate);
    console.log(saveDayRate, "previousMileageRate98765dayrate", values.dayRate);
    if (values.dayRate !== saveDayRate) {
      console.log("LLLLLLLLLL_CALLLLLLL");
      setValues((prevValues) => ({
        ...prevValues,
        dayRate: saveDayRate,
      }));
    }
    if (values.mileageRate !== savedMilRate) {
      // Revert to previous value if the value was changed without saving
      setValues((prevValues) => ({
        ...prevValues,
        mileageRate: savedMilRate,
      }));
    }
  };

  // const handleFocusOut = (e) => {
  //   if (!gridRef.current.contains(e.relatedTarget)) {
  //     // This means that focus has moved out of the grid
  //     handleMileageRateBlur(e);
  //   }
  // };
  const handleDayRateFocusOut = (e) => {
    console.log(
      e.relatedTarget,
      "gajjjjjjjjjjjjaaaaaaa",
      gridRefDay.current.contains(e.relatedTarget)
    );
    if (!gridRefDay.current.contains(e.relatedTarget)) {
      // This means that focus has moved out of the grid
      handleDayRateBlur(e);
    }
  };

  const printInvoice = (r, BillingStatementID) => {
    setBrokerView(true);
    setBrokerDetails(r);
    window.open(`/print-broker-form`, "_blank");
    localStorage.setItem(
      "BILLING_STATEMENT_ID",
      enCryptFun(BillingStatementID.toString())
    );
  };

  // useEffect(() => {
  //   // console.log(invoiceid,'biddddddddddd')
  //   // Check if bid is a number and has more than 3 digits
  //   if (!(/^\d*$/).test(invoiceid)) {
  //     // If bid is invalid (e.g., less than 4 digits), redirect to the dashboard
  //     navigate(PAGE_NOT_FOUND_PATH, { replace: true });
  //   }
  // }, [invoiceid, navigate]);

  const handleNumericCheck = (event) => {
    const { value, name } = event.target;
    const regex = /^\d+(\.\d{0,2})?$/;
    const floatRegex = /^(\d{0,2}(\.\d{0,2})?)$/;
    const floatRegexMiles = /^\d{1,5}$/; // matches numbers between 1 and 5 digits

    // Convert the value to a number if it passes the regex
    console.log(name, "nameeeeeeeeeee");
    const numericValue = parseFloat(value);
    if (name === "hours") {
      if (
        (value === "" || floatRegex.test(value)) &&
        (numericValue <= 24 || value === "")
      ) {
        formik1.setFieldValue(name, value); // Update Formik field value
      }
    } else if (name === "miles") {
      if (
        (value === "" || floatRegexMiles.test(value)) &&
        (numericValue <= 10000 || value === "")
      ) {
        formik1.setFieldValue(name, value); // Update Formik field value
      }
    } else {
      // Check if value is a valid number or empty string
      if (regex.test(value) || value === "") {
        formik1.setFieldValue(name, value); // Update Formik field value
      }
    }
  };

  const handleZipCodeChange = (event) => {
    const { value, name } = event.target;
    const regex = /^[0-9]*$/;

    // Check if value is a valid number or empty string
    if (regex.test(value) || (value === "" && value.length <= 10)) {
      setFieldValue(name, value); // Update Formik field value
    }
  };

  useEffect(() => {
    if (
      updateAddressValues.street1 !== values.street1 ||
      updateAddressValues.street2 !== values.street2 ||
      updateAddressValues.city !== values.city ||
      updateAddressValues.state != values.state ||
      updateAddressValues.zipcode !== values.zipcode
      // saveDayRate != values.dayRate ||
      // savedMilRate != values.mileageRate
    ) {
      setAddressvaluesChanged(true);
    } else {
      setAddressvaluesChanged(false);
    }
  }, [updateAddressValues, values]);

  useEffect(() => {
    if (
      (formik1?.values.brokerId && formik1?.values.brokerId != "") ||
      (formik1?.values.billingType && formik1?.values.billingType != "") ||
      (formik1?.values.hours && formik1?.values.hours != "0.00") ||
      (formik1?.values.miles && formik1?.values.miles != "0") ||
      (formik1?.values.lodging && formik1?.values.lodging != "0.00") ||
      (formik1?.values.copies && formik1?.values.copies != "0.00") ||
      (formik1?.values.description && formik1?.values.description != "") ||
      (formik1?.values.perDiemRate && formik1?.values.perDiemRate != "0.00") ||
      (formik1?.values.misc && formik1?.values.misc != "0.00")
    ) {
      setAddlineItemValue(true);
    } else {
      setAddlineItemValue(false);
    }
  }, [formik1?.values]);

  const handleNoClick = () => {
    setShowWarningpopup(false);
    setWarningHighlightColor(true);
  };
  const handleDeleteInvoiceNoClick = () => {
    // setShowWarningpopup(false);
    setDeletedInvoicePopup(false);
  };

  const handleDeleteInvoiceYesClick = () => {
    // setShowWarningpopup(false);
    setDeletedInvoicePopup(false);
    // const newCompleted = completed;
    // newCompleted[activeStep] = true;
    // setCompleted(newCompleted);
    // setActiveStep(3);
    // setInvoiceStatus(true);
    updateInvoiceStatus(invoiceid, 4, "true");
    setShowWarningpopup(false);
    setAddressvaluesChanged(false);
    setChangedFields({});
    setWarningHighlightColor(false);
    setAddlineItemValue(false);
  };

  const handleYesClick = () => {
    const allAttachedFalse = selectedPeriodList.every(
      (item) => item.IsAttached === false
    );
    // if (overAllInvoiceTotal == 0 && lineList?.length == 0 && allAttachedFalse) {
    //   setDeletedInvoicePopup(true);
    //   setShowWarningpopup(false);
    // } else
    if (backNavigateArrow) {
      navigate(INVOICE_LIST);
    } else if (closeBillingAlert) {
      // const newCompleted = completed;
      // newCompleted[activeStep] = true;
      // setCompleted(newCompleted);
      // setActiveStep(3);
      // setInvoiceStatus(true);
      updateInvoiceStatus(invoiceid, 4);
      setShowWarningpopup(false);
      setAddressvaluesChanged(false);
      setChangedFields({});
      setWarningHighlightColor(false);
      setAddlineItemValue(false);
    } else {
      // const newCompleted = completed;
      // newCompleted[activeStep] = true;
      // setCompleted(newCompleted);
      // setActiveStep(3);
      // setInvoiceStatus(true);
      updateInvoiceStatus(invoiceid, 4);
      setShowWarningpopup(false);
      setAddressvaluesChanged(false);
      setChangedFields({});
      setWarningHighlightColor(false);
      setAddlineItemValue(false);
    }
  };

  const handleNavigateAway = () => {
    // alert('jjjj')
    setShowWarningpopup(true);
    setBackNavigateArrow(true);
    // if (formSaved) {
    //   setFormSaved(false)
    //   // setOpenModal(true);
    // } else {
    //   console.log("Navigating away");
    // }
  };

  useEffect(() => {
    // if (!formSaved && backNavigateArrow) {
    //   setFormSaved(true);
    // }
    // console.log(warningHighlighted, "warningHighlightedwarningHighlighted");
    const handleBeforeUnload = (event) => {
      if (
        addressvaluesChanged ||
        Object.keys(changedFields).length > 0 ||
        addlineItemValue ||
        hasUnsavedDayRate
      ) {
        // setShowWarning(true);
        // Synchronously update state and warn the user
        setWarningHighlightColor(true);
        event.preventDefault(); // Necessary for some browsers to trigger warning
        event.returnValue = ""; // Most browsers will show a generic message
      }
    };

    const handlePopState = (event) => {
      const allAttachedFalse = selectedPeriodList.every(
        (item) => item.IsAttached === false
      );
      // if (
      //   overAllInvoiceTotal == 0 &&
      //   lineList?.length == 0 &&
      //   allAttachedFalse
      // ) {
      //   setDeletedInvoicePopup(true);
      // } else
      if (
        addressvaluesChanged ||
        Object.keys(changedFields).length > 0 ||
        addlineItemValue ||
        hasUnsavedDayRate
      ) {
        setShowWarningpopup(true);
        setWarningHighlightColor(true);
        setBackNavigateArrow(true);
        window.history.pushState(null, null, window.location.href);
      } else {
        // Navigate to the billingstatement page
        window.location.assign("/invoices");
      }
    };

    // Set up event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Initial push state to handle browser back button
    if (
      addressvaluesChanged ||
      Object.keys(changedFields).length > 0 ||
      addlineItemValue ||
      hasUnsavedDayRate
      // (overAllInvoiceTotal == 0 && lineList?.length == 0 && allAttachedFalse)
    ) {
      // setShowWarning(true);
      // setWarningHighlightColor(true);
      // setBackNavigateArrow(true);
      window.history.pushState(null, null, window.location.href);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [addressvaluesChanged, changedFields, addlineItemValue, hasUnsavedDayRate]);

  const allAttachedFalse = selectedPeriodList.every(
    (item) => item.IsAttached === false
  );

  const backRoute = useMemo(() => {
    // if (
    //   overAllInvoiceTotal === 0 &&
    //   lineList?.length === 0 &&
    //   allAttachedFalse
    // ) {
    //   return () => setDeletedInvoicePopup(true);
    // } else
    if (
      addressvaluesChanged ||
      Object.keys(changedFields).length > 0 ||
      addlineItemValue ||
      hasUnsavedDayRate
    ) {
      return handleNavigateAway;
    } else {
      return INVOICE_LIST;
    }
  }, [
    overAllInvoiceTotal,
    lineList,
    allAttachedFalse,
    addressvaluesChanged,
    changedFields,
    addlineItemValue,
    hasUnsavedDayRate,
  ]);

  const handleInvoiceDateClick = (event) => {
    setInvoiceDatePopup(true);
  };
  const handleInvoiceDatePopupUpdate = (event) => {
    updateHeaderDetails(
      "InvoiceDate",
      overAllInvoiceTotal.toFixed(2),
      lineList
    );
    setInvoiceDatePopup(false);
  };
  const handleInvoiceDatePopupClose = (event) => {
    setInvoiceDatePopup(false);
  };

  console.log(getLogUserName(), "LOG_USER_NAMELOG_USER_NAME");
  return (
    <div>
      {loading && <CustomPageLoading />}
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={"5"} />

        <Box
          className="invoice-form-page"
          component="main"
          sx={{ flexGrow: 1, p: "18px 20px" }}
        >
          <Navbar
            title="Invoices"
            backFlag={true}
            backRoute={backRoute}
            //  addressvaluesChanged ||
            //     Object.keys(changedFields).length > 0 ||
            //     addlineItemValue
            //   ? handleNavigateAway
            //   : INVOICE_LIST
            // }
          />

          <Box
            sx={{ mt: "20px", padding: "32px 18px", pt: "0px", pb: "4px" }}
            className="bg-box"
          >
            <div>
              <Accordion className="invoice-tab" defaultExpanded>
                <AccordionSummary
                  sx={{ mt: "10px" }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Billing Statements in Selected Period
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0px 16px 4px" }}>
                  {!attachDetachLoading ? (
                    selectedPeriodList?.length > 0 ? (
                      <>
                        <Box className="datebox-title">
                          {selectedPeriodList
                            .reduce((uniqueValues, value) => {
                              // Check if the current value already exists in the uniqueValues array
                              const isDuplicate = uniqueValues.some(
                                (item) =>
                                  item.ProjectName === value.ProjectName &&
                                  item.BillingStart === value.BillingStart &&
                                  item.BillingEnd === value.BillingEnd &&
                                  value?.BillingHeaderID != 0
                              );

                              // If it's not a duplicate, add it to uniqueValues
                              if (!isDuplicate) {
                                uniqueValues.push(value);
                              }

                              return uniqueValues;
                            }, [])
                            .map((value) => (
                              <Typography
                                key={`${value.ProjectName}-${value.BillingStart}`}
                              >
                                {value.ProjectName}:{" "}
                                {moment(new Date(value.BillingStart))
                                  .utc()
                                  .format("MM/DD/YYYY")}{" "}
                                -{" "}
                                {moment(new Date(value.BillingEnd))
                                  .utc()
                                  .format("MM/DD/YYYY")}
                              </Typography>
                            ))}
                        </Box>

                        <TableContainer className="statement-date-table">
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ minWidth: "100px" }}>
                                  Statement ID
                                </TableCell>
                                <TableCell>Broker Name</TableCell>
                                <TableCell sx={{ minWidth: "50px" }}>
                                  Hours
                                </TableCell>
                                <TableCell sx={{ minWidth: "103px" }}>
                                  Last Modified
                                </TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell sx={{ minWidth: "50px" }}>
                                  Total
                                </TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            {console.log("log", selectedPeriodList)}
                            <TableBody>
                              {selectedPeriodList &&
                                selectedPeriodList
                                  ?.filter(
                                    (item, index, self) =>
                                      index ===
                                      self.findIndex(
                                        (t) =>
                                          t.BillingHeaderID != 0 &&
                                          t.BillingHeaderID ===
                                            item.BillingHeaderID
                                      )
                                  )
                                  .map((r, index) => {
                                    const { BillingHeaderID, AttachedID } = r;
                                    console.log(
                                      r,
                                      "ractiveStepactiveStep",
                                      activeStep
                                    );
                                    return (
                                      <TableRow>
                                        <TableCell>
                                          {r.BillingHeaderID}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            wordBreak: "break-all",
                                            minWidth: "222px",
                                            maxWidth: "222px",
                                          }}
                                        >
                                          {r.BrokerName}
                                        </TableCell>
                                        <TableCell>
                                          {r.Hours?.toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                          {moment(new Date(r.LastModified))
                                            .utc()
                                            .format("MM/DD/YYYY")}
                                        </TableCell>
                                        <TableCell>
                                          {r.StatusID == 3
                                            ? "Invoice started"
                                            : ""}
                                          {r.StatusID == 2
                                            ? "Statement Closed"
                                            : ""}
                                          {r.StatusID == 1
                                            ? "Statement Open"
                                            : ""}
                                          {r.StatusID == 4
                                            ? "Invoice Closed"
                                            : ""}
                                        </TableCell>
                                        <TableCell>
                                          ${r?.Total?.toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                          <Stack
                                            className="action-icons"
                                            direction="row"
                                            spacing={1}
                                          >
                                            <Tooltip
                                              arrow
                                              className="project-tooltip"
                                              title="Click here to get all attachments for this statement."
                                              placement="top"
                                            >
                                              {downloadLoading ? (
                                                <Box class="download-btn-disable">
                                                  <DownloadIcon
                                                    style={{
                                                      background:
                                                        "#d5d5d6 !important",
                                                      important: "true",
                                                    }}
                                                  />
                                                </Box>
                                              ) : (
                                                <img
                                                  src={Download}
                                                  onClick={() => {
                                                    // if (invoiceStatus == true) {
                                                    //   showToast(
                                                    //     "This invoice has been closed and can no longer be edited.",
                                                    //     "reopenInvoice"
                                                    //   );
                                                    // } else {
                                                    getInvoiceAttachments(
                                                      r.ProjID,
                                                      r.UserID,
                                                      r.PeriodKey,
                                                      "download",
                                                      r
                                                    );
                                                    // }
                                                  }}
                                                />
                                              )}
                                            </Tooltip>
                                            <Tooltip
                                              arrow
                                              className="project-tooltip"
                                              title="Click here to print this statement."
                                              placement="top"
                                            >
                                              <img
                                                src={Print}
                                                onClick={() => {
                                                  if (BillingHeaderID) {
                                                    window.open(
                                                      `/print-billing-statement/${BillingHeaderID}`,
                                                      "_blank"
                                                    );
                                                  }
                                                  // printInvoice(r, BillingStatementID);
                                                }}
                                              />
                                            </Tooltip>
                                            {invoiceStatus == true ? (
                                              <></>
                                            ) : r.IsAttached == false ? (
                                              <Tooltip
                                                arrow
                                                className="project-tooltip"
                                                title="Click here to attach this statement to the invoice. This will import all details for this statement."
                                                placement="top"
                                              >
                                                <img
                                                  src={AttachmentGreen}
                                                  onClick={() => {
                                                    handleAttach(
                                                      BillingHeaderID,
                                                      AttachedID,
                                                      r.IsAttached,
                                                      r.BrokerName,
                                                      r.ProjectName,
                                                      r.ProjID,
                                                      r.customerId
                                                    );
                                                  }}
                                                />
                                              </Tooltip>
                                            ) : (
                                              <Tooltip
                                                arrow
                                                className="project-tooltip"
                                                title="Click here to detach this statement from the invoice. This will REMOVE all details from this invoice."
                                                placement="top"
                                              >
                                                <img
                                                  src={AttachmentRed}
                                                  onClick={() => {
                                                    handleDetach(
                                                      BillingHeaderID,
                                                      AttachedID,
                                                      r.IsAttached,
                                                      r.BrokerName,
                                                      r.ProjectName,
                                                      r.ProjID,
                                                      r.customerId
                                                    );
                                                  }}
                                                  // onClick={() => {
                                                  //   getInvoiceAttachments(
                                                  //     r.ProjID,
                                                  //     r.UserID,
                                                  //     r.PeriodKey,
                                                  //     "detach"
                                                  //   );
                                                  // }}
                                                />
                                              </Tooltip>
                                            )}
                                          </Stack>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}

                              {selectedNewPeriodList &&
                                selectedNewPeriodList?.map((rn, index) => {
                                  const { statementId } = rn;
                                  return (
                                    <TableRow>
                                      <TableCell>{rn.statementId}</TableCell>
                                      <TableCell
                                        sx={{
                                          wordBreak: "break-all",
                                          minWidth: "222px",
                                          maxWidth: "222px",
                                        }}
                                      >
                                        {rn.BrokerName}
                                      </TableCell>
                                      <TableCell>{rn.Hours}</TableCell>
                                      <TableCell>
                                        {moment(new Date(rn.LastModified))
                                          .utc()
                                          .format("MM/DD/YYYY")}
                                      </TableCell>
                                      <TableCell>
                                        {rn.StatusID == 3
                                          ? "Invoice started"
                                          : ""}
                                        {rn.StatusID == 2
                                          ? "Statement Closed"
                                          : ""}
                                        {rn.StatusID == 1
                                          ? "Statement Open"
                                          : ""}
                                        {rn.StatusID == 4
                                          ? "Invoice Closed"
                                          : ""}
                                      </TableCell>
                                      <TableCell>${rn.Total}</TableCell>
                                      <TableCell>
                                        <Stack
                                          className="action-icons"
                                          direction="row"
                                          spacing={1}
                                        >
                                          <Tooltip
                                            arrow
                                            className="project-tooltip"
                                            title="Click here to get all attachments for this statement."
                                            placement="top"
                                          >
                                            {downloadLoading ? (
                                              <Box class="download-btn-disable">
                                                <DownloadIcon
                                                  style={{
                                                    background:
                                                      "#d5d5d6 !important",
                                                    important: "true",
                                                  }}
                                                />
                                              </Box>
                                            ) : (
                                              <img
                                                src={Download}
                                                onClick={() => {
                                                  // if (invoiceStatus == true) {
                                                  //   showToast(
                                                  //     "This invoice has been closed and can no longer be edited.",
                                                  //     "reopenInvoice"
                                                  //   );
                                                  // } else {
                                                  getInvoiceAttachments(
                                                    rn.ProjID,
                                                    rn.UserID,
                                                    rn.PeriodKey,
                                                    "download",
                                                    r
                                                  );
                                                  // }
                                                }}
                                              />
                                            )}
                                          </Tooltip>
                                          <Tooltip
                                            arrow
                                            className="project-tooltip"
                                            title="Click here to print this statement."
                                            placement="top"
                                          >
                                            <img
                                              src={Print}
                                              onClick={() => {
                                                if (BillingHeaderID) {
                                                  window.open(
                                                    `/print-billing-statement/${BillingHeaderID}`,
                                                    "_blank"
                                                  );
                                                }
                                                // printInvoice(r, BillingStatementID);
                                              }}
                                            />
                                          </Tooltip>

                                          {invoiceStatus == true ? (
                                            <></>
                                          ) : rn.isAttached == false ? (
                                            <Tooltip
                                              arrow
                                              className="project-tooltip"
                                              title="Click here to attach this statement to the invoice. This will import all details for this statement."
                                              placement="top"
                                            >
                                              <img
                                                src={AttachmentGreen}
                                                onClick={() => {
                                                  handleAttach(
                                                    statementId,
                                                    // AttachedID,
                                                    rn.isAttached,
                                                    rn.BrokerName,
                                                    // rn.ProjectName,
                                                    rn.ProjID
                                                    // rn.customerId
                                                  );
                                                }}
                                              />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              arrow
                                              className="project-tooltip"
                                              title="Click here to detach this statement from the invoice. This will REMOVE all details from this invoice."
                                              placement="top"
                                            >
                                              <img
                                                src={AttachmentRed}
                                                onClick={() => {
                                                  handleDetach(
                                                    statementId,
                                                    // AttachedID,
                                                    rn.isAttached,
                                                    rn.BrokerName,
                                                    // rn.ProjectName,
                                                    rn.ProjID
                                                    // r.customerId
                                                  );
                                                }}
                                                // onClick={() => {
                                                //   getInvoiceAttachments(
                                                //     r.ProjID,
                                                //     r.UserID,
                                                //     r.PeriodKey,
                                                //     "detach"
                                                //   );
                                                // }}
                                              />
                                            </Tooltip>
                                          )}
                                        </Stack>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : selectedNewPeriodList?.length > 0 ? (
                      <>
                        <Box className="datebox-title">
                          {selectedNewPeriodList
                            .reduce((uniqueValues, value) => {
                              // Check if the current value already exists in the uniqueValues array
                              const isDuplicate = uniqueValues.some(
                                (item) =>
                                  item.ProjectName === value.ProjectName &&
                                  item.BillingStart === value.BillingStart &&
                                  item.BillingEnd === value.BillingEnd &&
                                  item?.BillingHeaderID != 0
                              );

                              // If it's not a duplicate, add it to uniqueValues
                              if (!isDuplicate) {
                                uniqueValues.push(value);
                              }

                              return uniqueValues;
                            }, [])
                            .map((value) => (
                              <Typography
                                key={`${value.ProjectName}-${value.BillingStart}`}
                              >
                                {value.ProjectName}:{" "}
                                {moment(new Date(value.BillingStart))
                                  .utc()
                                  .format("MM/DD/YYYY")}{" "}
                                -{" "}
                                {moment(new Date(value.BillingEnd))
                                  .utc()
                                  .format("MM/DD/YYYY")}
                              </Typography>
                            ))}
                        </Box>

                        <TableContainer className="statement-date-table">
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ minWidth: "100px" }}>
                                  Statement ID
                                </TableCell>
                                <TableCell>Broker Name</TableCell>
                                <TableCell sx={{ minWidth: "50px" }}>
                                  Hours
                                </TableCell>
                                <TableCell sx={{ minWidth: "103px" }}>
                                  Last Modified
                                </TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell sx={{ minWidth: "50px" }}>
                                  Total
                                </TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {selectedNewPeriodList &&
                                selectedNewPeriodList?.map((rn, index) => {
                                  const { statementId } = rn;
                                  return (
                                    <TableRow>
                                      <TableCell>{rn.statementId}</TableCell>
                                      <TableCell
                                        sx={{
                                          wordBreak: "break-all",
                                          minWidth: "222px",
                                          maxWidth: "222px",
                                        }}
                                      >
                                        {rn.BrokerName}
                                      </TableCell>
                                      <TableCell>
                                        {rn.Hours?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        {moment(new Date(rn.LastModified))
                                          .utc()
                                          .format("MM/DD/YYYY")}
                                      </TableCell>
                                      <TableCell>
                                        {rn.StatusID == 3
                                          ? "Invoice started"
                                          : ""}
                                        {rn.StatusID == 2
                                          ? "Statement Closed"
                                          : ""}
                                        {rn.StatusID == 1
                                          ? "Statement Open"
                                          : ""}
                                        {rn.StatusID == 4
                                          ? "Invoice Closed"
                                          : ""}
                                      </TableCell>
                                      <TableCell>${rn.Total}</TableCell>
                                      <TableCell>
                                        <Stack
                                          className="action-icons"
                                          direction="row"
                                          spacing={1}
                                        >
                                          <Tooltip
                                            arrow
                                            className="project-tooltip"
                                            title="Click here to get all attachments for this statement."
                                            placement="top"
                                          >
                                            {downloadLoading ? (
                                              <Box class="download-btn-disable">
                                                <DownloadIcon
                                                  style={{
                                                    background:
                                                      "#d5d5d6 !important",
                                                    important: "true",
                                                  }}
                                                />
                                              </Box>
                                            ) : (
                                              <img
                                                src={Download}
                                                onClick={() => {
                                                  // if (invoiceStatus == true) {
                                                  //   showToast(
                                                  //     "This invoice has been closed and can no longer be edited.",
                                                  //     "reopenInvoice"
                                                  //   );
                                                  // } else {
                                                  getInvoiceAttachments(
                                                    rn.ProjID,
                                                    rn.UserID,
                                                    rn.PeriodKey,
                                                    "download",
                                                    r
                                                  );
                                                  // }
                                                }}
                                              />
                                            )}
                                          </Tooltip>
                                          <Tooltip
                                            arrow
                                            className="project-tooltip"
                                            title="Click here to print this statement."
                                            placement="top"
                                          >
                                            <img
                                              src={Print}
                                              onClick={() => {
                                                if (BillingHeaderID) {
                                                  window.open(
                                                    `/print-billing-statement/${BillingHeaderID}`,
                                                    "_blank"
                                                  );
                                                }
                                                // printInvoice(r, BillingStatementID);
                                              }}
                                            />
                                          </Tooltip>

                                          {invoiceStatus == true ? (
                                            <></>
                                          ) : rn.isAttached == false ? (
                                            <Tooltip
                                              arrow
                                              className="project-tooltip"
                                              title="Click here to attach this statement to the invoice. This will import all details for this statement."
                                              placement="top"
                                            >
                                              <img
                                                src={AttachmentGreen}
                                                onClick={() => {
                                                  handleAttach(
                                                    statementId,
                                                    // AttachedID,
                                                    rn.isAttached,
                                                    rn.BrokerName,
                                                    // rn.ProjectName,
                                                    rn.ProjID
                                                    // rn.customerId
                                                  );
                                                }}
                                              />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              arrow
                                              className="project-tooltip"
                                              title="Click here to detach this statement from the invoice. This will REMOVE all details from this invoice."
                                              placement="top"
                                            >
                                              <img
                                                src={AttachmentRed}
                                                onClick={() => {
                                                  handleDetach(
                                                    statementId,
                                                    // AttachedID,
                                                    rn.isAttached,
                                                    rn.BrokerName,
                                                    // rn.ProjectName,
                                                    rn.ProjID
                                                    // r.customerId
                                                  );
                                                }}
                                                // onClick={() => {
                                                //   getInvoiceAttachments(
                                                //     r.ProjID,
                                                //     r.UserID,
                                                //     r.PeriodKey,
                                                //     "detach"
                                                //   );
                                                // }}
                                              />
                                            </Tooltip>
                                          )}
                                        </Stack>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : (
                      <>
                        <Box className="datebox-title">
                          <Typography
                            key={`${
                              billingStatementHeading &&
                              billingStatementHeading.ProjectName
                            }-${
                              billingStatementHeading &&
                              billingStatementHeading.InvoiceBillingEnd
                            }`}
                          >
                            {billingStatementHeading &&
                              billingStatementHeading.ProjectName}
                            :{" "}
                            {billingStatementHeading &&
                            billingStatementHeading.InvoiceBillingStart
                              ? moment(
                                  new Date(
                                    billingStatementHeading.InvoiceBillingStart
                                  )
                                ).format("MM/DD/YYYY")
                              : ""}{" "}
                            -{" "}
                            {billingStatementHeading &&
                            billingStatementHeading.InvoiceBillingEnd
                              ? moment(
                                  new Date(
                                    billingStatementHeading &&
                                      billingStatementHeading.InvoiceBillingEnd
                                  )
                                )
                                  .utc()
                                  .format("MM/DD/YYYY")
                              : ""}
                          </Typography>
                        </Box>
                        <Typography
                          sx={{ marginTop: "10px", marginBottom: "10px" }}
                        >
                          No invoice found for the selected period.
                        </Typography>
                      </>
                    )
                  ) : (
                    <AccordionDetails
                      sx={{
                        padding: "0px 16px 4px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%", // Optional: set height to fill the container
                      }}
                      key={1}
                    >
                      <CircularProgress disableShrink />
                    </AccordionDetails>
                  )}
                </AccordionDetails>
              </Accordion>
            </div>
          </Box>
          <Grid
            container
            rowSpacing={1}
            columnspacing={{ xs: 1, sm: 1.5, md: 1.5 }}
          >
            <Grid xs={12} md={9}>
              <Box
                sx={{
                  p: "16px 17px",
                  pb: "9px",
                  mt: "22px",
                }}
                className="bg-box"
              >
                <Box
                  sx={{
                    position: { xs: "unset", sm: "sticky" },
                    top: "0px",
                    zIndex: 9,
                    borderBottom: "12px solid #fff",
                    paddingTop: "16px",
                    borderTop: "12px solid #fff",
                    marginTop: "-12px",
                    borderRadius: "0px",
                  }}
                  className="billing-box"
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography className="billing-title">
                      Invoice No:
                    </Typography>
                    <Typography
                      sx={{ background: "#58A84A" }}
                      className="bill-date"
                    >
                      #{values.invoiceNo}
                    </Typography>
                  </Stack>
                  <Stack
                    sx={{ mt: "15px" }}
                    direction={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "flex-end", sm: "center" }}
                    spacing={{ xs: 2, sm: 3 }}
                  >
                    <FormControl
                      className="consolidated-date"
                      sx={{ width: "100%" }}
                      variant="standard"
                    >
                      <p className="label">Invoice Date: </p>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DemoItem>
                            <DatePicker
                              disabled={invoiceStatus}
                              // defaultValue={yesterday}
                              name="invoiceDate"
                              // disablePast
                              views={["year", "month", "day"]}
                              // // onChange={handleChangeDate}
                              // onChange={(e) => {
                              //   handleChangeDate(e, "invoiceDate");
                              // }}
                              // value={values.invoiceDate}
                              // Handle change and ensure the date is stored/handled in UTC
                              onChange={(newValue) => {
                                const utcDate = dayjs.utc(newValue); // Convert selected date to UTC
                                handleChangeDate(utcDate, "invoiceDate");
                              }}
                              // Ensure the value is in UTC when displayed
                              value={
                                values.invoiceDate
                                  ? dayjs.utc(values.invoiceDate)
                                  : todayUtc
                              }
                            />
                          </DemoItem>
                        </DemoContainer>
                      </LocalizationProvider>
                      <FormHelperText error={true}>
                        {dateFormatError}
                      </FormHelperText>
                    </FormControl>
                    <Button
                      sx={{ mt: "3% !important", marginLeft: "9px !important" }}
                      className={
                        invoiceStatus ||
                        dateFormatError !== "" ||
                        dayjs(periousInvoiceDate).isSame(
                          dayjs(values.invoiceDate),
                          "day"
                        ) // Use isSame for date comparison
                          ? "disable-filter-btn"
                          : "primary-btn"
                      }
                      disabled={
                        invoiceStatus ||
                        dateFormatError !== "" ||
                        dayjs(periousInvoiceDate).isSame(
                          dayjs(values.invoiceDate),
                          "day"
                        ) // Use isSame for disabling logic
                      }
                      onClick={handleInvoiceDateClick}
                    >
                      Save
                    </Button>
                    <FormControl
                      className="consolidated-date"
                      sx={{ width: "100%" }}
                      variant="standard"
                    >
                      <p className="label">Create Date: </p>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DemoItem>
                            <DatePicker
                              disabled
                              disablePast
                              views={["year", "month", "day"]}
                              onChange={(e) => {
                                handleChangeDate(e, "createDate");
                              }}
                              value={values.createDate}
                            />
                          </DemoItem>
                        </DemoContainer>
                      </LocalizationProvider>
                    </FormControl>
                    <Box className="invoice-total">
                      <Typography className="invoice-total-title">
                        Invoice Total:
                      </Typography>
                      <Typography className="invoice-total-amount">
                        ${overAllInvoiceTotal.toFixed(2)}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
                <Box sx={{ width: "100%", mt: "-6px" }}>
                  <Stepper
                    className="bill-stepper"
                    nonLinear
                    activeStep={activeStep}
                  >
                    {steps.map((label, index) => {
                      return (
                        <Step key={label} completed={completed[index]}>
                          <StepButton
                            className={activeStep == index ? "step-active" : ""}
                            color="inherit"
                            onClick={handleStep(index)}
                          >
                            {index < activeStep ? (
                              // {completed[index] && index === 0 ? (
                              <img src={CircleGreenIconSvg} alt="Completed" />
                            ) : (
                              <CircleIcon />
                            )}
                            {label}
                          </StepButton>
                        </Step>
                      );
                    })}
                  </Stepper>

                  <Typography sx={{ mt: "7px", mb: 1, py: 1, pt: 0 }}>
                    <Box className="billing-box">
                      <Grid
                        sx={{ ml: "0 !important", mt: "0px !important" }}
                        container
                        rowSpacing={3}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <Grid className="bill-fieldsbox" xs={12} md={5}>
                          <Typography className="bill-to-title">
                            Bill to: {values && values?.CustomerName}
                          </Typography>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">Street 1:</p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <TextField
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      border:
                                        updateAddressValues.street1 !==
                                          values.street1 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Default border color
                                    },
                                    "&:hover fieldset": {
                                      borderBottom:
                                        updateAddressValues.street1 !==
                                          values.street1 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when hovered
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderBottom:
                                        updateAddressValues.street1 !==
                                          values.street1 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when focused
                                    },
                                  },
                                }}
                                id="outlined-multiline-static"
                                disabled={invoiceStatus}
                                name="street1"
                                onChange={handleChange}
                                value={values.street1}
                                error={errors.street1 && touched.street1}
                                helperText={
                                  errors.street1 && touched.street1
                                    ? errors.street1
                                    : ""
                                }
                                inputProps={{
                                  maxLength: 250, // Restrict input length to 250 characters
                                }}
                              />
                            </FormControl>
                          </Stack>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">Street 2:</p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <TextField
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      border:
                                        updateAddressValues.street2 !==
                                          values.street2 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Default border color
                                    },
                                    "&:hover fieldset": {
                                      borderBottom:
                                        updateAddressValues.street2 !==
                                          values.street2 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when hovered
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderBottom:
                                        updateAddressValues.street2 !==
                                          values.street2 &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when focused
                                    },
                                  },
                                }}
                                disabled={invoiceStatus}
                                id="outlined-multiline-static"
                                defaultValue=""
                                name="street2"
                                onChange={handleChange}
                                value={values.street2}
                                error={errors.street2 && touched.street2}
                                helperText={
                                  errors.street2 && touched.street2
                                    ? errors.street2
                                    : ""
                                }
                                inputProps={{
                                  maxLength: 250, // Restrict input length to 250 characters
                                }}
                              />
                            </FormControl>
                          </Stack>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">City:</p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <TextField
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      border:
                                        updateAddressValues.city !==
                                          values.city && warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Default border color
                                    },
                                    "&:hover fieldset": {
                                      borderBottom:
                                        updateAddressValues.city !==
                                          values.city && warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when hovered
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderBottom:
                                        updateAddressValues.city !==
                                          values.city && warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when focused
                                    },
                                  },
                                }}
                                id="city"
                                disabled={invoiceStatus}
                                defaultValue=""
                                name="city"
                                onChange={handleChange}
                                value={values.city}
                                error={errors.city && touched.city}
                                helperText={
                                  errors.city && touched.city ? errors.city : ""
                                }
                                inputProps={{
                                  maxLength: 50, // Restrict input length to 250 characters
                                }}
                              />
                            </FormControl>
                          </Stack>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">State:</p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <Select
                                sx={{
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border:
                                      updateAddressValues.state !==
                                        values.state && warningHighlightColor
                                        ? "1px solid yellow"
                                        : "", // Conditionally apply yellow border
                                    borderWidth:
                                      updateAddressValues.state !==
                                        values.state && warningHighlightColor
                                        ? "1px"
                                        : "", // Adjust border width if needed
                                    outline:
                                      updateAddressValues.state !==
                                        values.state && warningHighlightColor
                                        ? "1px solid yellow"
                                        : "",
                                  },
                                  "& .MuiSelect-select": {
                                    borderColor:
                                      updateAddressValues.state !==
                                        values.state && warningHighlightColor
                                        ? "1px solid yellow"
                                        : "", // Border color on hover
                                  },
                                }}
                                className="invoice-state-field per-diem-rate-field"
                                name="state"
                                onChange={handleChange}
                                disabled={invoiceStatus}
                                // value={
                                //   values && values?.state ? values?.state : 0
                                // }
                                value={
                                  values && values.state ? values.state : ""
                                }
                                autoWidth
                                label="State"
                                error={errors.state && touched.state}
                                helperText={
                                  errors.state && touched.state
                                    ? errors.state
                                    : ""
                                }
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {stateList &&
                                  JSON.parse(stateList)?.data?.map((item) => (
                                    <MenuItem
                                      key={item?.countyId}
                                      value={item?.countyId}
                                    >
                                      {item?.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                              {errors.state && touched.state && (
                                <FormHelperText error={true}>
                                  {errors.state}
                                </FormHelperText>
                              )}
                            </FormControl>
                          </Stack>
                          <Stack
                            sx={{ mt: "10px" }}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            alignItems={{ xs: "baseline", sm: "center" }}
                          >
                            <p className="label">Zipcode: </p>
                            <FormControl
                              sx={{
                                minWidth: "100px",
                              }}
                              variant="standard"
                            >
                              <TextField
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      border:
                                        updateAddressValues.zipcode !==
                                          values.zipcode &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Default border color
                                    },
                                    "&:hover fieldset": {
                                      borderBottom:
                                        updateAddressValues.zipcode !==
                                          values.zipcode &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when hovered
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderBottom:
                                        updateAddressValues.zipcode !==
                                          values.zipcode &&
                                        warningHighlightColor
                                          ? "1px solid yellow"
                                          : "", // Border color when focused
                                    },
                                  },
                                }}
                                id="outlined-multiline-static"
                                defaultValue=""
                                disabled={invoiceStatus}
                                name="zipcode"
                                onChange={handleZipCodeChange}
                                value={values.zipcode}
                                error={errors.zipcode && touched.zipcode}
                                helperText={
                                  errors.zipcode && touched.zipcode
                                    ? errors.zipcode
                                    : ""
                                }
                              />
                            </FormControl>
                          </Stack>
                          <Button
                            sx={{
                              mt: "12px",
                              ml: { xs: "0px", sm: "74px" },
                              mb: { xs: "20px", sm: "0px" },
                            }}
                            className={
                              invoiceStatus || addressvaluesChanged == false
                                ? "disable-filter-btn"
                                : "primary-btn"
                            }
                            onClick={handleSubmit}
                            disabled={
                              invoiceStatus || addressvaluesChanged == false
                            }
                          >
                            Save bill to address
                          </Button>
                        </Grid>
                        <Grid xs={12} md={7}>
                          <Grid
                            sx={{ ml: "0 !important", mt: "0px !important" }}
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                          >
                            <Grid xs={12} md={6}>
                              <Typography className="state-titles">
                                Per Diem:
                              </Typography>
                              <Typography className="state-values">
                                $
                                {values?.totalPerDiem
                                  ? parseFloat(values.totalPerDiem).toFixed(2)
                                  : "0.00"}
                              </Typography>
                              <Typography
                                sx={{ position: "relative" }}
                                className="state-titles"
                              >
                                Mileage:
                                <span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                      cursor: "pointer",
                                    }}
                                    aria-owns={
                                      open ? "mouse-over-popover" : undefined
                                    }
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpen2}
                                    onMouseLeave={handlePopoverClose2}
                                    className="material-symbols-outlined"
                                  >
                                    
                                    help
                                  </span>
                                </span>
                              </Typography>
                              <Popover
                                className="charges-box"
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={open2}
                                anchorEl={anchorEl2}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                onClose={handlePopoverClose}
                                disableRestoreFocus
                              >
                                <Typography className="charges-title">
                                  Mileage Charges
                                </Typography>
                                <Box>
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      {values && values.totalMiles}
                                    </Typography>
                                    <Typography className="charge-text">
                                      miles
                                    </Typography>
                                  </Box>
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      x $
                                      {savedMilRate && savedMilRate
                                        ? savedMilRate
                                        : 0}
                                    </Typography>
                                    <Typography className="charge-text">
                                      per mile
                                    </Typography>
                                  </Box>
                                  <Divider
                                    sx={{
                                      borderColor: "#F2F4F8",
                                      margin: "5px 0px",
                                    }}
                                  />
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      $
                                      {values &&
                                      savedMilRate &&
                                      values.totalMiles
                                        ? (
                                            values.totalMiles * savedMilRate
                                          ).toFixed(3)
                                        : parseInt("0.000")}
                                    </Typography>
                                    <Typography className="charge-text">
                                      total charge
                                    </Typography>
                                  </Box>
                                </Box>
                              </Popover>
                              <Typography className="state-values">
                                $
                                {values
                                  ? (values.totalMiles * savedMilRate).toFixed(
                                      3
                                    )
                                  : parseInt("0.00")}
                              </Typography>
                              {/*                              
                              <Typography className="state-titles">
                                Mileage Rate: 
                              </Typography>
                              <Typography
                                sx={{ mb: "0 !important" }}
                                className="state-values"
                              >
                                test{" "}
                              </Typography> */}
                            </Grid>
                            <Grid xs={12} md={6}>
                              <Typography className="state-titles">
                                Expenses:
                                <span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    aria-owns={
                                      open ? "mouse-over-popover" : undefined
                                    }
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpen}
                                    onMouseLeave={handlePopoverClose}
                                    className="material-symbols-outlined"
                                  >
                                    help
                                  </span>
                                </span>
                              </Typography>
                              <Popover
                                className="charges-box"
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={open}
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                onClose={handlePopoverClose}
                                disableRestoreFocus
                              >
                                <Typography className="charges-title">
                                  Expenses Charges
                                </Typography>
                                <Box>
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      $
                                      {values && values.totalLodging
                                        ? values.totalLodging.toFixed(2)
                                        : "0"}
                                    </Typography>
                                    <Typography className="charge-text">
                                      lodging
                                    </Typography>
                                  </Box>
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      $
                                      {values && values.totalCopies
                                        ? values.totalCopies.toFixed(2)
                                        : "0"}
                                    </Typography>
                                    <Typography className="charge-text">
                                      copies
                                    </Typography>
                                  </Box>
                                  <Divider
                                    sx={{
                                      borderColor: "#F2F4F8",
                                      margin: "5px 0px",
                                    }}
                                  />
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      + $
                                      {values && values.totalMisc
                                        ? values.totalMisc.toFixed(2)
                                        : "0"}
                                    </Typography>
                                    <Typography className="charge-text">
                                      misc
                                    </Typography>
                                  </Box>

                                  <Box className="time-flexbox time-btn">
                                    <Typography className="charge-price total-charge">
                                      $
                                      {(values && values.totalLodging) ||
                                      values.totalCopies ||
                                      values.totalMisc
                                        ? (
                                            values.totalLodging +
                                            values.totalCopies +
                                            values.totalMisc
                                          ).toFixed(2)
                                        : "0"}
                                    </Typography>
                                    <Typography className="charge-text">
                                      total charge
                                    </Typography>
                                  </Box>
                                </Box>
                              </Popover>
                              <Typography className="state-values">
                                $
                                {(values && values.totalLodging) ||
                                values.totalCopies ||
                                values.totalMisc
                                  ? (
                                      values.totalLodging +
                                      values.totalCopies +
                                      values.totalMisc
                                    ).toFixed(2)
                                  : "0"}
                              </Typography>

                              <Typography className="state-titles">
                                Charges:
                                <span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    aria-owns={
                                      open3 ? "mouse-over-popover" : undefined
                                    }
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpen3}
                                    onMouseLeave={handlePopoverClose3}
                                    className="material-symbols-outlined"
                                  >
                                    help
                                  </span>
                                </span>
                              </Typography>
                              <Popover
                                className="charges-box"
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={open3}
                                anchorEl={anchorEl3}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                onClose={handlePopoverClose3}
                                disableRestoreFocus
                              >
                                <Typography className="charges-title">
                                  Charges
                                </Typography>
                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns: {
                                      xs: "minmax(0, 1fr)",
                                      sm:
                                        invoiceLineChargeBreakdown.length > 1
                                          ? "repeat(2, minmax(150px, 1fr))"
                                          : "minmax(150px, 1fr)",
                                    },
                                    gap: 1,
                                    width: {
                                      xs: "100%",
                                      sm:
                                        invoiceLineChargeBreakdown.length > 1
                                          ? "100%"
                                          : "50%",
                                    },
                                    minWidth: {
                                      xs: 0,
                                      sm:
                                        invoiceLineChargeBreakdown.length > 1
                                          ? 320
                                          : 150,
                                    },
                                  }}
                                >
                                  {invoiceLineChargeBreakdown.map((rate) => (
                                    <Box
                                      key={rate.selection}
                                      sx={{
                                        border: "1px solid #F2F4F8",
                                        borderRadius: "4px",
                                        p: 1,
                                      }}
                                    >
                                      <Typography
                                        className="charges-title"
                                        sx={{ fontSize: "12px", mb: 0.75 }}
                                      >
                                        {rate.label}
                                      </Typography>
                                      <Box className="time-flexbox">
                                        <Typography className="charge-price">
                                          {rate.hours.toFixed(2)}
                                        </Typography>
                                        <Typography className="charge-text">
                                          hours
                                        </Typography>
                                      </Box>
                                      <Box className="time-flexbox">
                                        <Typography className="charge-price">
                                          /8
                                        </Typography>
                                        <Typography className="charge-text">
                                          hour work day
                                        </Typography>
                                      </Box>
                                      <Divider
                                        sx={{
                                          borderColor: "#F2F4F8",
                                          margin: "5px 0px",
                                        }}
                                      />
                                      <Box className="time-flexbox">
                                        <Typography className="charge-price">
                                          {rate.billableDays.toFixed(3)}
                                        </Typography>
                                        <Typography className="charge-text">
                                          billable days
                                        </Typography>
                                      </Box>
                                      <Box className="time-flexbox">
                                        <Typography className="charge-price">
                                          {rate.rate.toFixed(2)}
                                        </Typography>
                                        <Typography className="charge-text">
                                          day rate
                                        </Typography>
                                      </Box>
                                      <Divider
                                        sx={{
                                          borderColor: "#F2F4F8",
                                          margin: "5px 0px",
                                        }}
                                      />
                                      <Box className="time-flexbox time-btn">
                                        <Typography className="charge-price total-charge">
                                          ${rate.charge.toFixed(2)}
                                        </Typography>
                                        <Typography className="charge-text">
                                          billable
                                        </Typography>
                                      </Box>
                                    </Box>
                                  ))}
                                </Box>
                                <Box className="time-flexbox time-btn" sx={{ mt: 1 }}>
                                  <Typography className="charge-price total-charge">
                                    ${invoiceLineChargeTotal.toFixed(2)}
                                  </Typography>
                                  <Typography className="charge-text">
                                    total charges
                                  </Typography>
                                </Box>
                              </Popover>
                              <Typography className="state-values">
                                $
                                {invoiceLineChargeTotal.toFixed(2)}
                              </Typography>

                              {/* <Typography
                                sx={{ position: "relative" }}
                                className="state-titles"
                              >
                                Charges: 
                                <span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    aria-owns={
                                      open1 ? "mouse-over-popover" : undefined
                                    }
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpen1}
                                    onMouseLeave={handlePopoverClose1}
                                    className="material-symbols-outlined"
                                  >
                                    help
                                  </span>
                                </span>
                              </Typography>
                              <Popover
                                className="charges-box"
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                }}
                                open={open1}
                                anchorEl={anchorEl}
                                // anchorReference="anchorPosition"
                                // anchorPosition={{ top: 420, left: 800 }}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "center",
                                  horizontal: "center",
                                }}
                                onClose={handlePopoverClose1}
                                disableRestoreFocus
                              >
                                <Typography className="charges-title">
                                  Charges
                                </Typography>
                                <Box>
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      {values && values.totalHours}
                                    </Typography>
                                    <Typography className="charge-text">
                                      hours
                                    </Typography>
                                  </Box>
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      /8
                                    </Typography>
                                    <Typography className="charge-text">
                                      hour work day
                                    </Typography>
                                  </Box>
                                  <Divider
                                    sx={{
                                      borderColor: "#F2F4F8",
                                      margin: "5px 0px",
                                    }}
                                  />
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      {values &&
                                        parseFloat(
                                          values.totalHours / 8
                                        ).toFixed(2)}
                                    </Typography>
                                    <Typography className="charge-text">
                                      Billable days
                                    </Typography>
                                  </Box>
                                  <Box className="time-flexbox">
                                    <Typography className="charge-price">
                                      x ${values && values.dayRate}
                                    </Typography>
                                    <Typography className="charge-text">
                                      day rate
                                    </Typography>
                                  </Box>
                                  <Box className="time-flexbox time-btn">
                                    <Typography className="charge-price total-charge">
                                      {parseFloat(
                                        (values.totalHours / 8) * values.dayRate
                                      ).toFixed(2)}
                                    </Typography>
                                    <Typography className="charge-text">
                                      total charge
                                    </Typography>
                                  </Box>
                                </Box>
                              </Popover>
                              <Typography className="state-values">
                                {parseFloat(
                                  (values.totalHours / 8) * values.dayRate
                                ).toFixed(2)}
                              </Typography> */}
                            </Grid>
                          </Grid>
                          <Typography
                            className="project-bill-date"
                            sx={{ mt: "37px" }}
                          >
                            Project & Billing Dates:
                          </Typography>
                          <Typography className="project-bill-text">
                            {values && values.projectName}:{" "}
                            {values && values.startDate} -{" "}
                            {values && values.endDate}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Typography>
                </Box>
                <Box className="bill-form-box">
                  <Stack
                    className="bill-form-title"
                    direction={{ xs: "column", sm: "row" }}
                    spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                    justifyContent="space-between"
                    sx={{
                      alignItems: {
                        xs: "flex-start",
                        md: "center",
                      },
                      padding: "11px 19px",
                      background: "#EEF6ED",
                    }}
                  >
                    <Typography className="billing-boxdate-title">
                      {/* {moment(new Date()).format('MM/DD/YYYY')} */}
                      {/* {calculateDate(index)} */}
                      Billing Period: {values && values.startDate} -{" "}
                      {values && values.endDate}
                    </Typography>

                    <Typography className="billing-boxdate-title">
                      {/* {moment(new Date()).format('MM/DD/YYYY')} */}
                      {/* {calculateDate(index)} */}
                      Project Name: {values && values.projectName}
                    </Typography>
                  </Stack>
                  <Box
                    className="bill-formbox-inside"
                    // ref={gridRefDay}
                    // onBlur={handleDayRateFocusOut}
                  >
                    <Box sx={{ display: "none" }}>
                      <Typography className="label" sx={{ mb: 0.75 }}>
                        Select Day Rate
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: { xs: "wrap", md: "nowrap" },
                          width: "fit-content",
                          maxWidth: "100%",
                          borderRadius: "4px",
                          overflow: "hidden",
                        }}
                      >
                        {DAY_RATE_OPTIONS.map((option) => (
                          <Button
                            key={option}
                            type="button"
                            onClick={() => handleDayRateSelection(option)}
                            disabled={invoiceStatus}
                            sx={{
                              minHeight: 38,
                              border: "1px solid #d7dce2",
                              borderRadius: 0,
                              color:
                                selectedDayRate === option ? "#4cae47" : "#202124",
                              backgroundColor:
                                selectedDayRate === option ? "#eef8eb" : "#fff",
                              fontWeight: selectedDayRate === option ? 600 : 400,
                              flex: { md: "1 1 0" },
                              minWidth: 0,
                              whiteSpace: "nowrap",
                              fontSize: { xs: 12, md: 13 },
                              px: { xs: 1, md: 0.75 },
                              "&:hover": {
                                backgroundColor: "#eef8eb",
                              },
                            }}
                          >
                            {option}
                          </Button>
                        ))}
                      </Box>
                    </Box>
                    <Box
  sx={{
    display: "flex",
    gap: { xs: 2, md: 4 },
    width: "100%",
    flexWrap: { xs: "wrap", md: "nowrap" },
  }}
>
  {/* LEFT SIDE - Select Day Rate + Rates */}
  <Box
  sx={{
    flex: { xs: "0 0 100%", md: "0 0 calc(70% - 8px)" },
    maxWidth: { xs: "100%", md: "calc(70% - 8px)" },
  }}
>
    {/* Select Day Rate */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <p className="label" style={{ marginBottom: 0 }}>Select Day Rate</p>
      <Tooltip
        title="Invoice-level configuration: Select a day-rate type and save your changes to apply the selected rate to existing line items and newly created line items on this invoice."
        arrow
        placement="top"
      >
        <IconButton
          size="small"
          aria-label="Select day rate information"
          sx={{ p: 0.25 }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
            help
          </span>
        </IconButton>
      </Tooltip>
    </Box>

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          sm: "repeat(4, minmax(0, 1fr))",
        },
        maxWidth: "100%",
        borderRadius: "4px",
        overflow: "hidden",
      }}
    >
      {DAY_RATE_OPTIONS.map((option) => (
        <Button
          key={option}
          type="button"
          onClick={() => handleDayRateSelection(option)}
          disabled={invoiceStatus}
          sx={{
            minHeight: 38,
            border: "1px solid #d7dce2",
            borderRadius: 0,
            color:
              selectedDayRate === option ? "#4cae47" : "#202124",
            backgroundColor:
              selectedDayRate === option ? "#eef8eb" : "#fff",
            fontWeight:
              selectedDayRate === option ? 600 : 400,
            minWidth: 0,
            width: "100%",
            boxSizing: "border-box",
            whiteSpace: "normal",
            overflowWrap: "break-word",
            lineHeight: 1.2,
            textAlign: "center",
            fontSize: { xs: 12, md: 13 },
            px: 1,
            "&:hover": {
              backgroundColor: "#eef8eb",
            },
          }}
        >
          {option}
        </Button>
      ))}
    </Box>

    {/* Day Rate + Mileage Rate */}
    <Box
      sx={{
        mt: 2,
        width: "100%",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
        columnGap: { xs: 0, md: 4 },
        rowGap: 2,
      }}
    >
      {/* Day Rate */}
      <Box sx={{ minWidth: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            gap: 1,
          }}
        >
          <FormControl variant="standard" sx={{ flex: 1 }}>
            <p className="label">Day Rate</p>

            <Input
              className="default-btn dollar-field"
              sx={{
                "&.MuiInputBase-root": {
                  border:
                    !loading && !isProjectCardDayRateSynced()
                      ? "1px solid yellow"
                      : "",
                },
                "&:hover:not(.Mui-disabled):before": {
                  borderBottom:
                    !loading && !isProjectCardDayRateSynced()
                      ? "1px solid yellow"
                      : "",
                },
                "&.Mui-focused:after": {
                  borderBottom:
                    !loading && !isProjectCardDayRateSynced()
                      ? "1px solid yellow"
                      : "",
                },
              }}
              disabled={invoiceStatus}
              name="dayRate"
              id="dayRate"
              type="dayRate"
              onChange={(e) => {
                handleChangeDayRate(e, "dayRate");
              }}
              value={values.dayRate}
              startAdornment={
                <InputAdornment position="start">
                  <span className="dollar-icon">$</span>
                </InputAdornment>
              }
            />
          </FormControl>

          <Button
            sx={{ minWidth: 60, mb: "2px" }}
            className={
              isProjectCardDayRateSynced()
                ? "disable-filter-btn"
                : "primary-btn"
            }
            onClick={dayRateSave}
            disabled={
              invoiceStatus ||
              isProjectCardDayRateSynced()
            }
          >
            Save
          </Button>
        </Box>
      </Box>

      {/* Mileage Rate */}
      <Box sx={{ minWidth: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            gap: 1,
          }}
        >
          <FormControl variant="standard" sx={{ flex: 1 }}>
            <p className="label">Mileage Rate</p>

            <Input
              className="default-btn dollar-field"
              sx={{
                "&.MuiInputBase-root": {
                  border:
                    !loading && savedMilRate != values.mileageRate
                      ? "1px solid yellow"
                      : "",
                },
                "&:hover:not(.Mui-disabled):before": {
                  borderBottom:
                    !loading && savedMilRate != values.mileageRate
                      ? "1px solid yellow"
                      : "",
                },
                "&.Mui-focused:after": {
                  borderBottom:
                    !loading && savedMilRate != values.mileageRate
                      ? "1px solid yellow"
                      : "",
                },
              }}
              name="mileageRate"
              id="mileageRate"
              disabled={invoiceStatus}
              onChange={(e) => {
                handleChangeMileageRate(e, "mileageRate");
              }}
              type="mileageRate"
              value={values.mileageRate}
              startAdornment={
                <InputAdornment position="start">
                  <span className="dollar-icon">$</span>
                </InputAdornment>
              }
            />
          </FormControl>

          <Button
            sx={{ minWidth: 60, mb: "2px" }}
            className={
              savedMilRate == values.mileageRate
                ? "disable-filter-btn"
                : "primary-btn"
            }
            onClick={() => {
              mileageRateSave();
            }}
            disabled={
              invoiceStatus ||
              savedMilRate == values.mileageRate
            }
          >
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  </Box>

  {/* RIGHT SIDE - Summary */}
  <Box
  sx={{
    flex: { xs: "0 0 100%", md: "0 0 calc(30% - 8px)" },
    maxWidth: { xs: "100%", md: "calc(30% - 8px)" },
  }}
>
    <Grid container>
      {/* Per Diem / Mileage */}
      <Grid xs={6}>
        <Typography className="state-titles">
          Per Diem:
        </Typography>

        <Typography className="state-values">
          $
          {values.totalPerDiem
            ? parseFloat(values.totalPerDiem).toFixed(2)
            : "0.00"}
        </Typography>

        <Typography
          sx={{ position: "relative" }}
          className="state-titles"
        >
          Mileage:
          <span>
            <span
              style={{
                position: "absolute",
                fontSize: "15px",
                cursor: "pointer",
              }}
              aria-owns={
                open ? "mouse-over-popover" : undefined
              }
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen2}
              onMouseLeave={handlePopoverClose2}
              className="material-symbols-outlined"
            >
              help
            </span>
          </span>
        </Typography>

        <Typography className="state-values">
          $
          {(values &&
            values.totalMiles * savedMilRate
          ).toFixed(3) || 0.000}
        </Typography>

        <Typography className="state-titles">
          Total:
        </Typography>

        <Typography className="state-values">
          $
          {overAllInvoiceTotal
            ? overAllInvoiceTotal.toFixed(2)
            : "0.00"}
        </Typography>
      </Grid>

      {/* Expenses / Charges */}
      <Grid xs={6}>
        <Typography className="state-titles">
          Expenses:
          <span>
            <span
              style={{
                position: "absolute",
                fontSize: "15px",
                cursor: "pointer",
              }}
              aria-owns={
                open ? "mouse-over-popover" : undefined
              }
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
              className="material-symbols-outlined"
            >
              help
            </span>
          </span>
        </Typography>

        <Typography className="state-values">
          $
          {(values &&
            (
              parseFloat(values.totalLodging || 0) +
              parseFloat(values.totalCopies || 0) +
              parseFloat(values.totalMisc || 0)
            ).toFixed(2)) ||
            "0.00"}
        </Typography>

        <Typography
          sx={{ position: "relative" }}
          className="state-titles"
        >
          Charges:
          <span>
            <span
              style={{
                position: "absolute",
                fontSize: "15px",
                cursor: "pointer",
              }}
              aria-owns={
                open3 ? "mouse-over-popover" : undefined
              }
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen3}
              onMouseLeave={handlePopoverClose3}
              className="material-symbols-outlined"
            >
              help
            </span>
          </span>
        </Typography>

        <Typography className="state-values">
          $
          {invoiceLineChargeTotal.toFixed(2)}
        </Typography>
      </Grid>
    </Grid>
  </Box>
</Box>
                  </Box>

                </Box>
                {/* {formik1.values &&
                  Object.keys(formik1.values)
                    .filter((key) => key.startsWith("lineItem"))
                    .map((key) =>
                      formik1.values[key].map((item, index) => ( */}
                <Box className="bill-form-box">
                  {/* {console.log("key", key)} */}
                  <Stack
                    className="bill-form-title"
                    direction={{ xs: "column", sm: "row" }}
                    spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                    justifyContent="space-between"
                    sx={{
                      alignItems: {
                        xs: "flex-start",
                        md: "center",
                      },
                    }}
                  >
                    <Typography className="billing-boxdate-title">
                      Add new line item
                    </Typography>

                    <Stack
                      className="icon-btn-box"
                      direction="row"
                      spacing={1}
                      alignItems="center"
                    >
                      <Tooltip title="Save" arrow placement="top">
                        <IconButton
                          // disabled={billingStatus}
                          className="save-icon-btn"
                          aria-label="fingerprint"
                          color="secondary"
                          // onClick={formik1.handleSubmit}
                          onClick={() => {
                            formik1.handleSubmit();
                            if (
                              calculatePerDiem(
                                formik1?.values?.hours,
                                formik1?.values?.perDiemRate
                              ) !==
                              parseFloat(formik1?.values?.perDiem).toFixed(2)
                            ) {
                              // Do something here, e.g. update state, show a warning, etc.
                              upsertPerDiemLog(formik1?.values);
                            }
                          }}
                          disabled={invoiceStatus || saveButtonLoading}
                        >
                          <span className="material-symbols-outlined">
                            save
                          </span>
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Stack>

                  <Box className="bill-formbox-inside">
                    <Stack
                      className="line-item-fields"
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 1, md: 1 }}
                      justifyContent="flex-start"
                      sx={{
                        alignItems: {
                          xs: "flex-start",
                          md: "baseline",
                        },
                        width: "100%",
                        maxWidth: "none",
                        flexWrap: { xs: "wrap", sm: "nowrap" },
                      }}
                    >
                      <FormControl
                        className="select-broker-field"
                        sx={{ flex: "1 1 0", minWidth: 0, width: "100%" }}
                        variant="outlined"
                        error={
                          formik1.errors.brokerId && formik1.touched.brokerId
                        } // Setting error state for FormControl
                      >
                        <p className="label">Select Broker:</p>
                        <Select
                          // sx={{ minWidth: "225px" }}
                          sx={{
                            minWidth: 0,
                            width: "100%",
                            "& .MuiOutlinedInput-notchedOutline": {
                              border:
                                warningHighlightColor &&
                                formik1?.values.brokerId &&
                                formik1?.values.brokerId != ""
                                  ? "yellow"
                                  : "",
                              borderWidth:
                                warningHighlightColor &&
                                formik1?.values.brokerId &&
                                formik1?.values.brokerId != ""
                                  ? "1px"
                                  : "",
                              outline:
                                warningHighlightColor &&
                                formik1?.values.brokerId &&
                                formik1?.values.brokerId != ""
                                  ? "1px solid yellow"
                                  : "",
                            },
                            "& .MuiSelect-select": {
                              color:
                                formik1?.values.brokerId === "" ||
                                formik1?.values.brokerId
                                  ? "#212121"
                                  : "#898989",
                            },
                          }}
                          name="brokerId"
                          // defaultValue={selectedPeriodList[0]?.BrokerID}
                          value={formik1.values.brokerId || ""}
                          onChange={formik1.handleChange}
                          onBlur={formik1.handleBlur} // Ensure onBlur is handled to update touched state
                          disabled={invoiceStatus}
                          IconComponent={KeyboardArrowDownIcon}
                          displayEmpty // This prop is important for displaying the placeholde
                        >
                          <MenuItem value="" disabled>
                            Select Broker
                          </MenuItem>
                          {brokerNamePerProject?.map((item) => (
                            <MenuItem key={item.UserID} value={item.UserID}>
                              <span
                                style={{
                                  maxWidth: "250px",
                                  whiteSpace: "break-spaces",
                                }}
                                className="select-option-text"
                              >
                                {item.FirstName} {item.LastName}
                              </span>
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText error={true}>
                          {formik1.errors.brokerId && formik1.touched.brokerId
                            ? formik1.errors.brokerId
                            : ""}
                        </FormHelperText>
                      </FormControl>

                      <Box sx={{ flex: "1 1 0", minWidth: 0, width: "100%" }}>
                        <p className="label">Date:</p>
                        <LocalizationProvider
                          sx={{
                            width: "100%",
                            overflow: "hidden",
                            mt: "0px",
                          }}
                          dateAdapter={AdapterDayjs}
                        >
                          <DatePicker
                            sx={{ width: "100%", minWidth: 0 }}
                            className={
                              formik1.errors.date &&
                              formik1.touched.date === true
                                ? "error-datefield"
                                : ""
                            }
                            defaultValue={
                              selectedPeriodList?.length > 0 &&
                              selectedPeriodList[0]?.BillingStart
                                ? dayjs.utc(selectedPeriodList[0]?.BillingStart)
                                : dayjs.utc(
                                    billingStatementHeading?.InvoiceBillingStart
                                  )
                            }
                            disabled={invoiceStatus} // Use invoiceStatus if necessary
                            views={["year", "month", "day"]}
                            name="date"
                            onChange={(date) => lineDateChange(date, formik1)} // Use modified handler
                            value={
                              formik1.values.date
                                ? dayjs.utc(formik1.values.date, "MM/DD/YYYY")
                                : selectedPeriodList?.length > 0 &&
                                  selectedPeriodList[0]?.BillingStart
                                ? dayjs.utc(selectedPeriodList[0]?.BillingStart)
                                : dayjs.utc(
                                    billingStatementHeading?.InvoiceBillingStart
                                  )
                            }
                            shouldDisableDate={(date) => {
                              const billingStart =
                                selectedPeriodList?.length > 0 &&
                                selectedPeriodList[0]?.BillingStart
                                  ? dayjs.utc(
                                      selectedPeriodList[0]?.BillingStart
                                    )
                                  : dayjs.utc(
                                      billingStatementHeading?.InvoiceBillingStart
                                    );

                              const billingEnd =
                                selectedPeriodList?.length > 0 &&
                                selectedPeriodList[0]?.BillingEnd
                                  ? dayjs.utc(selectedPeriodList[0]?.BillingEnd)
                                  : dayjs.utc(
                                      billingStatementHeading?.InvoiceBillingEnd
                                    );

                              // Disable if date is before billing start or after billing end
                              return (
                                date.isBefore(billingStart, "day") ||
                                date.isAfter(billingEnd, "day")
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={
                                  formik1.errors.date &&
                                  formik1.touched.date === true
                                }
                                helperText={
                                  formik1.errors.date &&
                                  formik1.touched.date === true
                                    ? formik1.errors.date
                                    : ""
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                        <FormHelperText error={true}>
                          {formik1.errors.date && formik1.touched.date == true
                            ? formik1.errors.date
                            : ""}
                        </FormHelperText>
                      </Box>
                      <FormControl className="billing-type-input" variant="outlined" sx={{ flex: "1 1 0", minWidth: 0, width: "100%" }}>
                        <p className="label">Select Day Rate:</p>
                        <Select
                          name="selectedDayRate"
                          value={formik1.values.selectedDayRate || "Billable Rate"}
                          onChange={handleNewLineRateChange}
                          disabled={invoiceStatus}
                          className="billing-type-input"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {getLineRateOptions().map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Stack>
                    <Stack
                      className="billing-type-box"
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                      justifyContent="space-between"
                      sx={{
                        alignItems: {
                          xs: "flex-start",
                          md: "flex-start",
                        },
                        mt: 1.5,
                        display: {
                          xs: "unset",
                          sm: "grid",
                          md: "grid",
                          lg: "flex",
                        },
                        gridTemplateColumns: {
                          xs: "unset",
                          sm: "repeat(3, 1fr)",
                          md: "repeat(3, 1fr)",
                          lg: "unset",
                        },
                        rowGap: "10px !important",
                      }}
                    >
                      <FormControl
                        className="billing-type-input"
                        sx={{ minWidth: "152px" }}
                      >
                        <p className="label">Billing Type</p>

                        <Select
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              border:
                                warningHighlightColor &&
                                formik1?.values.billingType &&
                                formik1?.values.billingType != ""
                                  ? "yellow"
                                  : "",
                              borderWidth:
                                warningHighlightColor &&
                                formik1?.values.billingType &&
                                formik1?.values.billingType != ""
                                  ? "1px"
                                  : "",
                              outline:
                                warningHighlightColor &&
                                formik1?.values.billingType &&
                                formik1?.values.billingType != ""
                                  ? "1px solid yellow"
                                  : "",
                            },
                            "& .MuiSelect-select": {
                              color:
                                formik1?.values.billingType === "" ||
                                formik1?.values.billingType
                                  ? "#212121"
                                  : "#898989",
                            },
                          }}
                          // disabled={billingStatus}
                          // defaultValue=""
                          disabled={invoiceStatus}
                          name="billingType"
                          onChange={formik1.handleChange}
                          value={
                            formik1.values.billingType
                              ? formik1.values.billingType
                              : ""
                          }
                          error={
                            formik1.errors.billingType &&
                            formik1.touched.billingType
                          }
                          helperText={
                            formik1.errors.billingType &&
                            formik1.touched.billingType
                              ? formik1.errors.billingType
                              : ""
                          }
                          displayEmpty // This prop is important for displaying the placeholde
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value="" disabled>
                            Select Type
                          </MenuItem>
                          {billTypeList.map((rec) => {
                            return (
                              <MenuItem key={rec.id} value={rec.id}>
                                {rec.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {formik1.errors.billingType &&
                          formik1.touched.billingType && (
                            <FormHelperText error={true}>
                              {formik1.errors.billingType}
                            </FormHelperText>
                          )}
                      </FormControl>
                      <FormControl variant="standard">
                        <p className="label">Day Rate</p>
                        <Input
                          className="default-btn dollar-field"
                          disabled
                          name="dayRate"
                          id="dayRate"
                          type="dayRate"
                          onChange={(e) => {
                            handleChangeDayRate(e, "dayRate");
                          }}
                          // value={values.dayRate}
                          // New line items always display the invoice billable
                          // day rate; selected optional rates are separate
                          // fields and must not replace this value.
                          value={formatPopulatedDayRate(
                            getDayRateForSelection(
                              formik1.values.selectedDayRate,
                              {
                                ...projectRateOptions,
                                ...invoiceExistingRateSource,
                              },
                              invoiceExistingRateSource.InvoiceDayRate ?? 0,
                              true
                            )
                          )}
                          startAdornment={
                            <InputAdornment position="start">
                              <span className="dollar-icon">$</span>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                      <FormControl variant="standard">
                        <p className="label">Hours</p>
                        <Input
                          // disabled={billingStatus}
                          name="hours"
                          disabled={invoiceStatus}
                          // onChange={handleNumericCheck}
                          onChange={(e) => {
                            handleNumericCheck(e); // First handle the default formik change

                            const { name, value } = e.target;

                            // Then update PerDiem based on the updated value
                            const updatedValues = {
                              ...formik1.values,
                              [name]: value,
                            };

                            formik1.setValues({
                              ...updatedValues,
                              perDiem: calculatePerDiem(
                                updatedValues.hours,
                                updatedValues.perDiemRate
                              ),
                            });
                          }}
                          value={formik1.values.hours}
                          sx={{
                            // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                            borderColor:
                              warningHighlightColor &&
                              formik1?.values.hours &&
                              formik1?.values.hours != "0.00"
                                ? "yellow"
                                : "inherit",
                            borderWidth:
                              warningHighlightColor &&
                              formik1?.values.hours &&
                              formik1?.values.hours != "0.00"
                                ? "1px"
                                : "inherit",
                            outline:
                              warningHighlightColor &&
                              formik1?.values.hours &&
                              formik1?.values.hours != "0.00"
                                ? "1px solid yellow"
                                : "inherit",
                            border:
                              warningHighlightColor &&
                              formik1?.values.hours &&
                              formik1?.values.hours != "0.00"
                                ? "1px solid yellow"
                                : "inherit",
                          }}
                        />
                      </FormControl>
                      <FormControl
                        sx={{
                          marginLeft: {
                            xs: "auto !important",
                            sm: "0px !important",
                            md: "0px !important",
                            lg: "12px !important",
                          },
                        }}
                        variant="standard"
                      >
                        <p className="label">Miles</p>
                        <Input
                          name="miles"
                          disabled={invoiceStatus}
                          onChange={handleNumericCheck}
                          value={formik1.values.miles}
                          sx={{
                            // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                            borderColor:
                              warningHighlightColor &&
                              formik1?.values.miles &&
                              formik1?.values.miles != "0"
                                ? "yellow"
                                : "inherit",
                            borderWidth:
                              warningHighlightColor &&
                              formik1?.values.miles &&
                              formik1?.values.miles != "0"
                                ? "1px"
                                : "inherit",
                            outline:
                              warningHighlightColor &&
                              formik1?.values.miles &&
                              formik1?.values.miles != "0"
                                ? "1px solid yellow"
                                : "inherit",
                            border:
                              warningHighlightColor &&
                              formik1?.values.miles &&
                              formik1?.values.miles != "0"
                                ? "1px solid yellow"
                                : "inherit",
                          }}
                        />
                      </FormControl>
                      <FormControl variant="standard">
                        <p className="label">Lodging</p>
                        <Input
                          className="dollar-field"
                          name="lodging"
                          disabled={invoiceStatus}
                          onChange={handleNumericCheck}
                          value={formik1.values.lodging}
                          startAdornment={
                            <InputAdornment position="start">
                              <span className="dollar-icon">$</span>
                            </InputAdornment>
                          }
                          sx={{
                            // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                            borderColor:
                              warningHighlightColor &&
                              formik1?.values.lodging &&
                              formik1?.values.lodging != "0.00"
                                ? "yellow"
                                : "inherit",
                            borderWidth:
                              warningHighlightColor &&
                              formik1?.values.lodging &&
                              formik1?.values.lodging != "0.00"
                                ? "1px"
                                : "inherit",
                            outline:
                              warningHighlightColor &&
                              formik1?.values.lodging &&
                              formik1?.values.lodging != "0.00"
                                ? "1px solid yellow"
                                : "inherit",
                            border:
                              warningHighlightColor &&
                              formik1?.values.lodging &&
                              formik1?.values.lodging != "0.00"
                                ? "1px solid yellow"
                                : "inherit",
                          }}
                        />
                      </FormControl>
                      <FormControl variant="standard">
                        <p className="label">Copies</p>
                        <Input
                          className="dollar-field"
                          name="copies"
                          disabled={invoiceStatus}
                          onChange={handleNumericCheck}
                          value={formik1.values.copies}
                          startAdornment={
                            <InputAdornment position="start">
                              <span className="dollar-icon">$</span>
                            </InputAdornment>
                          }
                          sx={{
                            // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                            borderColor:
                              warningHighlightColor &&
                              formik1?.values.copies &&
                              formik1?.values.copies != "0.00"
                                ? "yellow"
                                : "inherit",
                            borderWidth:
                              warningHighlightColor &&
                              formik1?.values.copies &&
                              formik1?.values.copies != "0.00"
                                ? "1px"
                                : "inherit",
                            outline:
                              warningHighlightColor &&
                              formik1?.values.copies &&
                              formik1?.values.copies != "0.00"
                                ? "1px solid yellow"
                                : "inherit",
                            border:
                              warningHighlightColor &&
                              formik1?.values.copies &&
                              formik1?.values.copies != "0.00"
                                ? "1px solid yellow"
                                : "inherit",
                          }}
                        />
                      </FormControl>
                    </Stack>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                      justifyContent="space-between"
                      sx={{
                        alignItems: {
                          xs: "flex-start",
                          md: "flex-start",
                        },
                        display: {
                          xs: "unset",
                          sm: "grid",
                          md: "grid",
                          lg: "flex",
                        },
                        gridTemplateColumns: {
                          xs: "unset",
                          sm: "repeat(2, 1fr)",
                          md: "repeat(2, 1fr)",
                          lg: "unset",
                        },
                        rowGap: "10px !important",
                      }}
                    >
                      <FormControl
                        sx={{ minWidth: { xs: "100%", sm: "300px" } }}
                        variant="standard"
                      >
                        <p className="label">Description</p>
                        <textarea
                          style={{
                            resize: "vertical",
                            overflow: "auto",
                            outline:
                              warningHighlightColor &&
                              formik1?.values.description &&
                              formik1?.values.description != ""
                                ? "2px solid yellow"
                                : "",
                          }}
                          placeholder="Write Description"
                          className="upload-textarea"
                          id="description"
                          disabled={invoiceStatus}
                          // multiline
                          rows={4}
                          // defaultValue=""
                          name="description"
                          maxLength="1000"
                          onChange={formik1.handleChange}
                          value={formik1.values.description}
                        />
                      </FormControl>

                      <FormControl
                        sx={{ minWidth: "130px" }}
                        variant="standard"
                        disabled={invoiceStatus}
                      >
                        <p className="label">Per Diem Rate</p>

                        <Select
                          sx={{
                            p: "0px !important",
                            "& .MuiInputBase-root.MuiInput-root": {
                              // For the standard variant, use borderBottom to apply the border color
                              "&:before": {
                                borderBottom:
                                  warningHighlightColor &&
                                  formik1?.values.perDiemRate &&
                                  formik1?.values.perDiemRate != "0.00"
                                    ? "2px solid yellow"
                                    : "",
                              },
                              "&:hover:not(.Mui-disabled):before": {
                                borderBottom:
                                  warningHighlightColor &&
                                  formik1?.values.perDiemRate &&
                                  formik1?.values.perDiemRate != "0.00"
                                    ? "2px solid yellow"
                                    : "",
                              },
                              "&.Mui-focused:after": {
                                borderBottom:
                                  warningHighlightColor &&
                                  formik1?.values.perDiemRate &&
                                  formik1?.values.perDiemRate != "0.00"
                                    ? "2px solid yellow"
                                    : "",
                              },
                            },
                            "& .MuiSelect-select": {
                              color:
                                formik1?.values.perDiemRate === "" ||
                                formik1?.values.perDiemRate
                                  ? "#212121"
                                  : "#898989",
                            },
                          }}
                          className="dollar-field per-diem-rate-field"
                          // disabled={billingStatus}
                          defaultValue="0"
                          id="grouped-select"
                          name="perDiemRate"
                          IconComponent={KeyboardArrowDownIcon}
                          onChange={(e) => {
                            formik1.handleChange(e); // First handle the default formik change

                            const { name, value } = e.target;

                            // Then update PerDiem based on the updated value
                            const updatedValues = {
                              ...formik1.values,
                              [name]: value,
                            };

                            formik1.setValues({
                              ...updatedValues,
                              perDiem: calculatePerDiem(
                                updatedValues.hours,
                                updatedValues.perDiemRate
                              ),
                            });
                          }}
                          value={
                            formik1.values.perDiemRate &&
                            !isNaN(parseFloat(formik1.values.perDiemRate))
                              ? parseFloat(formik1.values.perDiemRate).toFixed(
                                  2
                                )
                              : parseFloat("0").toFixed(2)
                          }
                          startAdornment={
                            <InputAdornment position="start">
                              <span className="dollar-icon">$</span>
                            </InputAdornment>
                          }
                        >
                          <ListSubheader className="per-diem-header">
                            N/A
                          </ListSubheader>
                          <MenuItem value="0.00">0.00</MenuItem>

                          <ListSubheader className="per-diem-header">
                            Office Per Diem
                          </ListSubheader>
                          <MenuItem
                            value={
                              !isNaN(parseFloat(values?.BillableOfficePerDiem))
                                ? parseFloat(
                                    values?.BillableOfficePerDiem
                                  ).toFixed(2)
                                : "0.00"
                            }
                          >
                            {!isNaN(parseFloat(values?.BillableOfficePerDiem))
                              ? parseFloat(
                                  values?.BillableOfficePerDiem
                                ).toFixed(2)
                              : "0.00"}
                          </MenuItem>

                          <ListSubheader className="per-diem-header">
                            Travel Per Diem
                          </ListSubheader>
                          <MenuItem
                            value={
                              !isNaN(parseFloat(values?.BillableTravelPerDiem))
                                ? parseFloat(
                                    values?.BillableTravelPerDiem
                                  ).toFixed(2)
                                : "0.00"
                            }
                          >
                            {!isNaN(parseFloat(values?.BillableTravelPerDiem))
                              ? parseFloat(
                                  values?.BillableTravelPerDiem
                                ).toFixed(2)
                              : "0.00"}
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl
                        sx={{
                          marginLeft: {
                            xs: "auto !important",
                            sm: "0px !important",
                            md: "0px !important",
                            lg: "12px !important",
                          },
                        }}
                        variant="standard"
                      >
                        <p className="label">Per Diem</p>
                        <Input
                          className="dollar-field"
                          name="perDiem"
                          // disabled
                          onChange={(e) => {
                            const { value } = e.target;

                            // Allow empty input or numbers with up to 2 decimal places
                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                              formik1.handleChange(e);
                            }
                          }}
                          value={formik1.values.perDiem}
                          // value={calculatePerDiem(
                          //   formik1.values.hours,
                          //   formik1.values.perDiemRate
                          // )}
                          startAdornment={
                            <InputAdornment position="start">
                              <span className="dollar-icon">$</span>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                      <FormControl variant="standard">
                        <p className="label">Misc</p>
                        <Input
                          className="dollar-field"
                          name="misc"
                          disabled={invoiceStatus}
                          onChange={handleNumericCheck}
                          value={formik1.values.misc}
                          startAdornment={
                            <InputAdornment position="start">
                              <span className="dollar-icon">$</span>
                            </InputAdornment>
                          }
                          sx={{
                            // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                            borderColor:
                              warningHighlightColor &&
                              formik1?.values.misc &&
                              formik1?.values.misc != "0.00"
                                ? "yellow"
                                : "inherit",
                            borderWidth:
                              warningHighlightColor &&
                              formik1?.values.misc &&
                              formik1?.values.misc != "0.00"
                                ? "1px"
                                : "inherit",
                            outline:
                              warningHighlightColor &&
                              formik1?.values.misc &&
                              formik1?.values.misc != "0.00"
                                ? "1px solid yellow"
                                : "inherit",
                            border:
                              warningHighlightColor &&
                              formik1?.values.misc &&
                              formik1?.values.misc != "0.00"
                                ? "1px solid yellow"
                                : "inherit",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Box>
                </Box>
                {/* ))
                    )} */}
                {lineList &&
                  [...lineList]
                    .sort((a, b) => {
                      const dateA = new Date(a.Date);
                      const dateB = new Date(b.Date);
                      return dateA - dateB; // Ascending order by Date
                    }) // Sort by Date in ascending order
                    .map((key, index) => {
                      const {
                        Date,
                        BillingType,
                        Hours,
                        Miles,
                        Lodging,
                        Copies,
                        Misc,
                        PerDiem,
                        Description,
                        BillingHeaderID,
                        InvoiceDetailsID,
                        BrokerName,
                        PerDiemRate,
                        BillableDayRate,
                        BrokerID,
                        BillingDetailID,
                      } = key;
                      console.log(key, "keyeeeeeeeeeeeeee");
                      console.log(
                        PerDiem,
                        "PerDiemRatePerDiemRate",
                        calculatePerDiem(Hours, PerDiemRate)
                      );
                      console.log(
                        changedFields[InvoiceDetailsID] != InvoiceDetailsID,
                        "changedFields[InvoiceDetailsID] != InvoiceDetailsID",
                        changedFields,
                        InvoiceDetailsID
                      );
                      const lineDayRateValue = resolveExistingLineItemDayRate(
                        getPersistedSelectedDayRate(key),
                        { ...key, ...invoiceExistingRateSource },
                        projectRateOptions,
                        key?.DayRate ?? key?.BillableDayRate ?? 0
                      ).dayRate;
                      return (
                        <>
                          <Box className="bill-form-box">
                            {console.log("key", key)}
                            <Stack
                              className="bill-form-title"
                              direction={{ xs: "column", sm: "row" }}
                              spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                              justifyContent="space-between"
                              sx={{
                                alignItems: {
                                  xs: "flex-start",
                                  md: "center",
                                },
                              }}
                            >
                              <Typography className="billing-boxdate-title">
                                {/* {moment(new Date()).format('MM/DD/YYYY')} */}
                                {/* {calculateDate(index)} */}
                                {BrokerName} -{" "}
                                {moment.utc(Date).format("MM/DD/YYYY")}
                              </Typography>

                              <Stack
                                className="icon-btn-box"
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <Tooltip
                                  arrow
                                  className="project-tooltip"
                                  title="Remove this line"
                                  placement="top"
                                >
                                  <IconButton
                                    className="delete-icon-btn"
                                    aria-label="fingerprint"
                                    color="secondary"
                                    disabled={invoiceStatus}
                                    onClick={() => {
                                      setDeletedInvoiceLineItemPopup(true);
                                      setInvoiceDetailsValues(InvoiceDetailsID);
                                      setInvoiceDeleteKey(key);
                                      setInvoiceDeleteIndex(index);
                                      // Optionally call deleteLineItemFromAPI here if needed
                                      // deleteLineItemFromAPI(InvoiceDetailsID, key, index);
                                    }}
                                  >
                                    <span className="material-symbols-outlined">
                                      delete
                                    </span>
                                  </IconButton>
                                </Tooltip>
                                {/* {!(
                                changedFields.hasOwnProperty(
                                  InvoiceDetailsID
                                ) &&
                                Object.keys(changedFields[InvoiceDetailsID])
                                  .length > 0
                              ) ? (
                                <IconButton
                                  disabled
                                  className="disabled-save-icon-btn"
                                  aria-label="fingerprint"
                                  color="secondary"
                                  // onClick={() =>
                                  //   handleUpdateLineItem(InvoiceDetailsID)
                                  // }
                                >
                                  <span className="material-symbols-outlined">
                                    save
                                  </span>
                                </IconButton>
                              ) : ( */}
                                <Tooltip title="Save" arrow placement="top">
                                  <IconButton
                                    disabled={invoiceStatus || saveLoading}
                                    className="save-icon-btn"
                                    aria-label="fingerprint"
                                    color="secondary"
                                    onClick={() => {
                                      handleUpdateLineItem(InvoiceDetailsID);
                                      if (
                                        calculatePerDiem(Hours, PerDiemRate) !==
                                        parseFloat(PerDiem).toFixed(2)
                                      ) {
                                        // Do something here, e.g. update state, show a warning, etc.
                                        upsertPerDiemLog(key);
                                      }
                                    }}
                                  >
                                    <span className="material-symbols-outlined">
                                      save
                                    </span>
                                  </IconButton>
                                </Tooltip>
                                {/* )} */}
                              </Stack>
                            </Stack>

                            <Box className="bill-formbox-inside">
                              <FormControl className="billing-type-input" variant="outlined" sx={{ minWidth: "180px", mb: 1.5 }}>
                                <p className="label">Select Day Rate</p>
                                <Select
                                  value={normalizeSelectedDayRate(getPersistedSelectedDayRate(key))}
                                  onChange={(event) =>
                                    handleExistingLineRateChange(
                                      InvoiceDetailsID,
                                      event.target.value,
                                      BrokerID
                                    )
                                  }
                                  disabled={invoiceStatus}
                                  IconComponent={KeyboardArrowDownIcon}
                                >
                                  {getLineDayRateOptions(
                                    findLineBroker(BrokerID),
                                    key,
                                    getPersistedSelectedDayRate(key)
                                  ).map((option) => (
                                    <MenuItem key={option} value={option}>{option}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <Stack
                                className="billing-type-box"
                                direction={{ xs: "column", sm: "row" }}
                                spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                                justifyContent="space-between"
                                sx={{
                                  alignItems: {
                                    xs: "flex-start",
                                    md: "flex-start",
                                  },
                                  display: {
                                    xs: "unset",
                                    sm: "grid",
                                    md: "grid",
                                    lg: "flex",
                                  },
                                  gridTemplateColumns: {
                                    xs: "unset",
                                    sm: "repeat(3, 1fr)",
                                    md: "repeat(3, 1fr)",
                                    lg: "unset",
                                  },
                                  rowGap: "10px !important",
                                }}
                              >
                                <FormControl
                                  className="billing-type-input"
                                  sx={{ minWidth: "152px" }}
                                >
                                  <p className="label">Billing Type</p>

                                  <Select
                                    sx={{
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border:
                                          warningHighlightColor &&
                                          changedFields[InvoiceDetailsID]
                                            ?.BillingType
                                            ? "yellow"
                                            : "",
                                        borderWidth:
                                          warningHighlightColor &&
                                          changedFields[InvoiceDetailsID]
                                            ?.BillingType
                                            ? "1px"
                                            : "",
                                        outline:
                                          warningHighlightColor &&
                                          changedFields[InvoiceDetailsID]
                                            ?.BillingType
                                            ? "1px solid yellow"
                                            : "",
                                      },
                                      "& .MuiSelect-select": {
                                        color:
                                          BillingType === "" || BillingType
                                            ? "#212121"
                                            : "#898989",
                                      },
                                    }}
                                    name="BillingType"
                                    onChange={(e) => {
                                      listOnChange(e, InvoiceDetailsID);
                                    }}
                                    value={BillingType ? BillingType : ""}
                                    disabled={invoiceStatus}
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    {billTypeList.map((rec) => {
                                      return (
                                        <MenuItem value={rec.id}>
                                          {rec.name}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>

                                <FormControl variant="standard">
                                  <p className="label">Day Rate</p>
                                  <Input
                                    className="default-btn dollar-field"
                                    disabled
                                    name="dayRate"
                                    id="dayRate"
                                    type="dayRate"
                                    onChange={(e) => {
                                      handleChangeDayRate(e, "dayRate");
                                    }}
                                    // value={dayRate}
                                    value={formatPopulatedDayRate(lineDayRateValue ?? 0)}
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <span className="dollar-icon">$</span>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>

                                <FormControl variant="standard">
                                  <p className="label">Hours</p>
                                  <Input
                                    disabled={invoiceStatus}
                                    name="Hours"
                                    onChange={(e) => {
                                      listOnChange(e, InvoiceDetailsID);
                                    }}
                                    value={Hours}
                                    sx={{
                                      // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                      borderColor:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Hours == true
                                          ? "yellow"
                                          : "inherit",
                                      borderWidth:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Hours == true
                                          ? "1px"
                                          : "inherit",
                                      outline:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Hours == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                      border:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Hours == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                    }}
                                  />
                                </FormControl>
                                <FormControl
                                  sx={{
                                    marginLeft: {
                                      xs: "auto !important",
                                      sm: "0px !important",
                                      md: "0px !important",
                                      lg: "12px !important",
                                    },
                                  }}
                                  variant="standard"
                                >
                                  <p className="label">Miles</p>
                                  <Input
                                    disabled={invoiceStatus}
                                    name="Miles"
                                    onChange={(e) => {
                                      const { name, value } = e.target;
                                      const numericValue = parseInt(value);
                                      const floatRegex = /^\d{1,5}$/;
                                      if (
                                        !isNaN(value) &&
                                        (value === "" ||
                                          floatRegex.test(value)) &&
                                        (numericValue <= 10000 || value === "")
                                      ) {
                                        listOnChange(e, InvoiceDetailsID);
                                      }
                                    }}
                                    value={Miles}
                                    sx={{
                                      // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                      borderColor:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Miles == true
                                          ? "yellow"
                                          : "inherit",
                                      borderWidth:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Miles == true
                                          ? "1px"
                                          : "inherit",
                                      outline:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Miles == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                      border:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Miles == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                    }}
                                  />
                                </FormControl>
                                <FormControl variant="standard">
                                  <p className="label">Lodging</p>
                                  <Input
                                    className="dollar-field"
                                    name="Lodging"
                                    disabled={invoiceStatus}
                                    onChange={(e) => {
                                      listOnChange(e, InvoiceDetailsID);
                                    }}
                                    value={Lodging}
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <span className="dollar-icon">$</span>
                                      </InputAdornment>
                                    }
                                    sx={{
                                      // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                      borderColor:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Lodging == true
                                          ? "yellow"
                                          : "inherit",
                                      borderWidth:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Lodging == true
                                          ? "1px"
                                          : "inherit",
                                      outline:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Lodging == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                      border:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Lodging == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                    }}
                                  />
                                </FormControl>
                                <FormControl variant="standard">
                                  <p className="label">Copies</p>
                                  <Input
                                    className="dollar-field"
                                    name="Copies"
                                    disabled={invoiceStatus}
                                    onChange={(e) => {
                                      listOnChange(e, InvoiceDetailsID);
                                    }}
                                    value={Copies}
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <span className="dollar-icon">$</span>
                                      </InputAdornment>
                                    }
                                    sx={{
                                      // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                      borderColor:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Copies == true
                                          ? "yellow"
                                          : "inherit",
                                      borderWidth:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Copies == true
                                          ? "1px"
                                          : "inherit",
                                      outline:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Copies == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                      border:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Copies == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                    }}
                                  />
                                </FormControl>
                              </Stack>
                              <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={{ xs: 1, sm: 1.5, md: 1.5 }}
                                justifyContent="space-between"
                                sx={{
                                  alignItems: {
                                    xs: "flex-start",
                                    md: "flex-start",
                                  },
                                  display: {
                                    xs: "unset",
                                    sm: "grid",
                                    md: "grid",
                                    lg: "flex",
                                  },
                                  gridTemplateColumns: {
                                    xs: "unset",
                                    sm: "repeat(2, 1fr)",
                                    md: "repeat(2, 1fr)",
                                    lg: "unset",
                                  },
                                  rowGap: "10px !important",
                                }}
                              >
                                <FormControl
                                  sx={{ minWidth: { xs: "100%", sm: "300px" } }}
                                  variant="standard"
                                >
                                  <p className="label">Description</p>
                                  <textarea
                                    style={{
                                      resize: "vertical",
                                      overflow: "auto",
                                      outline:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.Description
                                          ? "2px solid yellow"
                                          : "",
                                    }}
                                    placeholder="Write Description"
                                    className="upload-textarea"
                                    disabled={invoiceStatus}
                                    id="outlined-multiline-static"
                                    // multiline
                                    rows={4}
                                    // defaultValue=""
                                    name="Description"
                                    maxLength="1000"
                                    onChange={(e) => {
                                      listOnChange(e, InvoiceDetailsID);
                                    }}
                                    value={Description}
                                  />
                                </FormControl>

                                {invoiceStatus ? (
                                  <FormControl
                                    sx={{ minWidth: "130px" }}
                                    variant="standard"
                                    disabled={invoiceStatus}
                                  >
                                    <p className="label">Per Diem Rate</p>
                                    <Input
                                      className="dollar-field"
                                      disabled={invoiceStatus}
                                      id="grouped-select"
                                      name="PerDiemRate"
                                      onChange={(e) =>
                                        handleChangeCustomFloatNumber(
                                          e,
                                          key,
                                          index
                                        )
                                      }
                                      value={
                                        !isNaN(parseFloat(PerDiemRate))
                                          ? parseFloat(PerDiemRate).toFixed(2)
                                          : !isNaN(parseFloat(key?.PerDiemRate))
                                          ? parseFloat(
                                              key?.PerDiemRate
                                            ).toFixed(2)
                                          : "0.00"
                                      }
                                      startAdornment={
                                        <InputAdornment position="start">
                                          <span className="dollar-icon">$</span>
                                        </InputAdornment>
                                      }
                                    />
                                  </FormControl>
                                ) : (
                                  <FormControl
                                    sx={{ minWidth: "130px" }}
                                    variant="standard"
                                    disabled={invoiceStatus}
                                  >
                                    <p className="label">Per Diem Rate</p>

                                    <Select
                                      className="dollar-field per-diem-rate-field"
                                      sx={{
                                        p: "0px !important",
                                        "& .MuiInputBase-root.MuiInput-root": {
                                          // For the standard variant, use borderBottom to apply the border color
                                          "&:before": {
                                            borderBottom:
                                              warningHighlightColor &&
                                              changedFields[InvoiceDetailsID]
                                                ?.PerDiemRate
                                                ? "2px solid yellow"
                                                : "",
                                          },
                                          "&:hover:not(.Mui-disabled):before": {
                                            borderBottom:
                                              warningHighlightColor &&
                                              changedFields[InvoiceDetailsID]
                                                ?.PerDiemRate
                                                ? "2px solid yellow"
                                                : "",
                                          },
                                          "&.Mui-focused:after": {
                                            borderBottom:
                                              warningHighlightColor &&
                                              changedFields[InvoiceDetailsID]
                                                ?.PerDiemRate
                                                ? "2px solid yellow"
                                                : "",
                                          },
                                        },
                                        "& .MuiSelect-select": {
                                          color:
                                            PerDiemRate === "" || PerDiemRate
                                              ? "#212121"
                                              : "#898989",
                                        },
                                      }}
                                      // disabled={billingStatus}
                                      defaultValue={
                                        PerDiemRate
                                          ? PerDiemRate
                                          : key?.PerDiemRate
                                          ? key?.PerDiemRate
                                          : "0"
                                      }
                                      id="grouped-select"
                                      name="PerDiemRate"
                                      IconComponent={KeyboardArrowDownIcon}
                                      onChange={(e) => {
                                        listOnChange(e, InvoiceDetailsID);
                                      }}
                                      value={
                                        !isNaN(parseFloat(PerDiemRate))
                                          ? parseFloat(PerDiemRate).toFixed(2)
                                          : !isNaN(parseFloat(key?.PerDiemRate))
                                          ? parseFloat(
                                              key?.PerDiemRate
                                            ).toFixed(2)
                                          : "0.00"
                                      }
                                      startAdornment={
                                        <InputAdornment position="start">
                                          <span className="dollar-icon">$</span>
                                        </InputAdornment>
                                      }
                                    >
                                      {/* {PerDiemRate &&
                                        PerDiemRate.toString() !==
                                          BillableOfficePerDiem?.toString() &&
                                        PerDiemRate.toString() !==
                                          BillableTravelPerDiem?.toString() && (
                                          <MenuItem
                                            value={PerDiemRate.toString()}
                                            disabled
                                          >
                                            {PerDiemRate.toString()}
                                          </MenuItem>
                                        )} */}
                                      <ListSubheader className="per-diem-header">
                                        N/A
                                      </ListSubheader>
                                      <MenuItem value="0.00">0.00</MenuItem>
                                      <ListSubheader className="per-diem-header">
                                        Office Per Diem
                                      </ListSubheader>
                                      <MenuItem
                                        value={
                                          BillableOfficePerDiem &&
                                          !isNaN(BillableOfficePerDiem)
                                            ? BillableOfficePerDiem.toFixed(2)
                                            : "0.00"
                                        }
                                      >
                                        {BillableOfficePerDiem &&
                                        !isNaN(BillableOfficePerDiem)
                                          ? BillableOfficePerDiem.toFixed(2)
                                          : "0.00"}
                                      </MenuItem>

                                      <ListSubheader className="per-diem-header">
                                        Travel Per Diem
                                      </ListSubheader>

                                      <MenuItem
                                        value={
                                          BillableTravelPerDiem &&
                                          !isNaN(BillableTravelPerDiem)
                                            ? BillableTravelPerDiem.toFixed(2)
                                            : "0.00"
                                        }
                                      >
                                        {BillableTravelPerDiem &&
                                        !isNaN(BillableTravelPerDiem)
                                          ? BillableTravelPerDiem.toFixed(2)
                                          : "0.00"}
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                )}
                                <FormControl
                                  sx={{
                                    marginLeft: {
                                      xs: "auto !important",
                                      sm: "0px !important",
                                      md: "0px !important",
                                      lg: "12px !important",
                                    },
                                  }}
                                  variant="standard"
                                >
                                  <p className="label">Per Diem</p>
                                  <Input
                                    className="dollar-field"
                                    name="PerDiem"
                                    // disabled
                                    onChange={(e) => {
                                      listOnChange(e, InvoiceDetailsID);
                                    }}
                                    value={PerDiem}
                                    // value={
                                    //   calculatePerDiem(Hours, PerDiemRate) ==
                                    //   PerDiem
                                    //     ? PerDiem
                                    //     : calculatePerDiem(Hours, PerDiemRate)
                                    // }
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <span className="dollar-icon">$</span>
                                      </InputAdornment>
                                    }
                                    sx={{
                                      // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                      borderColor:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.PerDiem == true
                                          ? "yellow"
                                          : "inherit",
                                      borderWidth:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.PerDiem == true
                                          ? "1px"
                                          : "inherit",
                                      outline:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.PerDiem == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                      border:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]
                                          ?.PerDiem == true
                                          ? "1px solid yellow"
                                          : "inherit",
                                    }}
                                  />
                                  {/* {calculatePerDiem(Hours, PerDiemRate) !=
                                    parseFloat(PerDiem).toFixed(2) && (
                                    <FormHelperText>
                                      <span
                                        style={{
                                          color: "#FFCC00",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Manual value overrides calculated amount.
                                      </span>
                                    </FormHelperText>
                                  )} */}
                                </FormControl>
                                <FormControl variant="standard">
                                  <p className="label">Misc</p>
                                  <Input
                                    className="dollar-field"
                                    name="Misc"
                                    disabled={invoiceStatus}
                                    onChange={(e) => {
                                      listOnChange(e, InvoiceDetailsID);
                                    }}
                                    value={Misc}
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <span className="dollar-icon">$</span>
                                      </InputAdornment>
                                    }
                                    sx={{
                                      // Check if the entry for this InvoiceDetailsID exists before accessing Hours
                                      borderColor:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]?.Misc ==
                                          true
                                          ? "yellow"
                                          : "inherit",
                                      borderWidth:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]?.Misc ==
                                          true
                                          ? "1px"
                                          : "inherit",
                                      outline:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]?.Misc ==
                                          true
                                          ? "1px solid yellow"
                                          : "inherit",
                                      border:
                                        warningHighlightColor &&
                                        changedFields[InvoiceDetailsID]?.Misc ==
                                          true
                                          ? "1px solid yellow"
                                          : "inherit",
                                    }}
                                  />
                                </FormControl>
                              </Stack>
                              <Typography
                                sx={{
                                  margin: "10px 0px 0px",
                                  fontSize: "13px",
                                  color: "#007FFF",
                                  fontWeight: 400,
                                }}
                              >
                                {BillingHeaderID != 0
                                  ? "This line imported from billing statement."
                                  : "This line manually entered."}
                              </Typography>
                            </Box>
                          </Box>
                        </>
                      );
                    })}
              </Box>
            </Grid>
            <Grid xs={12} md={3}>
              <Box
                sx={{
                  p: "16px 17px",
                  ml: { xs: "0px", sm: "20px" },
                  mt: "22px",
                  position: { xs: "unset", sm: "sticky" },
                  top: "0px",
                  zIndex: 9,
                }}
                className="bg-box"
              >
                <Button
                  className="viewedit-btn"
                  variant="outlined"
                  // disabled={invoiceStatus}
                  // disabled={overAllInvoiceTotal == 0 || overAllInvoiceTotal == "0.00"}
                  startIcon={
                    <span className="material-symbols-outlined">edit</span>
                  }
                  onClick={() => {
                    handleAttachmentOpen(true);
                  }}
                  // disabled={billingStatementDetail.hprojectID ? false : true}
                >
                  View/edit attachments
                </Button>
                <Button
                  className={
                    lineList?.length == 0 &&
                    (overAllInvoiceTotal == 0 || overAllInvoiceTotal == "0.00")
                      ? "notopen-btn"
                      : "print-btn"
                  }
                  variant="outlined"
                  disabled={
                    lineList?.length == 0 &&
                    (overAllInvoiceTotal == 0 || overAllInvoiceTotal == "0.00")
                  }
                  startIcon={
                    <span className="material-symbols-outlined">print</span>
                  }
                  onClick={() => {
                    setOpenPrintInvoiceModel(true);
                    // window.open(`/print-invoice-form/${invoiceid}`, "_blank");
                  }}
                >
                  Print Invoice
                </Button>
                {invoiceStatus == false ? (
                  <Tooltip
                    title="Cannot reopen an invoiced billing statement."
                    arrow
                    placement="bottom"
                  >
                    <Button
                      className="close-btn"
                      variant="outlined"
                      onClick={handleInvoiceStatus}
                      disabled={invoiceStatus}
                      startIcon={
                        <span className="material-symbols-outlined">
                          description
                        </span>
                      }
                    >
                      Close Invoice
                    </Button>
                  </Tooltip>
                ) : (
                  <Tooltip
                    title="Cannot reopen an invoiced billing statement."
                    arrow
                    placement="bottom"
                  >
                    <Button
                      className="notopen-btn"
                      variant="outlined"
                      startIcon={
                        <span className="material-symbols-outlined">
                          receipt_long
                        </span>
                      }
                      disabled={reOpenLoading}
                      onClick={() => {
                        setReopenLoading(true);
                        showToast(
                          "This invoice is closed and cannot be reopened or edited",
                          "error"
                        );

                        showToast(
                          "This invoice has been closed and can no longer be edited.",
                          "reopenInvoice"
                        );
                        setTimeout(() => {
                          setReopenLoading(false);
                        }, 3000);
                      }}
                    >
                      Cannot Reopen
                    </Button>
                  </Tooltip>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {detachOpen && (
        <DetachConfirmation
          open={detachOpen}
          handleClose={handleClose}
          detachFunCall={detachFunCall}
          attachDettachLoading={attachDettachLoading}
        />
      )}
      {AtachOpen && (
        <AttachConfirmation
          open={AtachOpen}
          handleClose={handleCloseAttach}
          detachFunCall={detachFunCall}
          attachDettachLoading={attachDettachLoading}
        />
      )}

      {openAttachmentFilter && (
        <InvoiceAttachment
          open={openAttachmentFilter}
          handleClose={handleAttachmentClose}
          setOpenAttachmentFilter={setOpenAttachmentFilter}
          billingStatementDetail={selectedPeriodList}
          selectedNewPeriodList={selectedNewPeriodList}
          invoiceNumber={values.invoiceNo}
          getInvoiceDetails={getInvoiceDetails}
          activeStep={activeStep}
          values={values}
        />
      )}
      {saveDayRateValue && (
        <>
          <Dialog
            className="user-filter-popup project-filters"
            sx={{ width: "100%" }}
            fullScreen={fullScreen}
            open={saveDayRateValue}
            //onClose={""}
            aria-labelledby="responsive-dialog-title"
          >
            <Stack
              sx={{ p: "25px 25px", pb: "8px" }}
              direction="row"
              alignItems="center"
              spacing={2}
              justifyContent="space-between"
            >
              <Typography className="model-title">Save Confirmation</Typography>
            </Stack>
            <Box sx={{ p: "0px 25px 0px 25px" }}>
              <p style={{ marginBottom: "0px" }} className="label">
                Are you sure you want to update the day rate for this invoice?
              </p>
            </Box>
            <DialogActions
              sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "25px" }}
            >
              <Button className="filter-btn" onClick={handleSaveDayRateYes}>
                Yes
              </Button>
              <Button className="cancel-btn" onClick={handleSaveDayRateNo}>
                No
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
      {saveMileageRateValue && (
        <>
          <Dialog
            className="user-filter-popup project-filters"
            sx={{ width: "100%" }}
            fullScreen={fullScreen}
            open={saveMileageRateValue}
            //onClose={""}
            aria-labelledby="responsive-dialog-title"
          >
            <Stack
              sx={{ p: "25px 25px", pb: "8px" }}
              direction="row"
              alignItems="center"
              spacing={2}
              justifyContent="space-between"
            >
              <Typography className="model-title">Save Confirmation</Typography>
            </Stack>
            <Box sx={{ p: "0px 25px 0px 25px" }}>
              <p style={{ marginBottom: "0px" }} className="label">
                Are you sure you want to update the mileage rate for this
                invoice?
              </p>
            </Box>
            <DialogActions
              sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "25px" }}
            >
              <Button className="filter-btn" onClick={handleSaveMileageRateYes}>
                Yes
              </Button>
              <Button className="cancel-btn" onClick={handleSaveMileageRateNo}>
                No
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
      {showWarning && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          // fullScreen={fullScreen}
          open={showWarning}
          //  onClose={handleChangeno}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            <ErrorIcon
              fontSize="inherit"
              style={{ color: "#007FFF", fontSize: "24px" }}
            />
            <Typography className="model-title" sx={{ ml: "5px !important" }}>
              Warning: Unsaved Changes
            </Typography>
          </Stack>
          <Box sx={{ p: "0px 25px 0px 55px" }}>
            <p className="label">
              You have unsaved changes. Unsaved changes will be lost if you
              proceed. Are you sure you want to continue?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button className="filter-btn" onClick={() => handleYesClick()}>
              Proceed
            </Button>
            <Button className="cancel-btn" onClick={handleNoClick}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {deletedInvoicePopup && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          // fullScreen={fullScreen}
          open={deletedInvoicePopup}
          //  onClose={handleChangeno}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            <ErrorIcon
              fontSize="inherit"
              style={{ color: "#df0000", fontSize: "24px" }}
            />
            <Typography className="model-title" sx={{ ml: "5px !important" }}>
              Warning
            </Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 54px" }}>
            <p className="label">
              The invoice cannot be closed without any line items. Would you
              like to cancel this invoice?{" "}
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="delete-btn"
              onClick={() => handleDeleteInvoiceYesClick()}
            >
              Delete
            </Button>
            <Button className="cancel-btn" onClick={handleDeleteInvoiceNoClick}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {closingInvoice && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          // fullScreen={fullScreen}
          open={closingInvoice}
          //  onClose={handleChangeno}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            {/* <ErrorIcon
              fontSize="inherit"
              style={{ color: "#f95b5b", fontSize: "24px" }}
            /> */}
            <Typography className="model-title">Confirmation</Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 25px" }}>
            <p className="label">
              Are you sure you want to close this invoice?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="filter-btn"
              onClick={() => handleClosingInvoiceYesClick()}
            >
              Proceed
            </Button>
            <Button
              className="cancel-btn"
              onClick={handleClosingInvoiceNoClick}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {deletedInvoiceLineItemPopup && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          open={deletedInvoiceLineItemPopup}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            <Typography className="model-title">Confirmation</Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 25px" }}>
            <p className="label">
              Are you sure you want to delete this line item?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="delete-btn"
              onClick={() => handleManulyAddYesClick()}
            >
              Delete
            </Button>
            <Button className="cancel-btn" onClick={handleManuallyAddNoClick}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {invoicDatePopup && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          open={invoicDatePopup}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            <Typography className="model-title">Confirmation</Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 25px" }}>
            <p className="label">
              Are you sure you want to update the invoice date for this invoice?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="filter-btn"
              onClick={() => handleInvoiceDatePopupUpdate()}
            >
              Update
            </Button>
            <Button
              className="cancel-btn"
              onClick={handleInvoiceDatePopupClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openPrintInvoiceModel && (
        <PrintInvoiceModel
          open={openPrintInvoiceModel}
          setOpenPrintInvoiceModel={setOpenPrintInvoiceModel}
          billingStatementDetail={selectedPeriodList}
          invoiceNumber={values.invoiceNo}
          // handleClose = {}
        />
      )}
    </div>
  );
}
